// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/asset/images/Mask Group 29.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/asset/images/exclusive-tailor-our-clients-header.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-gallery-icon {
  color: #fff;
  transition: all 0.3s ease-out;
  appearance: none;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
  position: absolute;
  z-index: 4;
  filter: drop-shadow(0 2px 2px #1a1a1a);
}
@media (hover: hover) and (pointer: fine) {
  .image-gallery-icon:hover {
    color: #337ab7;
  }
  .image-gallery-icon:hover .image-gallery-svg {
    transform: scale(1.1);
  }
}
.image-gallery-icon:focus {
  outline: 2px solid #337ab7;
}

.image-gallery-using-mouse .image-gallery-icon:focus {
  outline: none;
}

.image-gallery-fullscreen-button,
.image-gallery-play-button {
  bottom: 0;
  padding: 20px;
}
.image-gallery-fullscreen-button .image-gallery-svg,
.image-gallery-play-button .image-gallery-svg {
  height: 28px;
  width: 28px;
}
@media (max-width: 768px) {
  .image-gallery-fullscreen-button,
  .image-gallery-play-button {
    padding: 15px;
  }
  .image-gallery-fullscreen-button .image-gallery-svg,
  .image-gallery-play-button .image-gallery-svg {
    height: 24px;
    width: 24px;
  }
}
@media (max-width: 480px) {
  .image-gallery-fullscreen-button,
  .image-gallery-play-button {
    padding: 10px;
  }
  .image-gallery-fullscreen-button .image-gallery-svg,
  .image-gallery-play-button .image-gallery-svg {
    height: 16px;
    width: 16px;
  }
}

.image-gallery-fullscreen-button {
  right: 0;
}

.image-gallery-play-button {
  left: 0;
}

.image-gallery-left-nav,
.image-gallery-right-nav {
  padding: 50px 10px;
  top: 50%;
  transform: translateY(-50%);
}
.image-gallery-left-nav .image-gallery-svg,
.image-gallery-right-nav .image-gallery-svg {
  height: 120px;
  width: 60px;
}
@media (max-width: 768px) {
  .image-gallery-left-nav .image-gallery-svg,
  .image-gallery-right-nav .image-gallery-svg {
    height: 72px;
    width: 36px;
  }
}
@media (max-width: 480px) {
  .image-gallery-left-nav .image-gallery-svg,
  .image-gallery-right-nav .image-gallery-svg {
    height: 48px;
    width: 24px;
  }
}
.image-gallery-left-nav[disabled],
.image-gallery-right-nav[disabled] {
  cursor: disabled;
  opacity: 0.6;
  pointer-events: none;
}

.image-gallery-left-nav {
  left: 0;
}

.image-gallery-right-nav {
  right: 0;
}

.image-gallery {
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: relative;
}
.image-gallery.fullscreen-modal {
  background: #000;
  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 5;
}
.image-gallery.fullscreen-modal .image-gallery-content {
  top: 50%;
  transform: translateY(-50%);
}

.image-gallery-content {
  position: relative;
  line-height: 0;
  top: 0;
}
.image-gallery-content.fullscreen {
  background: #000;
}
.image-gallery-content .image-gallery-slide .image-gallery-image {
  max-height: calc(100vh - 80px);
}
.image-gallery-content.image-gallery-thumbnails-left .image-gallery-slide .image-gallery-image, .image-gallery-content.image-gallery-thumbnails-right .image-gallery-slide .image-gallery-image {
  max-height: 100vh;
}

.image-gallery-slide-wrapper {
  position: relative;
}
.image-gallery-slide-wrapper.image-gallery-thumbnails-left, .image-gallery-slide-wrapper.image-gallery-thumbnails-right {
  display: inline-block;
  width: calc(100% - 110px);
}
@media (max-width: 768px) {
  .image-gallery-slide-wrapper.image-gallery-thumbnails-left, .image-gallery-slide-wrapper.image-gallery-thumbnails-right {
    width: calc(100% - 87px);
  }
}
.image-gallery-slide-wrapper.image-gallery-rtl {
  direction: rtl;
}

.image-gallery-slides {
  line-height: 0;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  text-align: center;
}

.image-gallery-slide {
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.image-gallery-slide.image-gallery-center {
  position: relative;
}
.image-gallery-slide .image-gallery-image {
  width: 100%;
  object-fit: contain;
}
.image-gallery-slide .image-gallery-description {
  background: rgba(0, 0, 0, 0.4);
  bottom: 70px;
  color: #fff;
  left: 0;
  line-height: 1;
  padding: 10px 20px;
  position: absolute;
  white-space: normal;
}
@media (max-width: 768px) {
  .image-gallery-slide .image-gallery-description {
    bottom: 45px;
    font-size: 0.8em;
    padding: 8px 15px;
  }
}

.image-gallery-bullets {
  bottom: 20px;
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  width: 80%;
  z-index: 4;
}
.image-gallery-bullets .image-gallery-bullets-container {
  margin: 0;
  padding: 0;
  text-align: center;
}
.image-gallery-bullets .image-gallery-bullet {
  appearance: none;
  background-color: transparent;
  border: 1px solid #fff;
  border-radius: 50%;
  box-shadow: 0 2px 2px #1a1a1a;
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
  outline: none;
  padding: 5px;
  transition: all 0.2s ease-out;
}
@media (max-width: 768px) {
  .image-gallery-bullets .image-gallery-bullet {
    margin: 0 3px;
    padding: 3px;
  }
}
@media (max-width: 480px) {
  .image-gallery-bullets .image-gallery-bullet {
    padding: 2.7px;
  }
}
.image-gallery-bullets .image-gallery-bullet:focus {
  transform: scale(1.2);
  background: #337ab7;
  border: 1px solid #337ab7;
}
.image-gallery-bullets .image-gallery-bullet.active {
  transform: scale(1.2);
  border: 1px solid #fff;
  background: #fff;
}
@media (hover: hover) and (pointer: fine) {
  .image-gallery-bullets .image-gallery-bullet:hover {
    background: #337ab7;
    border: 1px solid #337ab7;
  }
  .image-gallery-bullets .image-gallery-bullet.active:hover {
    background: #337ab7;
  }
}

.image-gallery-thumbnails-wrapper {
  position: relative;
}
.image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal {
  touch-action: pan-y;
}
.image-gallery-thumbnails-wrapper.thumbnails-swipe-vertical {
  touch-action: pan-x;
}
.image-gallery-thumbnails-wrapper.thumbnails-wrapper-rtl {
  direction: rtl;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
  display: inline-block;
  vertical-align: top;
  width: 100px;
}
@media (max-width: 768px) {
  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
    width: 81px;
  }
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails {
  height: 100%;
  width: 100%;
  left: 0;
  padding: 0;
  position: absolute;
  top: 0;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails .image-gallery-thumbnail {
  display: block;
  margin-right: 0;
  padding: 0;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail {
  margin-left: 0;
  margin-top: 2px;
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
  margin: 0 5px;
}
@media (max-width: 768px) {
  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
    margin: 0 3px;
  }
}

.image-gallery-thumbnails {
  overflow: hidden;
  padding: 5px 0;
}
@media (max-width: 768px) {
  .image-gallery-thumbnails {
    padding: 3px 0;
  }
}
.image-gallery-thumbnails .image-gallery-thumbnails-container {
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}

.image-gallery-thumbnail {
  display: inline-block;
  border: 4px solid transparent;
  transition: border 0.3s ease-out;
  width: 100px;
  background: transparent;
  padding: 0;
}
@media (max-width: 768px) {
  .image-gallery-thumbnail {
    border: 3px solid transparent;
    width: 81px;
  }
}
.image-gallery-thumbnail + .image-gallery-thumbnail {
  margin-left: 2px;
}
.image-gallery-thumbnail .image-gallery-thumbnail-inner {
  display: block;
  position: relative;
}
.image-gallery-thumbnail .image-gallery-thumbnail-image {
  vertical-align: middle;
  width: 100%;
  line-height: 0;
}
.image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
  outline: none;
  border: 4px solid #337ab7;
}
@media (max-width: 768px) {
  .image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
    border: 3px solid #337ab7;
  }
}
@media (hover: hover) and (pointer: fine) {
  .image-gallery-thumbnail:hover {
    outline: none;
    border: 4px solid #337ab7;
  }
}
@media (hover: hover) and (pointer: fine) and (max-width: 768px) {
  .image-gallery-thumbnail:hover {
    border: 3px solid #337ab7;
  }
}

.image-gallery-thumbnail-label {
  box-sizing: border-box;
  color: white;
  font-size: 1em;
  left: 0;
  line-height: 1em;
  padding: 5%;
  position: absolute;
  top: 50%;
  text-shadow: 0 2px 2px #1a1a1a;
  transform: translateY(-50%);
  white-space: normal;
  width: 100%;
}
@media (max-width: 768px) {
  .image-gallery-thumbnail-label {
    font-size: 0.8em;
    line-height: 0.8em;
  }
}

.image-gallery-index {
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  line-height: 1;
  padding: 10px 20px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 4;
}
@media (max-width: 768px) {
  .image-gallery-index {
    font-size: 0.8em;
    padding: 5px 10px;
  }
}

html {
  overflow-x: hidden;
  scroll-behavior: smooth;
}

.__react_modal_image__medium_img {
  max-height: 70% !important;
}

.attributed-text-segment-list__container {
  display: none !important;
}

#webpack-dev-server-client-overlay {
  display: none !important;
}

body {
  overflow-x: hidden;
}

.header {
  position: relative;
  z-index: 35555555;
  width: 100%;
}

.header-container {
  padding-left: 0px !important;
}

.whatsapp {
  position: fixed;
  right: 25px;
  bottom: 14%;
  z-index: 10000000;
}

.arr:hover {
  background: #ff5c00 !important;
  cursor: pointer;
}

.__react_modal_image__medium_img {
  width: auto !important;
  height: auto !important;
  border-radius: 20px;
  border: 3px solid white;
}

.__react_modal_image__modal_container {
  z-index: 99999000 !important;
}

.h-ban .slick-next {
  height: 80%;
  z-index: 111111;
  width: 50%;
  opacity: -1;
  display: block !important;
}

.h-ban .slick-prev {
  height: 40%;
  z-index: 11;
  width: 50%;
  opacity: -1;
  display: block !important;
}
@media (max-width: 767px) {
  .h-ban .slick-prev {
    height: 30% !important;
  }
}

@media (max-width: 576px) {
  .Header-logo {
    margin-left: 25px;
  }
}
@media (max-width: 517px) {
  .head-viewallpro-dom {
    display: none;
  }
}
.nav-link li a {
  color: #333333;
  font-size: 14px;
  text-decoration: none;
  padding: 0.5em;
}

.nav-link li {
  list-style: none;
}

.nav-item {
  padding: 0px 12px;
}

.menu1 {
  padding-right: 10px;
  margin-top: -2px;
}

.navbar {
  position: fixed;
  height: 100px;
  right: 0;
  background: rgb(255, 255, 255);
}

.navbar-nav {
  height: 100px;
}

.naa {
  position: absolute;
  right: 0;
}

.nav-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  font-size: 14px;
  padding: 0;
}

.active .nav-link {
  color: #ff5c00 !important;
  font-weight: 500 !important;
}

.nav-link:hover {
  color: #ff5c00 !important;
}

nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-product {
  background: #002B85;
  background-position: 100% 100%;
  height: 100px;
  padding: 39px;
}
.nav-product a {
  color: white;
  text-decoration: none;
}

.nav-product-list {
  text-decoration: none !important;
  color: #FFFFFF;
}

.nav-product-list:hover {
  color: #ff5c00 !important;
}

.clients-div {
  border-bottom: 2px solid #002b85;
  margin: 30px 0;
}

.clients-div-logo {
  margin: 15px;
  border-right: 2px solid #002b85;
}

.nav-product:hover {
  background: linear-gradient(#00A1ED, #00A1ED 50%, #002B85 50%, #002B85);
  background-size: 100% 200%;
  /*trasition effect for background*/
  transition: background 0.2s;
}
.nav-product:hover .menu2 {
  display: block;
  padding-right: 13px;
}
.nav-product:hover .menu1 {
  display: none;
}

.menu2 {
  display: none;
}

@media (min-width: 768px) and (max-width: 1214px) {
  .nav-item {
    padding: 0px 10px;
  }
  .navbar {
    height: auto;
    min-height: 100px;
  }
  .navbar-nav {
    height: auto;
  }
}
@media (max-width: 768px) {
  .navbar {
    width: 100%;
    height: auto;
  }
  .navbar-nav {
    height: auto;
  }
}
@media (max-width: 992px) {
  .naa {
    background: white;
    position: fixed;
    left: 0;
    top: 68px;
    overflow: scroll;
    height: 100vh;
  }
}
.homeBanner {
  position: relative;
}

.intro {
  position: absolute !important;
  top: 40%;
  margin-left: 150px;
  opacity: 0.7;
}
@media (min-width: 1500px) {
  .intro {
    top: 45% !important;
  }
}

.homeBanner {
  filter: brightness(0.7);
}

.banner-text1 {
  top: 80px;
  left: 100px;
  width: 132px;
  height: 18px;
  position: absolute;
  color: #FFFFFF;
  font-size: 14px;
}

.num {
  top: 80px;
  left: 81px;
  width: 20px;
  height: 18px;
  position: absolute;
  color: #FF5C00;
  font-size: 14px;
}

.arbtn {
  background: #002B85;
  border: none;
  margin-top: 30px;
}

.btns2 {
  margin-left: 10px;
}

.arbtn img {
  height: 44px !important;
}

.banner-text2 {
  font-size: 32px;
  top: 130px;
  left: 81px;
  width: 409px;
  height: 82px;
  position: absolute;
  color: #FFFFFF;
}

.banner-text3 {
  font-size: 20px;
  top: 250px;
  left: 81px;
  width: 408px;
  height: 52px;
  position: absolute;
  color: #FFFFFF;
}

.btn {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 50px;
  color: white !important;
  background-color: #002B85;
  border-radius: 10px;
  border: none;
  z-index: 20;
  transition: all 0.35s cubic-bezier(1, 0, 0, 1);
}

.btn:hover {
  color: #fcfcfc;
}

.btn-color {
  border-color: #002B85;
  color: #002B85;
}

.btn-color::before, .btn-color::after {
  border-radius: 10px;
  border-color: #FF5C00;
  background: #FF5C00;
}

.btn::before,
.btn::after {
  content: "";
  position: absolute;
  z-index: -1;
  transition: all 0.35s cubic-bezier(1, 0, 0, 1);
}

.btn-l-r::after {
  height: 100%;
  width: 0;
  top: 0;
}

.btn-l-r:hover::after {
  width: 100%;
}

.btn-l-r::after {
  left: 0;
}

.slick-dots {
  top: 50%;
  right: -95%;
}

.slick-dots li {
  position: relative;
  display: block !important;
  width: 20px;
  height: 20px;
  margin: 0 5px;
  padding: 0;
}

.slick-dots li button::before {
  display: none !important;
}

.slick-dots li button {
  width: 2px !important;
  height: 2px !important;
  padding: 3px !important;
  border-radius: 50% !important;
  border: 1px solid #ffffff !important;
  margin: 5px !important;
}

.slick-active button {
  background-color: #ffffff !important;
}

.about-us {
  background: #EFF7FF;
  padding-top: 80px;
  margin-top: -5px;
}

.development-support {
  margin: 50px 0;
}

@media (max-width: 1200px) {
  .about-us-sub-con {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
}
@media (max-width: 998px) {
  .aboutimg-div {
    display: flex;
    align-items: center;
  }
}
.aboutimg {
  width: 95%;
  border-radius: 20px;
  height: 90%;
}

.development-support img {
  border-radius: 20px;
}

.Ser_slid .__react_modal_image__modal_content img {
  margin-left: -9%;
}

.banner-txt {
  display: flex;
}

.banner-num {
  color: #FF5C00;
  font-size: 14px;
}

.intro .banner-num {
  color: #ff5c00 !important;
  font-size: 14px;
}
.intro .banner-title {
  color: #ffffff;
  font-size: 14px;
  margin-left: 20px;
}

.banner-title {
  color: #333333;
  font-size: 14px;
  margin-left: 20px;
}

.txt1 {
  font-size: 32px;
  color: #FFFFFF;
  font-weight: bold;
}

.txt2 {
  color: #002B85;
  font-weight: bold;
  font-size: 30px;
}

.our-products .txt2 {
  padding-left: 0 !important;
}

.txt3 {
  color: #3B3B3B;
  font-size: 18px;
}

.txt4 {
  color: #002B85;
  font-size: 16px;
  font-weight: bold;
}

.txt5 {
  color: #7C90A2;
  font-size: 16px;
}

.txt6 {
  color: #0A0A0A;
  font-size: 26px;
  padding-left: 100px;
}

.txt7 {
  color: #FFFFFF;
  font-size: 20px;
  font-weight: lighter;
}

.txt8 {
  color: #000000;
  font-size: 18px;
}

.our-products {
  padding-top: 20px;
}

.txt9 {
  color: #FFFFFF;
  font-size: 10px;
}

.txt10 {
  color: #FFFFFF;
  font-size: 20px;
}

.txt11 {
  color: #ffffff;
  font-weight: bold;
  font-size: 30px;
}

.txt12 {
  color: #ffffff;
  font-size: 18px;
}

.txt13 {
  color: #ffffff;
  font-size: 24px;
}

.txt14 {
  color: #0A0A0A;
  font-size: 24px;
  font-weight: 500;
}

.txt15 {
  color: #0A0A0A;
  font: size 20px;
}

.txt16 {
  color: #0A0A0A;
  font-size: 32px;
}

.txt17 {
  color: #FFFFFF;
  font-size: 17px;
}

.txt18 {
  color: #002B85;
  font-size: 18px;
}

.txt19 {
  font-size: 24px;
  color: #002B85;
  font-weight: bold;
}

.txt20 {
  color: #000000;
  font-size: 12px;
}

.txt21 {
  color: #3B3B3B;
  font-size: 18px;
}

.txt22 {
  font-size: 14px;
  color: #555555;
}

.txt23 {
  font-size: 24px;
  color: #000000;
  font-weight: bold;
}

.btn2 {
  position: relative;
  display: block;
  width: 200px;
  height: 50px;
  color: white;
  align-items: center;
  background: transparent;
  border-radius: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: 2px solid #002B85;
  z-index: 20;
  transition: all 0.35s cubic-bezier(1, 0, 0, 1);
}

.btn2:hover {
  color: #fcfcfc;
  border: none;
}

.btn2-color {
  border-color: #002B85;
  color: #002B85;
}

.btn2-color::before, .btn2-color::after {
  border-radius: 10px;
  border-color: #FF5C00;
  border: none;
  background: #FF5C00;
}

.btn2::before,
.btn2::after {
  content: "";
  position: absolute;
  z-index: -1;
  transition: all 0.35s cubic-bezier(1, 0, 0, 1);
}

.btn2-l-r::after {
  height: 100%;
  width: 0;
  top: 0;
}

.btn2-l-r:hover::after {
  width: 100%;
}

.btn2-l-r::after {
  left: 0;
}

.data1 {
  border-right: 2px solid #002B85;
}

.data1:last-child {
  border-right: none;
}

@media (max-width: 768px) {
  .data1 {
    border-right: none;
  }
}
.banner-txt-Dev {
  display: flex;
  width: 310px;
  height: 20px;
  transform: rotate(-90deg) translate(-100%, 0);
  transform-origin: 0 0;
}

.Our_Ser {
  background-color: #EFF7FF;
  overflow-x: hidden;
}

@media (max-width: 992px) {
  .banner-txt-Dev {
    width: 230px;
  }
}
@media (max-width: 568px) {
  .Our_Ser {
    padding-left: 20px;
  }
}
.banner-txt-Ser {
  display: flex;
  width: 207px;
  height: 20px;
  transform: rotate(-90deg) translate(-100%, 0);
  transform-origin: 0 0;
}

.dev-img1 {
  width: 78%;
  max-height: 370px;
}

.dev-img2 {
  width: 100%;
  height: 286px;
  object-fit: cover;
}

.homeBanner {
  padding-top: 0 !important;
}

.Ser_slid {
  margin-left: 50px;
}

@media (min-width: 768px) and (max-width: 1200px) {
  .Ser_slid .slick-slide {
    width: 250px !important;
  }
}

@media (min-width: 768px) and (max-width: 1200px) {
  .Ser_slid .slick-current {
    width: 400px !important;
  }
}

.Ser_slid img {
  height: 406px;
  object-fit: cover;
  border-radius: 20px;
}
@media (max-width: 1000px) {
  .Ser_slid img {
    height: 300px;
  }
}

@media (max-width: 768px) {
  .dev-img2 {
    width: 100%;
    height: auto;
  }
}
@media (max-width: 568px) {
  .slide-img {
    width: 68px !important;
  }
  .Ser_slid {
    margin-left: 0px;
  }
}
.Ser_slid .slick-initialized .slick-slide {
  display: block;
  padding-right: 25px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.slick-arrow {
  display: none !important;
}

.slick-slide img {
  padding-top: 150px;
}

.slick-center img {
  padding-top: 0px !important;
}

.show .pro {
  display: block !important;
}

.pro {
  background-color: #002B85;
  position: absolute;
  border-radius: 0px 0px 20px 20px;
  margin-top: 29px;
  right: 0;
  display: none !important;
  top: 71px;
  width: 100%;
  /* width: 873px;
  height: 496px; */
  color: #EFF7FF;
  font-size: 14px;
  z-index: 2;
}
@media (max-width: 480px) {
  .pro {
    background-color: transparent;
  }
}

.pro p {
  padding: 0;
  text-align: left;
}

.navbar-nav {
  align-items: center;
}

.btn-products {
  border: 1px solid #FFFFFF;
  border-radius: 10px;
  text-align: center;
  align-items: center;
  width: 184px;
  height: 34px;
  padding: 6px;
}

@media (max-width: 1024px) {
  .banner-num {
    margin-bottom: 0 !important;
  }
  .intro {
    top: 26%;
  }
}
@media (max-width: 992px) {
  .pro {
    position: relative !important;
    width: 100% !important;
    margin-top: 0;
    top: 0;
  }
  .pro p {
    padding: 0;
    text-align: center;
  }
  .btn-products {
    height: 34px;
    width: 150px !important;
    display: flex;
    /* text-align: center; */
    align-items: center;
    justify-content: space-around;
  }
  .nav-product {
    border-radius: 10px 10px;
  }
  .navbar-nav {
    align-items: normal !important;
  }
  .navbar-nav li {
    padding: 10px;
  }
  .txt1 {
    font-size: 25px;
  }
  .txt7 {
    font-size: 18px;
  }
  .txt6 {
    font-size: 20px;
  }
  .txt2 {
    font-size: 20px;
  }
  .txt3 {
    font-size: 15px;
  }
  .btn {
    margin-top: 10px !important;
    left: 25%;
  }
}
@media (max-width: 768px) {
  .intro {
    top: 30% !important;
    margin-left: 75px;
  }
  .Ser_slid .slick-initialized .slick-slide {
    display: block;
    padding: 19px;
  }
  .our-Ser-btn {
    display: flex;
    justify-content: center;
  }
  .our-Ser-title {
    text-align: center;
  }
  .our-Ser-title .offset-3 {
    margin-left: 0;
  }
  .txt1 {
    padding-top: 0 !important;
  }
  .banner-num {
    margin-bottom: 0 !important;
  }
}
@media (max-width: 668px) {
  .intro {
    top: 30% !important;
    margin-left: 30px;
  }
  .intro .txt1 {
    padding-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .txt1 {
    font-size: 15px;
    padding-top: 0;
  }
  .banner-title {
    font-size: 10px;
  }
  .banner-num {
    font-size: 10px;
  }
  .txt7 {
    font-size: 12px;
  }
  .btn {
    width: 156px;
    height: 35px;
    font-size: 12px;
  }
  .slick-dots {
    top: 30%;
    right: -90%;
  }
  .homeBanner {
    height: 250px;
  }
  .pro {
    padding: 30px !important;
  }
}
@media (max-width: 568px) {
  .Ser_slid .slick-initialized .slick-slide {
    display: block;
    padding: 12px;
  }
  .our-products img {
    width: 250px !important;
    height: 200px !important;
  }
  .our-products {
    margin-left: 20px;
    overflow-x: hidden;
  }
}
.our-products img {
  width: 320px;
  height: 280px;
}

.our-pro .Our-pro-img {
  border-right: #002B85 solid 2px;
}
@media (max-width: 768px) {
  .our-pro .Our-pro-img {
    border-right: none !important;
  }
}

.Our-pro-img {
  border-bottom: #002B85 solid 2px;
}

.our-pro:nth-child(3n) .Our-pro-img {
  border-right: none !important;
}

.our-pro-con {
  border-bottom: #ffffff solid 2px;
}

.our-pro:hover .our-pro-con {
  color: white;
  background: linear-gradient(#002B85, #002B85 50%, #ffffff 50%, #ffffff);
  background-size: 100% 200%;
  /*trasition effect for background*/
  transition: background 0.5s;
}

.our-pro-con {
  background-position: 100% 100%;
}

@media (max-width: 991px) {
  .Our-pro-img-1 {
    border-bottom: #002B85 solid 2px;
    border-right: none;
  }
  .Our-pro-img-2 {
    border-bottom: #002B85 solid 2px;
    border-right: #002B85 solid 2px;
  }
  .Our-pro-img-3 {
    border-bottom: #002B85 solid 2px;
    border-right: none;
  }
  .Our-pro-img-4 {
    border-bottom: #002B85 solid 2px;
    border-right: #002B85 solid 2px;
  }
  .Our-pro-img-5 {
    border-bottom: #002B85 solid 2px;
  }
}
@media (max-width: 767px) {
  .Our-pro-img {
    border-bottom: #002B85 solid 2px;
    border-right: none;
  }
  .Our-pro-img-1 {
    border-bottom: #002B85 solid 2px;
    border-right: none;
  }
  .Our-pro-img-2 {
    border-bottom: #002B85 solid 2px;
    border-right: none;
  }
  .Our-pro-img-3 {
    border-bottom: #002B85 solid 2px;
    border-right: none;
  }
  .Our-pro-img-4 {
    border-bottom: #002B85 solid 2px;
    border-right: none;
  }
  .Our-pro-img-5 {
    border-bottom: #002B85 solid 2px;
  }
  .our-pro-btn {
    display: flex;
    justify-content: center;
  }
}
.Ser_slid .slick-list .slick-active:nth-child(2) {
  margin-top: -100px;
}

mark {
  color: white;
  background: #FF5C00;
}

.previous {
  z-index: 999;
  cursor: pointer;
  position: absolute;
  bottom: 30%;
  left: -50px;
}
@media (max-width: 420px) {
  .previous {
    left: -5px;
    bottom: 50%;
  }
}

.next {
  z-index: 999;
  cursor: pointer;
  position: absolute;
  bottom: 30%;
  right: 0;
}
@media (max-width: 420px) {
  .next {
    right: 4px;
    bottom: 50%;
  }
}

.Ser_slid .slick-list {
  margin-right: 30px;
}

.arrow svg {
  width: 57px;
  height: 56px;
  font-weight: 600;
  color: #ff5c00;
}
@media (max-width: 420px) {
  .arrow svg {
    width: 23px !important;
    height: 23px;
  }
}

.ser-slide .slick-initialized {
  padding-left: 40px;
}

.latest_news_area {
  overflow-x: hidden;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
}

.latest_news {
  margin-left: 30%;
  padding-top: 8%;
}

#direct-post-widget[data-iframeembed=true] #createPostButton {
  display: none !important;
  z-index: -1111 !important;
}

.latest_feed {
  margin-left: 0 !important;
  padding-bottom: 50px;
}

.latest_news .btn2 {
  margin-left: 15px;
}

.news-img {
  width: 246px;
  height: 248px;
  position: relative;
}

.news-img img {
  position: relative;
}

.news-date {
  position: relative;
  right: -119px;
  top: 15px;
}

.news-title {
  bottom: -230px;
  position: absolute;
  width: 225px;
}

.contact-us-bg {
  background-color: #002B85;
  margin-left: 13%;
}

.contact-us-bg .btn2 {
  border: #EFF7FF solid 2px;
  color: #FFFFFF;
}

.contact-us-bg img {
  max-width: 95%;
}

.banner-txt-contact {
  display: flex;
  width: 300px;
  height: 20px;
  transform: rotate(-90deg) translate(-100%, 0);
  transform-origin: 0 0;
  margin-left: 100px;
}

@media (max-width: 768px) {
  .contact-us-bg img {
    max-width: 95%;
    margin-top: 25%;
  }
  .banner-txt-contact {
    margin-left: 80px;
  }
  .latest_news {
    margin-left: 10%;
  }
}
@media (max-width: 568px) {
  .news-img {
    padding: 0 !important;
  }
}
.footer-top {
  background-color: #ECECEC;
}

.footer-top .container {
  padding-top: 55px;
  padding-bottom: 50px;
}

.logo {
  width: 237px;
  height: 93px;
}

.footer-title {
  color: #002B85;
  font-size: 18px;
  font-weight: bold;
  /* text-align: center; */
}
.footer-title a {
  text-decoration: none;
  color: #002B85;
}

.footer-Qlink {
  margin-left: 10px;
}

.list {
  list-style: none;
  padding-left: 0%;
  color: #3B3B3B;
  font-size: 14px;
  padding-top: 25px;
}

.list li {
  padding-top: 5px;
}
.list li a {
  text-decoration: none;
  color: #3B3B3B;
}

.list li a:hover {
  color: #FF5C00;
  font-weight: 600;
}

.tail ul li a:hover {
  color: #FF5C00;
  font-weight: 600;
}

.Novacancy .btn {
  padding-top: 0.8em !important;
  margin-left: 145px;
}

.footer-bottom {
  width: 100%;
  padding: 20px 0;
  background-color: #002B85;
}

.tail ul li {
  list-style: none;
  display: inline-block;
  color: #FFFFFF;
  padding-right: 20px;
  font-size: 14px;
}
.tail ul li a {
  text-decoration: none;
  color: #FFFFFF;
}

.footer-text2 {
  color: #FFFFFF;
  padding-left: 3px;
  margin: 0%;
  font-size: 14px;
}

.footer-img {
  width: 140px;
  height: 33px;
}

.footer-text {
  color: #fc0000;
  font-size: 14px;
  margin: 0%;
  /* padding-right: 25px; */
}

@media (min-width: 767px) and (max-width: 830px) {
  .tail-row {
    display: block;
  }
  .tail-row ul {
    margin: 0px !important;
    text-align: center;
    width: 100% !important;
  }
  .tail-row-logo {
    justify-content: flex-start !important;
    width: 100% !important;
  }
}
@media (max-width: 576px) {
  .foot-logo {
    margin-left: 15px;
  }
  .tail {
    padding: 0px 10px;
  }
}
.Def-banner {
  position: relative;
}

.Def-banner-image {
  width: 100%;
}

.Def-banner-text {
  position: absolute;
  bottom: 100px;
  color: #FFFFFF;
  font-size: 50px;
}

@media (max-width: 768px) {
  .Def-banner-text {
    bottom: 30px;
  }
}
@media (max-width: 574px) {
  .Def-banner-image {
    height: 315px;
  }
}
@media (min-width: 1500px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
    max-width: 1450px;
  }
}
@media (min-width: 1620px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
    max-width: 1450px;
  }
}
.since {
  overflow-x: hidden;
}

.since-top-link {
  border: 1px solid #002B85;
  border-radius: 20px;
  margin-top: 30px;
}

.since-top-link-text {
  margin: 20px 0px;
}

.since-top-links {
  margin: 20px 0px;
  border-right: 1px solid #002B85;
  text-align: center;
}
.since-top-links a {
  color: #002B85;
  font-size: 18px;
  text-decoration: none;
}
.since-top-links a:hover {
  color: #FF5C00;
}

.since-top-links:last-child {
  border-right: none;
}

@media (max-width: 767px) {
  .since-top-links:nth-child(3) {
    border-right: none;
  }
}
@media (max-width: 576px) {
  .since-top-links:nth-child(3) {
    border-right: 1px solid #002B85;
  }
  .since-top-links:nth-child(2) {
    border-right: none;
  }
  .since-top-links:nth-child(4) {
    border-right: none;
  }
}
.since-con {
  margin-top: 80px;
}
@media (max-width: 991px) {
  .since-con {
    margin-top: 20px;
  }
}

.since-con img {
  width: 100%;
}

@media (max-width: 1200px) {
  .since-img {
    display: flex;
    align-items: center;
  }
}
.since-title {
  font-size: 30px;
  font-weight: bold;
  color: #002B85;
  margin-top: 45px;
  padding-left: 20px;
}

.since-desc {
  font-size: 17px;
  color: #3B3B3B;
  margin-top: 27px;
  margin-bottom: 0px;
  padding-left: 20px;
}
@media (max-width: 1300px) {
  .since-desc {
    margin-bottom: 0px;
  }
}
@media (max-width: 1200px) {
  .since-desc {
    font-size: 14px;
  }
}

.profile-container {
  background: #EFF7FF;
  margin-top: 26px;
}

.CompanyProfile-img {
  margin-top: 80px;
  width: 100%;
}

.CompanyProfile-img-overly {
  position: relative;
}

.CompanyProfile-img-overly:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: rgba(22, 44, 201, 0.26);
  border-radius: 20px;
  margin-top: 80px;
}

.CompanyProfile-con {
  padding: 30px 0px;
}

.Com-Profile {
  background: #002B85;
}

.company-profile {
  border-bottom: 1px solid #FFFFFF;
  border-right: 1px solid #FFFFFF;
  display: flex;
}

.company-profile:nth-child(2n) {
  border-right: none;
}

.company-profile:nth-child(3) {
  border-bottom: none;
}
@media (max-width: 992px) {
  .company-profile:nth-child(3) {
    border-bottom: none;
  }
}
@media (max-width: 768px) {
  .company-profile:nth-child(3) {
    border-bottom: 1px solid #FFFFFF;
  }
}

.company-profile:nth-child(4) {
  border-bottom: none;
}

.company-profile1 {
  border-bottom: 1px solid #FFFFFF;
  display: flex;
}

.company-profile2 {
  display: flex;
  border-right: 1px solid #FFFFFF;
}

.company-profile3 {
  display: flex;
}

.Com-Profile-con {
  padding-top: 100px;
  padding-bottom: 100px;
}
@media (max-width: 991px) {
  .Com-Profile-con {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
@media (min-width: 1200px) and (max-width: 1300px) {
  .Com-Profile-con {
    padding-left: 100px;
    padding-right: 100px;
  }
}

.profile-icon {
  width: 85px;
  height: 85px;
}

.profile-txt {
  margin-left: 40px;
}

@media (max-width: 767px) {
  .company-profile {
    border-bottom: 1px solid #FFFFFF;
    border-right: none;
  }
  .company-profile2 {
    border-bottom: 1px solid #FFFFFF;
    border-right: none !important;
  }
}
.QualityAssurance {
  margin-top: 80px;
}

.QualityAssurance-img {
  width: 100%;
}

@media (max-width: 868px) {
  .QualityAssurance-img-con {
    display: flex;
    align-items: center;
  }
}
.QualityAssurance-con {
  padding-right: 120px;
  margin-left: 30px;
  margin-top: 50px;
}

@media (max-width: 1250px) {
  .QualityAssurance-con {
    padding-right: 30px;
  }
}
.TrinityHoldingsSubsidiaries {
  margin-top: 80px;
}
@media (max-width: 1300px) {
  .TrinityHoldingsSubsidiaries {
    margin-top: 10px;
  }
}

.TrinityHoldingsSubsidiaries-con {
  margin-top: 50px;
}
@media (max-width: 1300px) {
  .TrinityHoldingsSubsidiaries-con {
    margin-left: 50px;
  }
}
@media (max-width: 768px) {
  .TrinityHoldingsSubsidiaries-con {
    margin-left: 0px;
  }
}
@media (max-width: 991px) {
  .TrinityHoldingsSubsidiaries-con {
    margin-left: 0px;
  }
}

@media (max-width: 992px) {
  .TrinityHoldingsSubsidiaries-img-con {
    display: flex;
    align-items: center;
  }
}
.TrinityHoldingsSubsidiaries-img {
  width: 100%;
  padding-left: 20px;
}

.WordsfromtheCEO {
  margin-top: 80px;
}
@media (max-width: 1300px) {
  .WordsfromtheCEO {
    margin-top: 10px;
  }
}

.WordsfromtheCEO-con {
  margin-left: 25px;
  margin-top: 50px;
}

.WordsfromtheCEO-con-det {
  padding-left: 30px;
}

.WordsfromtheCEO-img {
  width: 100%;
}

@media (max-width: 992px) {
  .WordsfromtheCEO-img-con {
    display: flex;
    align-items: center;
  }
  .WordsfromtheCEO-con {
    margin-top: 15px;
  }
}
.OurTeam-about {
  margin: 75px 0px;
}

.OurTeam-about-img {
  margin-top: 10px;
}

.OurTeam-about-img img {
  width: 100%;
  height: 268px;
}

.OurTeam-about-con {
  background: #002B85;
}

@media (min-width: 768px) and (max-width: 992px) {
  .OurTeam-about-con {
    height: 150px;
  }
}
.OurTeam-about-con-det {
  padding: 21px;
}

@media (max-width: 768px) {
  .OurTeam-about-img {
    margin-top: 20px;
  }
}
@media (max-width: 575px) {
  .OurTeam-about {
    margin: 30px 50px;
  }
}
.OurClients-bg {
  position: relative;
  background: rgba(22, 44, 201, 0.5215686275);
}

.OurClients {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-repeat: no-repeat;
}

.OurClients-con {
  padding-top: 80px;
  margin-left: 60px;
}

.OurClients-div {
  background: #FFFFFF;
  border-radius: 20px;
  margin-bottom: 150px;
}

.OurClients-logo-first-row {
  border-bottom: #002B85 solid 1px;
}

.Clientslogo {
  border-right: #002B85 solid 1px;
}
@media (max-width: 768px) {
  .Clientslogo {
    border-right: none !important;
  }
}

.OurClients-logo:nth-child(4) .Clientslogo {
  border-right: none !important;
}

.OurClients-logo:nth-child(5) {
  border-bottom: none !important;
}
@media (max-width: 768px) {
  .OurClients-logo:nth-child(5) {
    border-bottom: #002B85 solid 1px !important;
  }
}

.OurClients-logo:nth-child(6) {
  border-bottom: none !important;
}
@media (max-width: 768px) {
  .OurClients-logo:nth-child(6) {
    border-bottom: #002B85 solid 1px !important;
  }
}

.OurClients-logo:nth-child(7) {
  border-bottom: none !important;
}
@media (max-width: 768px) {
  .OurClients-logo:nth-child(7) {
    border-bottom: #002B85 solid 1px !important;
  }
}

.OurClients-logo:nth-child(8) {
  border-bottom: none !important;
}

.OurClients-logo {
  border-bottom: 1px solid #002b85;
  margin-bottom: 10px;
  padding-bottom: 20px;
}

.Clientslogo {
  width: 100%;
  padding-right: 20px;
}

.OurClients-logo:last-child {
  border-right: none;
}

.OurClients-logo-first-row:last-child {
  border-bottom: none;
}

@media (max-width: 992px) {
  .OurClients-logo {
    margin-top: 20px;
  }
  .OurClients-logo:nth-child(2) {
    border-right: none;
  }
}
@media (max-width: 767px) {
  .OurClients-logo {
    border-right: none;
    border-bottom: #002B85 solid 1px;
  }
  .OurClients-logo:last-child {
    border-bottom: none;
  }
  .OurClients-logo-first-row {
    display: block !important;
    align-items: center;
  }
  .OurClients-con {
    margin-left: 0px;
  }
}
.Solutions-banner {
  position: relative;
}

.Solutions-banner-image {
  height: 657px;
  margin-top: 50px;
  width: 100%;
}

.Solutions-banner-text {
  position: absolute;
  bottom: 160px;
  padding-left: 10px;
}

.Solutions-banner-text-title {
  bottom: 100px;
  color: #FFFFFF;
  font-size: 50px;
}

.Solutions-banner-text-sub {
  bottom: 100px;
  color: #FFFFFF;
  font-weight: 300;
  font-size: 30px;
}

.Solutions-content {
  margin: 20px;
}

@media (max-width: 768px) {
  .Solutions-banner-text-sub {
    bottom: 100px;
    color: #FFFFFF;
    font-weight: 300;
    font-size: 20px;
    padding-right: 50px !important;
  }
}
.CustomManufacturing-txt {
  align-items: center;
  padding-left: 70px;
  padding-right: 10px;
}

.CustomManufacturing {
  margin-top: 80px;
}

.CustomManufacturing-image {
  width: 100%;
  height: auto;
}

@media (max-width: 767px) {
  .CustomManufacturing-txt {
    align-items: center;
    padding-left: 0px;
    margin-top: 20px;
    padding-right: 10px;
  }
  .Hire-image-con {
    padding-left: 0px !important;
  }
}
.Hire {
  margin-top: 80px;
}

.Hire-image {
  width: 100%;
  height: auto;
  border-radius: 20px;
}

.Hire-image-con {
  padding-left: 50px;
}

.TurnkeyProjects {
  margin-top: 80px;
}

.TurnkeyProjects-image {
  border-radius: 20px;
  width: 100%;
  height: auto;
}

.TurnkeyProjects-con {
  padding-left: 50px !important;
}

@media (max-width: 767px) {
  .TurnkeyProjects-con {
    padding-left: 0px !important;
    margin-top: 20px;
  }
}
.ProductSliderContent-row .childslider .slick-active.slick-cloned {
  display: none;
}

.ConsultingDesign {
  margin-top: 80px;
}

.ConsultingDesign-image {
  width: 100%;
}

.ConsultingDesign-image-con {
  padding-left: 32px !important;
}

.DewateringTechniques-image {
  width: 100%;
  border-radius: 20px;
}

.DewateringTechniques {
  margin-top: 80px;
  margin-bottom: 80px;
}

.DewateringTechniques-txt {
  padding-left: 80px;
}

@media (max-width: 767px) {
  .ConsultingDesign-image-con {
    padding-left: 0px !important;
  }
  .DewateringTechniques-txt {
    padding-left: 0px;
  }
}
.ProductsBanner {
  overflow-x: hidden;
  margin-top: 100px;
}

.ProductsBanner-text {
  background: #EFF7FF;
}

.ProductsBanner-txt {
  padding-left: 80px;
  margin-top: 80px;
  padding-right: 20px;
}
@media (min-width: 1300px) and (max-width: 1599px) {
  .ProductsBanner-txt {
    padding-left: 100px;
  }
}
@media (min-width: 1600px) and (max-width: 1920px) {
  .ProductsBanner-txt {
    padding-left: 200px;
  }
}

.ProductsBanner-image {
  width: 100%;
  height: auto;
}

@media (max-width: 894px) {
  .ProductsBanner-txt {
    padding-left: 45px;
    margin-top: 10px;
    padding-right: 20px;
  }
}
.ProductsList {
  margin-top: 80px;
  margin-bottom: 130px;
}

.ProductsList-image {
  width: 320px;
  height: 274px;
  padding: 20px 0px;
  margin: 0px 40px;
}
@media (min-width: 1000px) and (max-width: 1200px) {
  .ProductsList-image {
    margin: 0px !important;
  }
}

.ProductsList-image-div {
  border-bottom: #002B85 solid 1px;
  border-right: #002B85 solid 1px;
}

.ProductsList-image-col:nth-child(2n) .ProductsList-image-div {
  border-right: none !important;
}

.productslide-img-scroll {
  padding-top: 0 !important;
}

.productslide-img {
  padding-top: 0 !important;
}

.ProductsList-image-div1 {
  border-bottom: #002B85 solid 1px;
}

.ProductsList-image-col:hover .ProductsList-image-desc {
  color: #FFFFFF !important;
  background: linear-gradient(#002B85, #002B85 50%, #ffffff 50%, #ffffff);
  background-size: 100% 200%;
  /*trasition effect for background*/
  transition: background 0.5s;
}

.ProductsList-image-desc {
  background-position: 100% 100%;
  font-size: 18;
  color: #000000;
  text-align: center;
  padding: 20px;
  width: 100%;
}

.ProductsList-image-desc:hover {
  color: #FFFFFF !important;
  background: linear-gradient(#002B85, #002B85 50%, #ffffff 50%, #ffffff);
  background-size: 100% 200%;
  /*trasition effect for background*/
  transition: background 0.5s;
}

.RelatedProducts-div {
  border: #002B85 solid 1px;
  border-radius: 20px;
  margin-top: 80px !important;
  margin-left: 50px;
}
@media (min-width: 1000px) and (max-width: 1200px) {
  .RelatedProducts-div {
    margin: 0px !important;
  }
}
@media (min-width: 1400px) {
  .RelatedProducts-div {
    margin-left: 0px !important;
  }
}

.ProductsList-col1 {
  padding-right: 30px;
}

.pro-item img {
  padding: 0 3px;
}

.RelatedProducts-title {
  border-bottom: rgba(0, 42, 133, 0.5294117647) solid 2px;
  margin: 20px 20px;
  padding: 10px 20px;
}

.RelatedProducts-sub {
  margin: 10px 40px;
  padding: 10px 0px;
  border-bottom: rgba(0, 42, 133, 0.5294117647) solid 1px;
}
.RelatedProducts-sub a {
  text-decoration: none;
  color: #000000;
}

.RelatedProducts-sub a:hover {
  color: #002B85;
  font-weight: 500;
}

.RelatedProducts-sub:last-child {
  border-bottom: none;
}

.RelatedProducts-sub-div {
  margin-top: 20px;
  margin-bottom: 50px;
}

.LatestNews-div {
  background: #EFF7FF;
  border-radius: 20px;
  margin-top: 100px !important;
  margin-left: 50px;
}
@media (min-width: 1000px) and (max-width: 1200px) {
  .LatestNews-div {
    margin: 0px !important;
  }
}
@media (min-width: 1400px) {
  .LatestNews-div {
    margin-left: 0px !important;
  }
}

.LatestNews-title {
  border-bottom: rgba(0, 42, 133, 0.5294117647) solid 2px;
  margin: 20px 20px;
  margin-top: 60px !important;
  padding: 10px 20px;
  margin-right: 40px;
}

.LatestNews-sub-div {
  margin-top: 20px;
  margin-bottom: 40px;
  margin-right: 40px;
}

.LatestNews-sub {
  margin-left: 40px;
  line-height: 35px;
  margin-top: 15px;
  padding-bottom: 15px;
  border-bottom: rgba(0, 42, 133, 0.5294117647) solid 1px;
}

.LatestNews-sub:last-child {
  border-bottom: none !important;
}

.ReadALLNews {
  margin-left: 40px;
  margin-bottom: 60px;
}

.btn3 {
  display: flex;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 50px;
  color: #EFF7FF !important;
  background-color: #002B85;
  border-radius: 10px;
  border: none;
}

.Button3 {
  cursor: pointer;
  margin-top: 40px;
}

.form-group .errors {
  color: red;
}

.ProductsList-image-col {
  margin-top: 50px !important;
}

@media (max-width: 992px) {
  .ProductsList-row {
    display: block;
  }
  .ProductsList-col1 {
    width: 100%;
  }
  .ProductsList-col2 {
    width: 90%;
  }
}
@media (max-width: 767px) {
  .ProductsList-image-div {
    text-align: center;
    border-right: none;
  }
  .ProductsList-image-div1 {
    text-align: center;
  }
  .RelatedProducts-div {
    margin-left: 0px;
  }
  .LatestNews-div {
    margin-left: 0px;
  }
  .ProductsList-col2 {
    width: 100%;
  }
  .ProductsBanner-txt {
    padding-left: 80px;
    margin-top: 80px;
    padding-right: 20px;
  }
}
.ProductSliderContent {
  margin-top: 100px;
  background: rgb(255, 255, 255);
  background: linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 0%, rgb(254, 253, 253) 50%, rgb(239, 247, 255) 50%);
}

.Productpath {
  margin-top: 60px;
}

.ProductSliderContent-title {
  margin-top: 73px;
}

.ProductSliderContent-det {
  margin-left: 60px;
  margin-bottom: 110px;
}

.btn4 {
  text-decoration: none;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 220px;
  color: #EFF7FF !important;
  background-color: #002B85;
  border-radius: 10px;
  border: none;
  cursor: pointer;
}

.btn5 {
  text-decoration: none;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #002B85 !important;
  background: transparent;
  border-radius: 10px;
  border: #002B85 solid 1px !important;
  border: none;
}

.productslide-img {
  width: 98%;
  height: 400px;
}

.productslide-img-scroll {
  width: 128px;
  height: 98px;
}

.childslider .slick-track {
  height: auto !important;
  display: flex;
  z-index: 99999;
}

@media (max-width: 992px) {
  .ProductSliderContent-row {
    display: block;
  }
  .ProductSliderContent {
    background: none;
  }
  .ProductSliderContent-col1 {
    width: 100%;
  }
  .ProductSliderContent-col2 {
    width: 100%;
    margin: 0;
  }
  .ProductSliderContent-det {
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
  }
}
.MaterialsandApplications {
  margin-top: 30px;
  margin-bottom: 80px;
}

.MaterialsandApplications-div {
  border: #002B85 solid 1px;
  border-radius: 20px;
}

.MaterialsandApplications-title {
  border-bottom: rgba(0, 42, 133, 0.5294117647) solid 2px;
  margin: 20px 20px;
  margin-top: 20px !important;
  padding: 10px 10px;
  margin-right: 40px;
}

.MaterialsandApplications-sub-div {
  margin-top: 20px;
  margin-bottom: 40px;
  margin-right: 40px;
}

.MaterialsandApplications-sub {
  margin-left: 40px;
  line-height: 35px;
  margin-top: 10px;
  padding-bottom: 10px;
  border-bottom: rgba(0, 42, 133, 0.5294117647) solid 1px;
}

.MaterialsandApplications-sub:last-child {
  border-bottom: none !important;
}

.MaterialsandApplications-col {
  margin-right: 130px;
}

.pcnt {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 1px !important;
}

.pcnt2 {
  font-size: 14px;
}

.feature {
  border-bottom: 1px solid black;
}

.feature img {
  width: 100%;
  height: 60% !important;
}

.feature-cnt {
  margin-right: 0 !important;
}

.Materials table {
  border-collapse: collapse;
  border: 2px solid rgb(200, 200, 200);
  letter-spacing: 1px;
  font-size: 0.8rem;
}

.Materials table th {
  border: 1px solid rgb(190, 190, 190);
  padding: 2px 4px;
}

.Materials table td {
  border: 1px solid rgb(190, 190, 190);
  padding: 2px 4px;
}

.Materials table th {
  background-color: rgb(235, 235, 235);
}

.materials td {
  text-align: center;
}

.Materials tr:nth-child(even) td {
  background-color: rgb(250, 250, 250);
}

.materials tr:nth-child(odd) td {
  background-color: rgb(245, 245, 245);
}

@media (max-width: 1200px) {
  .MaterialsandApplications-title {
    margin-right: 20px;
  }
  .MaterialsandApplications-sub-div {
    margin-right: 20px;
  }
  .MaterialsandApplications-sub {
    margin-left: 20px;
  }
}
@media (max-width: 992px) {
  .MaterialsandApplications-first-col {
    width: 100%;
  }
  .MaterialsandApplications-col2 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .MaterialsandApplications-col {
    margin-right: 0px;
  }
  .Materials {
    margin-right: 0px !important;
  }
  .Applications {
    margin-right: 0px !important;
  }
}
@media (max-width: 576px) {
  .MaterialsandApplications {
    margin: 0px 30px;
  }
  .MaterialsandApplications {
    margin-bottom: 50px;
  }
  .ProductSliderContent {
    margin: 0px 30px;
  }
}
.Materials {
  margin-top: 90px;
  margin-right: 130px;
}

.Materials-title {
  font-size: 22px;
  color: #000000;
  font-weight: bold;
}

.Materials-sub {
  font-size: 17px;
  color: #000000;
}

.Applications {
  margin-top: 90px;
  margin-right: 130px;
}

.Applications-title {
  font-size: 22px;
  color: #000000;
  font-weight: bold;
}

.Applications-sub {
  font-size: 17px;
  color: #000000;
}

.MaterialsandApplications-btn {
  cursor: pointer;
  padding: 20px 0px;
}

.GalleryImages {
  margin-top: 80px;
}

.GalleryBtn {
  margin-top: 35px;
  margin-bottom: 75px;
}
.GalleryBtn a {
  cursor: pointer;
}

.MainNews {
  margin-top: 55px;
}

.MainNews-news {
  margin-top: 35px;
}

.MainNews-news-img {
  width: 100%;
}

.MainNews-news-con {
  background: #F1F1F1;
  position: relative;
}

.MainNews-news-con-news {
  margin-left: 38px;
  margin-top: 58px;
}

.MainNews-news-con-news-title {
  padding-right: 100px;
}

.MainNews-news-con-news-det {
  padding-right: 69px;
}

.News2 {
  margin-top: 35px;
}

.News2:first-child {
  margin-top: 0;
}

.NewsDate {
  color: #14446F;
  font-size: 14px;
  bottom: 45px;
  position: absolute;
}

.MainNews-div {
  background: #EFF7FF;
  border-radius: 20px;
}

.MainNews-Related {
  padding-left: 72px;
}

.MainNews-title {
  border-bottom: rgba(0, 42, 133, 0.5294117647) solid 2px;
  margin: 20px 20px;
  margin-top: 48px !important;
  padding: 10px 20px;
  margin-right: 40px;
}

.MainNews-sub-div {
  margin-top: 20px;
  margin-bottom: 40px;
  margin-right: 40px;
}

.MainNews-sub {
  margin-left: 40px;
  line-height: 35px;
  margin-top: 15px;
  padding-bottom: 15px;
  border-bottom: rgba(0, 42, 133, 0.5294117647) solid 1px;
}

.MainNews-sub:last-child {
  border-bottom: none !important;
}

.SubNews {
  margin-top: 35px;
}

.SubNews-col {
  padding-right: 25px !important;
  display: grid !important;
}

.SubNews-con {
  background: #F1F1F1;
  position: relative;
}

.productslide-img {
  cursor: pointer;
}

.open-modal {
  padding: 1px 6px;
  background-color: #002B85;
  color: white;
  border-color: #002B85;
  right: 10px;
  position: absolute;
}

.open-modal:hover {
  background-color: #FF5C00;
  border-color: #FF5C00;
}

.ril__navButtons {
  width: 8px !important;
  height: 18px !important;
  padding: 25px 15px !important;
}

.pslide {
  width: 40% !important;
  margin-top: 10% !important;
  margin-right: auto !important;
  margin-left: 30% !important;
}

.ReactModal__Content--after-open {
  width: 100%;
  display: block !important;
}

.ReactModal__Content--after-open img {
  width: 600px !important;
  height: 400px !important;
  display: block !important;
  margin: auto !important;
  transform: none !important;
}

.ril__outer {
  background-color: rgba(0, 0, 0, 0.568627451) !important;
}

.ril-zoom-in {
  display: none;
}

.ril-zoom-out {
  display: none;
}

.ril-errored {
  display: none !important;
}

.ReactModalPortal {
  position: fixed !important;
  z-index: 111111111 !important;
}

.SubNews-con-det {
  margin-left: 40px;
  padding-top: 35px;
  padding-bottom: 40px;
}

.SubNews-con-title {
  margin-right: 80px;
}

.SubNews-con-desc {
  margin-right: 58px;
  margin-bottom: 37px;
}

.SubNewsDate {
  color: #14446F;
  font-size: 14px;
  bottom: 5px;
  position: absolute;
}

.SubNews-img {
  height: 236px;
  width: 100%;
}
@media (min-width: 1400px) and (max-width: 1920px) {
  .SubNews-img {
    height: 330px;
  }
}

.pagination {
  margin-top: 35px;
  display: flex;
  padding-left: 0;
  list-style: none;
  justify-content: center;
  margin-bottom: 70px;
}

.pagination .disable {
  background: #F1F1F1;
  border-radius: 25px;
  padding: 13px;
  margin-right: 10px;
  pointer-events: none;
}
.pagination .blocks {
  background: #F1F1F1;
  border-radius: 50%;
  padding: 13px;
  margin-left: 10px;
  margin-right: 10px;
}
.pagination a {
  text-decoration: none;
  color: #002B85 !important;
  cursor: pointer;
}
.pagination .active {
  background: #002B85 !important;
  border-radius: 10px !important;
  color: #FFFFFF !important;
  padding: 15px;
  width: 51px;
  height: 50px;
}

.GetinTouch-icons-con li {
  list-style: none;
}

.pagenumber {
  background: #F1F1F1;
  padding-left: 60px;
  padding-right: 60px;
  padding-top: 13px;
  padding-bottom: 0px;
  border-radius: 25px;
  text-align: center;
}
.pagenumber .blocks {
  background: #F1F1F1;
  border-radius: 25px;
  padding: 15px;
  width: 51px;
  height: 50px;
}

@media (min-width: 992px) and (max-width: 1200px) {
  .MainNews-news-con-news {
    margin-left: 38px;
    margin-top: 20px;
  }
  .MainNews-news-con-news-title {
    font-size: 20px;
  }
  .NewsDate {
    color: #14446F;
    font-size: 14px;
    bottom: 10px;
    position: absolute;
  }
  .MainNews-sub {
    font-size: 14px;
  }
  .MainNews-title {
    border-bottom: rgba(0, 42, 133, 0.5294117647) solid 2px;
    margin: 20px 20px;
    margin-top: 22px !important;
    padding: 10px 20px;
    margin-right: 40px;
    font-size: 19px;
  }
}
@media (max-width: 992px) {
  .NewsDate {
    color: #14446F;
    font-size: 14px;
    bottom: 10px !important;
    position: absolute;
  }
  .MainNews-Related {
    padding-left: 0px;
  }
  .MainNews-div {
    background: #EFF7FF;
    border-radius: 20px;
    margin-top: 50px;
  }
}
@media (max-width: 767px) {
  .MainNews-news-con-news {
    margin-left: 38px;
    margin-top: 56px;
    padding-bottom: 101px !important;
  }
  .SubNews-col {
    padding-right: 0px !important;
    margin-top: 30px;
  }
  .pagination {
    margin-top: 35px;
    display: flex;
    padding-left: 0;
    list-style: none;
    justify-content: center;
    margin-bottom: 70px;
  }
  .pagination .disable {
    margin-right: 5px;
  }
  .pagination .blocks {
    background: #F1F1F1;
    border-radius: 50%;
    padding: 10px;
    margin-left: 10px;
  }
  .pagination .active {
    background: #002B85 !important;
    border-radius: 10px !important;
    color: #FFFFFF !important;
    padding: 5px;
    width: auto;
    height: auto;
  }
  .pagenumber {
    background: #F1F1F1;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 0px;
    border-radius: 25px;
    text-align: center;
  }
  .pagenumber .blocks {
    background: #F1F1F1;
    border-radius: 25px;
    padding: 2px;
    width: auto;
    height: auto;
  }
}
.CurrentOpportunities-main-title {
  margin-top: 50px;
}

.CurrentOpportunities-sub-title {
  color: #404040;
  font-size: 24px;
  margin-top: 40px;
}

.CurrentOpportunities-list {
  margin-top: 50px;
  margin-left: 25px;
  margin-right: 20px;
}

.CurrentOpportunities-div1 {
  padding-right: 25px;
  margin-bottom: 50px;
  display: flex;
}

.CurrentOpportunities-div2 {
  padding-left: 25px;
  margin-bottom: 50px;
}

.CurrentOpportunities-list-div {
  border: 1px solid #002B85;
  border-radius: 20px;
}

.CurrentOpportunities-list-div-con {
  margin: 30px;
  margin-bottom: 20px;
}
.CurrentOpportunities-list-div-con .txt20 {
  font-weight: 500;
}

.CurrentOpportunities-exp {
  font-weight: bold;
  font-size: 14px;
}

.CurrentOpportunities-cont {
  color: #002B85;
  font-weight: 600;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 30px;
}

.CurrentOpportunities-det {
  color: #555555;
  font-size: 14px;
  margin-bottom: 24px;
}

.Applyform-bg {
  background: #EFF7FF;
  border-radius: 20px;
  margin-bottom: 80px;
}

.Applyform-cont {
  padding-left: 110px;
  padding-right: 110px;
  padding-top: 85px;
  padding-bottom: 90px;
}

.Applyform-cont input {
  border: none;
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  color: #959595;
  font-size: 14px;
}
.Applyform-cont label {
  color: #555555;
  font-size: 16px;
}
.Applyform-cont .form-group {
  margin-top: 25px;
}
.Applyform-cont .btn4 {
  width: 185px;
  height: 52px;
  padding: 0;
  float: right;
  margin-top: inherit;
}
.Applyform-cont .trashbin {
  float: right;
  margin-right: 20px;
  margin-top: 30px;
}
.Applyform-cont .delete {
  color: #555555;
  font-size: 16px;
}

.file-upload {
  border: none;
}

.image-upload {
  text-align: center !important;
}
.upload-img {
  opacity: 0.2;
  width: 122px;
  height: 100px;
}

@media (max-width: 1200px) {
  .upload-img {
    padding-left: 20px;
    opacity: 0.2;
    width: 96px;
    height: 68px;
  }
  .file-drop-target {
    display: flex;
  }
  .progress {
    width: 75% !important;
  }
}
@media (max-width: 992px) {
  .progress {
    width: 50% !important;
  }
}
.brow {
  color: #002B85;
  font-size: 14px;
}

.DD {
  font-size: 14px;
}

.CurrentOpportunities {
  overflow-x: hidden;
}

@media (max-width: 458px) {
  .CurrentOpportunities-list-div-content {
    display: block !important;
  }
}
@media (max-width: 575px) {
  .Applyform-cont {
    padding-left: 51px;
    padding-right: 49px;
  }
}
@media (min-width: 768px) and (max-width: 992px) {
  .CurrentOpportunities-list-row {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
  }
  .CurrentOpportunities-div2 {
    padding-left: 0;
    padding-right: 0;
    width: 500px;
  }
  .CurrentOpportunities-div1 {
    padding-left: 0;
    padding-right: 0;
    width: 500px;
  }
}
@media (max-width: 1200px) {
  .CurrentOpportunities-div2 {
    padding-left: 0;
    margin-bottom: 50px;
  }
}
@media (max-width: 768px) {
  .CurrentOpportunities-div2 {
    padding-left: 0;
    padding-right: 0;
  }
  .CurrentOpportunities-div1 {
    padding-left: 0;
    padding-right: 0;
  }
}
.popup-content {
  width: 100% !important;
  left: 0 !important;
}

.Novacancy-div {
  position: relative;
}

.Novacancy-img {
  width: 100%;
}

.Novacancy-text {
  position: absolute;
  z-index: 222;
  font-size: 24px;
  color: #101010;
  text-align: center;
  bottom: 0;
}

.Novacancy a {
  font-size: 14px;
  width: 200px;
  text-align: center;
}

.ttlvac {
  margin-top: 30px;
}

.Novacancy-cv {
  margin-top: 26px;
}
@media (max-width: 483px) {
  .Novacancy-cv {
    margin-top: 20px;
  }
}

input::file-selector-button {
  display: none;
}

.Novacancy-cv-det {
  margin-left: 25px;
  font-size: 20px;
  color: #4E4E4E;
  font-weight: 500;
}
.Novacancy-cv-det a {
  margin-right: 25px;
  text-decoration: none;
  font-size: 20px;
  color: #002b85;
  font-weight: 500;
}
@media (max-width: 483px) {
  .Novacancy-cv-det {
    margin-right: 11px;
    margin-bottom: 10px !important;
  }
}

.Novacancy {
  margin-bottom: 100px;
}
@media (max-width: 483px) {
  .Novacancy {
    margin-bottom: 40px;
  }
}

@media (max-width: 483px) {
  .Novacancy-text {
    font-size: 16px;
  }
}
.contact {
  margin-top: 60px;
  margin-bottom: 60px;
}

.GetinTouch {
  background: #002B85;
  border-radius: 20px 0px 0px 20px;
}

.Connectwithus {
  background: #EFF7FF;
  border-radius: 0px 20px 20px 0px;
}

.GetinTouch-data {
  margin-left: 64px;
  margin-top: 68px;
}

.GetinTouch-data-Title {
  font-size: 40px;
  font-family: Centrale Sans Bold;
  font-weight: bold;
  color: #FFFFFF;
}

.GetinTouch-data-txt {
  font-size: 16px;
  color: #FFFFFF;
}

.GetinTouch-data-info {
  margin-top: 54px;
  margin-left: 64px;
}

.GetinTouch-icons {
  width: 54px;
  height: 54px;
  display: block;
  cursor: pointer;
}

.GetinTouch-icons:hover {
  display: none;
}

.GetinTouch-icons:hover + .GetinTouch-icons-new {
  display: block !important;
}

.GetinTouch-icons-new {
  cursor: pointer;
  display: none;
  width: 54px;
  height: 54px;
}

.icon-type {
  font-size: 16px;
  color: #FFFFFF;
}

.icon-data {
  font-size: 20px;
  color: #FFFFFF;
}

.GetinTouch-icons-con {
  padding-left: 10px;
}

.Connectwithus-data {
  margin-top: 45px;
  margin-left: 87px;
}

.Connectwithus-data-Title {
  font-size: 30px;
  color: #002B85;
  font-weight: bold;
}

.Connectwithus-data {
  margin-right: 90px;
}
.Connectwithus-data input {
  border: none;
  border-radius: 10px;
  height: 48px;
  font-size: 14px;
  color: #A2A9B0;
  margin-top: 10px;
}
.Connectwithus-data label {
  color: #555555;
  font-size: 16px;
}
.Connectwithus-data .form-group {
  margin-top: 15px;
}
.Connectwithus-data form {
  margin-top: 25px;
}

.contactsub {
  width: 185px;
  height: 52px;
  padding: 0;
  margin-top: 30px;
}

.contactsub-div {
  margin-bottom: 120px;
}

@media (max-width: 992px) {
  .GetinTouch {
    background: #002B85;
    border-radius: 20px;
  }
  .Connectwithus {
    background: #EFF7FF;
    border-radius: 20px;
    margin-top: 20px;
  }
}
@media (max-width: 575px) {
  .contactus {
    margin: 20px;
  }
  .icon-data {
    font-size: 13px;
  }
  .GetinTouch-data-info {
    margin-left: 20px;
  }
  .GetinTouch-data {
    margin-left: 20px;
  }
  .Connectwithus-data {
    margin-right: 20px;
    margin-left: 10px;
  }
  .captcha {
    display: block !important;
  }
}
.Feedback {
  margin-top: 100px;
}

.Feedback-form {
  margin-left: 80px;
  margin-top: 90px;
  margin-right: 80px;
  margin-bottom: 100px;
}
.Feedback-form .form-group {
  margin-top: 30px;
}
.Feedback-form label {
  margin-top: 10px;
  color: #555555;
  font-size: 16px;
  font-weight: 600;
}
.Feedback-form input {
  background: #F1F1F1;
  border: none;
  border-radius: 10px;
  height: 48px;
}
.Feedback-form textarea {
  background: #F1F1F1;
  border: none;
  border-radius: 10px;
  height: 218px;
}
.Feedback-form .btn4 {
  width: 200px;
  padding: 14px !important;
}

.filled-icons {
  color: #FF5C00 !important;
}

.Feedback-img {
  height: 100%;
}

.Feedback-img1 {
  display: none;
}

@media (max-width: 767px) {
  .Feedback-img {
    display: none;
  }
  .Feedback-img1 {
    display: block;
  }
}
@media (max-width: 992px) {
  .Feedback-form {
    margin-left: 50px;
    margin-right: 30px;
  }
}
.Enquiry {
  margin-top: 150px;
  margin-bottom: 80px;
}

.Enquiry-form {
  margin-left: 80px;
  margin-right: 80px;
}

.Enquiry-img {
  height: 100%;
}

.Enquiry-img1 {
  display: none;
}

.Enquiry-form-div {
  margin-top: 25px;
}
.Enquiry-form-div input {
  background: #F1F1F1;
  border: none;
  border-radius: 10px;
  height: 48px;
  margin-top: 10px;
  font-size: 10px;
}
.Enquiry-form-div label {
  color: #555555;
  font-size: 16px;
  font-weight: 500;
  margin-top: 30px;
}
.Enquiry-form-div textarea {
  background: #F1F1F1;
  border: none;
  border-radius: 10px;
  height: 215px;
}
.Enquiry-form-div .btn4 {
  padding: 14px;
  width: 200px;
}

.Enq-Btns {
  margin-top: 30px;
}

.btn6 {
  background-color: #FF5C00;
  border: none;
  border-radius: 10px;
  color: #FFFFFF;
  padding: 14px;
  width: 228px;
}

.Dowbtn {
  margin-left: 30px;
}

@media (max-width: 1200px) {
  .Enquiry-form {
    margin-left: 50px;
    margin-right: 50px;
  }
}
@media (min-width: 768px) and (max-width: 992px) {
  .btn6 {
    width: 205px;
  }
  .Enquiry-form-div .btn4 {
    width: 145px;
  }
  .Dowbtn {
    margin-left: 15px;
  }
  .Enquiry-form-div textarea {
    height: 158px;
  }
  .Enquiry-form-div label {
    margin-top: 15px;
  }
}
@media (max-width: 767px) {
  .Enquiry-img {
    /* height: 100%; */
    display: none;
  }
  .Enquiry-img1 {
    display: block;
  }
}
@media (max-width: 580px) {
  .Enq-Btns {
    display: block !important;
  }
  .sendbtn {
    text-align: center;
  }
  .Dowbtn {
    text-align: center;
    margin-left: 0;
    margin-top: 20px;
  }
}
.Clientele {
  margin-top: 50px;
}

.ProductsList-image-col a {
  text-decoration: none;
}

.our-pro a {
  text-decoration: none;
}

.clients-list:last-child {
  border-bottom: none;
}

.clients-div {
  margin: 30px 0px;
}

.clients-div:nth-child(4n) .clients-div-logo {
  border-right: none !important;
}

.clients-div:last-child {
  border-right: none;
}

.clients-div-logo {
  margin: 15px;
}

.clients-div-logo-img {
  width: 100%;
  padding-right: 40px;
}

@media (max-width: 767px) {
  .clients-div:nth-child(2) {
    border-right: none;
  }
}
@media (max-width: 576px) {
  .clients-div {
    margin: 0px 0px;
    border-right: none;
  }
  .clients-list {
    margin: 0px 0px;
    border-bottom: none;
  }
  .clients-div-logo {
    border-bottom: #002B85 2px solid;
  }
}
.btn7 {
  position: relative;
  display: block;
  width: 200px;
  height: 50px;
  color: white !important;
  background: transparent;
  border-radius: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: 2px solid #FFFFFF !important;
  z-index: 20;
  transition: all 0.35s cubic-bezier(1, 0, 0, 1);
}

.btn7:hover {
  color: #fcfcfc;
  border: none !important;
}

.btn7-color {
  border-color: #ffffff;
  color: #FFFFFF;
}

.btn7-color::before, .btn7-color::after {
  border-radius: 10px;
  border-color: #00A1ED !important;
  border: none !important;
  background: #00A1ED;
}

.btn7::before,
.btn7::after {
  content: "";
  position: absolute;
  z-index: -1;
  transition: all 0.35s cubic-bezier(1, 0, 0, 1);
}

.btn7-l-r::after {
  height: 100%;
  width: 0;
  top: 0;
}

.btn7-l-r:hover::after {
  width: 100%;
}

.btn7-l-r::after {
  left: 0;
}

#canv {
  width: 140px !important;
}

/*** Modified On: 16/11/2022 ***/
.footer-top .logo {
  width: auto;
}

@media (max-width: 1199px) {
  .tail-row .col-md-7,
  .tail-row .col-md-5 {
    width: 100%;
  }
  .footer-text {
    display: flex;
    align-items: center;
  }
}
@media (max-width: 1199px) and (max-width: 480px) {
  .footer-text {
    text-align: center;
    display: grid;
    float: inherit !important;
  }
}
@media (max-width: 991px) {
  .MainNews-news-con-news {
    margin-left: 25px;
  }
  .MainNews-news-con-news-title, .MainNews-news-con-news-det {
    padding-right: calc(var(--bs-gutter-x) * 0.5) !important;
  }
  .SubNews-con-det {
    margin-left: 0;
    padding-top: 15px;
    padding-bottom: 30px;
    padding-right: calc(var(--bs-gutter-x) * 0.5) !important;
    padding-left: calc(var(--bs-gutter-x) * 0.5) !important;
  }
  .SubNews-con-title, .SubNews-con-desc {
    margin-right: 0px;
  }
  .productslide-img {
    width: 100%;
    height: 400px;
  }
}
@media (max-width: 767px) {
  .navbar {
    padding: 10px !important;
  }
  .header-container {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .Header-logo {
    margin-left: 0px;
  }
  .intro .txt1 {
    font-size: 17px;
  }
  .nav-product {
    height: auto;
    padding: 5px 10px;
  }
  .nav-product a {
    font-size: 14px;
  }
  .menu1 {
    padding-right: 7px;
    margin-top: 0px;
  }
  .menu1 svg {
    width: 18px;
  }
  .navbar-toggler {
    padding: 0.15rem 0.5rem;
    font-size: 1rem;
  }
  .navbar-nav .pro {
    padding: 10px 0px !important;
  }
  .navbar-nav .pro p {
    padding-bottom: 0.5rem !important;
    margin-bottom: 0.5rem !important;
    border-bottom: 0px solid #dee2e6 !important;
  }
}
@media (max-width: 767px) and (max-width: 480px) {
  .navbar-nav .pro p {
    width: 91%;
    margin-left: auto;
    margin-right: auto;
    background: #002B85;
    border-radius: 4%;
  }
}
@media (max-width: 767px) {
  .about-us {
    padding-top: 40px;
    margin-top: 0px;
  }
  .slick-slider .slick-dots {
    bottom: 0px;
    top: 50%;
  }
  .intro {
    top: auto !important;
    margin-left: 30px;
    bottom: 22%;
  }
  .intro a {
    padding-top: 0rem !important;
  }
  .about-us .banner-txt {
    margin-top: 15px;
  }
  .txt2.mt-4 {
    margin-top: 0.5rem !important;
    line-height: 25px;
  }
  .px-5, .aboutimg-div {
    padding-right: 15px !important;
    padding-left: 15px !important;
  }
  .txt3.mt-4, .btn2-color {
    margin-top: 0.5rem !important;
  }
  .mob-mt-2 {
    margin-top: 35px !important;
    padding-bottom: 35px !important;
  }
  .mob-mt-2 .data1.mt-5 {
    margin-top: 1rem !important;
  }
  .banner-txt-Dev {
    width: 50%;
    height: 0px;
  }
  .development-support {
    margin: 30px 0;
  }
  .btn2.btn2-color {
    width: 165px;
    height: 40px;
    font-size: 15px;
  }
  .development-support .p-5, .Our_Ser .p-5 {
    padding: 1rem !important;
  }
  .txt2 {
    font-size: 17px;
    margin-bottom: 10px;
  }
  .txt6 {
    padding-left: 50px;
    font-size: 16px;
  }
  .Our_Ser {
    padding-left: 0px;
  }
  .Ser_slid img {
    height: auto;
    padding-top: 0px;
    width: auto !important;
  }
  .py-5.our-Ser-title {
    padding-top: 1rem !important;
    padding-bottom: 2rem !important;
  }
  .py-5.our-Ser-title .offset-3 {
    margin-left: 0;
    padding: 0 15px !important;
  }
  .banner-txt-Ser {
    padding-top: 10px;
  }
  .our-products {
    margin-left: 0px;
  }
  .our-products .txt2 {
    padding-left: calc(var(--bs-gutter-x) * 0.5) !important;
    margin-top: 0.5rem !important;
    line-height: 25px;
  }
  .our-products .mt-5 {
    margin-top: 1rem !important;
  }
  .our-products .mt-3 {
    margin-top: 0rem !important;
  }
  .our-products .center.mt-5 {
    margin-top: 0rem !important;
  }
  .our-products .txt3 {
    padding: 0 15px !important;
  }
  .our-products .our-pro {
    padding-right: calc(var(--bs-gutter-x) * 0.5) !important;
    padding-left: calc(var(--bs-gutter-x) * 0.5) !important;
  }
  .our-products .our-pro-con {
    padding: 10px 5px !important;
    font-size: 15px;
  }
  .latest_news {
    margin-left: 0%;
  }
  .latest_news .btn2-color.btn2-l-r {
    margin-top: -20px !important;
  }
  .latest_news .mt-5 {
    margin-top: 1rem !important;
  }
  .latest_news .news-img {
    padding: 10px !important;
    margin: 0rem !important;
    width: 100%;
    height: auto;
  }
  .contact-us.mt-5 {
    margin-top: 1rem !important;
  }
  .contact-us.mt-5 .banner-txt-contact {
    margin-left: 25px;
  }
  .contact-us.mt-5 .m-5 {
    margin: 1rem !important;
  }
  .contact-us.mt-5 .txt11 {
    font-size: 17px;
    margin-bottom: 10px;
  }
  .contact-us.mt-5 .txt12 {
    font-size: 15px;
    padding-top: 2px !important;
  }
  .contact-us.mt-5 .btn7 {
    margin-top: 0.5rem !important;
  }
  .contact-us.mt-5 .contact-us-bg img {
    max-width: 100%;
    margin-top: 10%;
  }
  .footer-top .container {
    padding-top: 35px;
    padding-bottom: 30px;
  }
  .footer-top .container .foot-logo {
    padding: 0 15px !important;
    margin-left: 0px;
    margin-bottom: 10px;
  }
  .footer-top .container .foot-logo p {
    margin-bottom: 10px;
  }
  .footer-top .container .list {
    padding-top: 5px;
  }
  .footer-bottom .footer-img {
    margin-left: 0px;
  }
  .Def-banner {
    margin-top: 0;
  }
  .Def-banner .Def-banner-text {
    font-size: 20px;
    font-weight: bold;
  }
  .Def-banner-image {
    height: 250px;
  }
  .since-row-p5 {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
  }
  .since-row-p5 .since-top-link-text {
    margin: 10px 0px;
  }
  .since-row-p5 .since-top-link-text .since-top-links {
    margin: 10px 0px;
  }
  .since-con {
    margin-top: 40px;
  }
  .since-con .since-img {
    padding-right: calc(var(--bs-gutter-x) * 0.5) !important;
    padding-left: calc(var(--bs-gutter-x) * 0.5) !important;
  }
  .since-title {
    margin-top: 1.5rem !important;
    line-height: 25px;
    font-size: 17px;
    margin-bottom: 10px;
    padding: 0px;
  }
  .since-desc {
    padding-left: 0px;
    margin-top: 10px;
  }
  .CompanyProfile-img, .QualityAssurance, .WordsfromtheCEO, .CustomManufacturing, .TurnkeyProjects, .GalleryImages, .MainNews, .ProductSliderContent-title, .Materials {
    margin-top: 40px;
  }
  .CompanyProfile-con {
    padding-top: 1.5rem !important;
    padding-top: 1.5rem !important;
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
  }
  .CompanyProfile-img-overly, .MainNews .p-0, .SubNews-col, .ProductSliderContent-col1, .ProductSliderContent-col2 {
    padding-right: calc(var(--bs-gutter-x) * 0.5) !important;
    padding-left: calc(var(--bs-gutter-x) * 0.5) !important;
  }
  .CompanyProfile-img-overly:before {
    left: 10px;
    width: 96%;
    border-radius: 5px;
    margin-top: 40px;
  }
  .Com-Profile-con {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .profile-txt {
    margin-bottom: 0px;
    margin-left: 30px;
    font-size: 18px;
  }
  .QualityAssurance-con {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
    margin-left: 0px;
    margin-top: 1.5rem !important;
  }
  .TrinityHoldingsSubsidiaries-con, .TrinityHoldingsSubsidiaries, .ConsultingDesign {
    margin-top: 10px;
  }
  .WordsfromtheCEO-con-det {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
  }
  .WordsfromtheCEO-con-det .WordsfromtheCEO-con {
    margin-left: 0px;
  }
  .WordsfromtheCEO-con-det .WordsfromtheCEO-con .txt14 {
    font-size: 17px;
  }
  .OurTeam-about {
    margin: 10px 0px;
  }
  .OurTeam-about .txt16 {
    font-size: 24px;
    margin-bottom: 0px;
  }
  .OurTeam-about .OurTeam-about-img img {
    width: 100%;
    height: auto;
  }
  .OurTeam-about .OurTeam-about-con-det {
    padding: 15px;
  }
  .OurClients-con {
    padding: 40px 15px 0;
  }
  .OurClients-con .txt11 {
    font-size: 24px;
  }
  .OurClients-con .OurClients-div {
    margin-bottom: 50px;
  }
  .OurClients-con .OurClients-div .m-5 {
    margin: 0rem !important;
  }
  .OurClients-con .OurClients-logo, .OurClients-con .Clientslogo {
    padding: 0 !important;
    margin: 0;
  }
  .OurClients-con .OurClients-logo:nth-child(7) {
    border-bottom: #002B85 solid 0px !important;
  }
  .Solutions-banner-image {
    height: 300px;
    margin-top: 0;
  }
  .Solutions-banner-text {
    bottom: 5%;
  }
  .Solutions-banner-text .Solutions-banner-text-title {
    font-size: 17px;
    font-weight: bold;
  }
  .Solutions-banner-text .Solutions-banner-text-sub {
    font-size: 18px;
  }
  .Solutions-content {
    margin: 0 15px;
  }
  .CustomManufacturing-txt {
    margin-top: 10px;
    padding-right: 0px;
  }
  .CustomManufacturing-title {
    margin-top: 0.5rem !important;
    line-height: 25px;
  }
  .Hire {
    margin-top: 0px;
  }
  .Hire .Hire-title {
    margin-top: 0.5rem !important;
    line-height: 25px;
  }
  .Hire .Hire-image-con {
    padding: 0;
  }
  .TurnkeyProjects-con {
    margin-top: 10px;
  }
  .TurnkeyProjects-con .TurnkeyProjects-title {
    margin-top: 0.5rem !important;
    line-height: 25px;
  }
  .DewateringTechniques {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .DewateringTechniques .DewateringTechniques-txt {
    margin-top: 10px;
  }
  .DewateringTechniques .ConsultingDesign-title {
    margin-top: 0.5rem !important;
    line-height: 25px;
  }
  .GalleryBtn {
    margin-top: 25px;
    margin-bottom: 50px;
  }
  .contact {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .GetinTouch-data {
    margin-left: 0px;
    margin-top: 20px;
  }
  .GetinTouch-data-Title, .Connectwithus-data-Title, .MainNews-news-con-news-title, .SubNews-con-title {
    margin-top: 0.5rem !important;
    line-height: 25px;
    font-size: 17px;
    margin-bottom: 10px;
  }
  .GetinTouch-data-txt {
    font-size: 16px;
    color: #FFFFFF;
  }
  .GetinTouch-data-info {
    margin-top: 25px;
  }
  .Connectwithus-data {
    margin-top: 30px;
  }
  .Connectwithus-data input {
    height: 35px;
    margin-top: 5px;
  }
  .Connectwithus-data .contactsub {
    width: 160px;
    height: 45px;
  }
  .News2, .MainNews-div {
    margin-top: 20px;
    padding-right: 0;
  }
  .MainNews .txt2 {
    font-size: 19px;
  }
  .MainNews .txt8 {
    font-size: 15px;
    line-height: 28px;
  }
  .MainNews .txt22 {
    font-size: 15px;
  }
  .MainNews-title {
    margin: 20px 20px;
    margin-top: 20px !important;
    font-size: 19px;
  }
  .MainNews-news {
    margin-top: 15px;
  }
  .MainNews-news-con-news {
    margin-left: 0px;
    margin-top: 10px;
    padding-bottom: 50px !important;
  }
  .MainNews-news-con-news .MainNews-news-con-news-title, .MainNews-news-con-news .MainNews-news-con-news-det {
    padding-right: 0px;
  }
  .MainNews-sub-div {
    margin-bottom: 20px;
  }
  .MainNews-sub-div span.txt20 {
    line-height: 50px;
  }
  .SubNews {
    margin-top: 10px;
  }
  .SubNews .SubNews-img {
    height: auto;
  }
  .SubNews .pagination {
    padding-right: 0;
  }
  .SubNews-con-det {
    margin-left: 0px;
    padding-top: 0px;
    padding-bottom: 30px;
  }
  .SubNews-con-det .SubNews-con-title {
    margin-right: 0px;
  }
  .feature img {
    width: auto;
    height: auto !important;
  }
}
@media (max-width: 580px) {
  .MaterialsandApplications-col {
    flex-direction: column;
  }
  .ProductSliderContent {
    margin: unset;
    margin-top: 100px;
  }
  .MaterialsandApplications {
    margin: 0px 15px;
  }
  .MaterialsandApplications-title {
    margin: 20px 0px;
    margin-top: 0px !important;
    padding: 10px 10px;
    margin-right: 0px;
    margin-top: 0.5rem !important;
    line-height: 25px;
    font-size: 17px;
    margin-bottom: 10px;
  }
  .MaterialsandApplications-sub-div {
    margin-right: 0px;
  }
  .MaterialsandApplications-sub-div RelatedProducts-sub {
    margin: 10px 15px;
  }
}
@media (max-width: 520px) {
  .tail ul li {
    padding: 0;
    width: 25%;
  }
  .tail-row-logo {
    display: flex !important;
    flex-direction: column;
  }
  .footer-text {
    margin-bottom: 1rem;
  }
  .CompanyProfile-img-overly:before {
    width: 95%;
  }
  .profile-icon {
    width: 65px;
    height: 65px;
  }
  .since-row-p5 .since-top-link-text .since-top-links {
    margin: 5px 0px;
  }
  .since-row-p5 .since-top-link-text .since-top-links a {
    font-size: 14px;
  }
  .Solutions-banner-text .Solutions-banner-text-sub {
    font-size: 14px;
  }
  .productslide-img {
    width: 100%;
    height: 250px;
    object-fit: contain;
  }
}
@media (max-width: 370px) {
  .banner-title {
    margin-left: 10px;
  }
  .our-products img {
    width: 100% !important;
    height: 130px !important;
  }
  .tail ul li {
    width: 33.333%;
  }
  .CompanyProfile-img-overly:before {
    width: 94%;
  }
  .profile-icon {
    width: auto;
    height: auto;
  }
  .company-profile .p-4 {
    padding: 1rem 0.5rem !important;
  }
  .banner-txt-Dev {
    width: 58%;
  }
  .Solutions-banner-text .Solutions-banner-text-title {
    margin-bottom: 10px !important;
  }
}
@media (max-width: 300px) {
  .tail ul li {
    width: 50%;
  }
  .CompanyProfile-img-overly:before {
    width: 92%;
  }
  .Solutions-banner-text {
    bottom: 0%;
  }
}
.design {
  background-color: #d4d4d4;
  padding: 12px 0;
}

.footer-text {
  color: #002B85;
  float: right;
  margin-bottom: 0;
}

.footer-text2 {
  color: #002B85;
}

.des p {
  color: #002B85;
  margin-bottom: 0;
}

.des p a {
  font-weight: bold;
  color: #002B85;
  text-decoration: none;
}

.imgs {
  border-radius: 20px;
}

.footer-top .logo {
  margin-left: -15px;
}

.tree {
  overflow-y: scroll;
}

.tree, .tree ul, .tree li {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
}

.tree {
  margin: 0 0 1em;
  text-align: center;
}

.tree, .tree ul {
  display: table;
}

.tree ul {
  width: 100%;
}

.tree li {
  display: table-cell;
  padding: 0.5em 0;
  vertical-align: top;
}

/* _________ */
.tree li:before {
  outline: solid 1px #666;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.tree li:first-child:before {
  left: 50%;
}

.tree li:last-child:before {
  right: 50%;
}

.tree code, .tree span {
  border: solid 0.1em #002B85;
  background: #002B85;
  color: white;
  width: 160px;
  border-radius: 4px;
  display: inline-block;
  font-size: 14px;
  margin: 0 0.3em 0.9em;
  padding: 0.4em 0.5em;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;
}

.tree code, .tree span:hover {
  background: #f28300;
  border: solid 0.1em #f28300;
}

/* If the tree represents DOM structure */
.tree code {
  font-family: monaco, Consolas, "Lucida Console", monospace;
}

/* | */
.tree ul:before,
.tree code:before,
.tree span:before {
  outline: solid 1px #666;
  content: "";
  height: 0.5em;
  left: 50%;
  position: absolute;
}

.tree ul:before {
  top: -0.5em;
}

.tree code:before,
.tree span:before {
  top: -0.55em;
}

/* The root node doesn't connect upwards */
.tree > li {
  margin-top: 0;
}

.tree > li:before,
.tree > li:after,
.tree > li > code:before,
.tree > li > span:before {
  outline: none;
}

.tree .head {
  background: #f28300;
  border: solid 0.1em #f28300;
}

.slick-current .productslide-img.pop {
  position: fixed !important;
  width: 100% !important;
  margin: 0 !important;
  height: 100% !important;
  z-index: 99999999999999 !important;
}

.attributed-text-segment-list__content {
  line-height: 1.5em !important;
  height: 3em !important;
  overflow: hidden !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/react-image-gallery/styles/scss/image-gallery.scss","webpack://./src/styles/main.scss"],"names":[],"mappings":"AAgBA;EACE,WAfS;EAgBT,6BAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,sCAAA;ACfF;ADiBE;EACE;IACE,cA1BI;ECWR;EDgBI;IACE,qBAAA;ECdN;AACF;ADkBE;EAEE,0BAAA;ACjBJ;;ADuBI;EACE,aAAA;ACpBN;;ADyBA;;EAEE,SAAA;EACA,aAAA;ACtBF;ADwBE;;EACE,YAAA;EACA,WAAA;ACrBJ;ADwBE;EAVF;;IAWI,aAAA;ECpBF;EDsBE;;IACE,YAAA;IACA,WAAA;ECnBJ;AACF;ADsBE;EAnBF;;IAoBI,aAAA;EClBF;EDoBE;;IACE,YAAA;IACA,WAAA;ECjBJ;AACF;;ADqBA;EACE,QAAA;AClBF;;ADqBA;EACE,OAAA;AClBF;;ADqBA;;EAEE,kBAAA;EACA,QAAA;EACA,2BAAA;AClBF;ADoBE;;EACE,aAAA;EACA,WAAA;ACjBJ;ADoBE;EACE;;IACE,YAAA;IACA,WAAA;ECjBJ;AACF;ADoBE;EACE;;IACE,YAAA;IACA,WAAA;ECjBJ;AACF;ADoBE;;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;ACjBJ;;ADqBA;EACE,OAAA;AClBF;;ADqBA;EACE,QAAA;AClBF;;ADsBA;EAtHI,yBAAA;EAAA,oBAAA;EAAA,iBAAA;EAwHF,6CA7He;EA8Hf,kBAAA;ACfF;ADiBE;EACE,gBApIO;EAqIP,SAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;ACfJ;ADiBI;EACE,QAAA;EACA,2BAAA;ACfN;;ADoBA;EACE,kBAAA;EACA,cAAA;EACA,MAAA;ACjBF;ADmBE;EACE,gBA3JO;AC0IX;ADoBE;EACE,8BAAA;AClBJ;ADuBI;EACE,iBAAA;ACrBN;;AD0BA;EACE,kBAAA;ACvBF;ADyBE;EAEE,qBAAA;EACA,yBAAA;ACxBJ;AD0BI;EALF;IAMI,wBAAA;ECvBJ;AACF;ADyBE;EACE,cAAA;ACvBJ;;AD2BA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;ACxBF;;AD2BA;EACE,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;ACxBF;AD0BE;EACE,kBAAA;ACxBJ;AD2BE;EACE,WAAA;EACA,mBAAA;ACzBJ;AD4BE;EACE,8BAjNkB;EAkNlB,YAAA;EACA,WAtNO;EAuNP,OAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AC1BJ;AD4BI;EAVF;IAWI,YAAA;IACA,gBAAA;IACA,iBAAA;ECzBJ;AACF;;AD8BA;EACE,YAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AC3BF;AD6BE;EACE,SAAA;EACA,UAAA;EACA,kBAAA;AC3BJ;AD8BE;EACE,gBAAA;EACA,6BAAA;EACA,sBAAA;EACA,kBAAA;EACA,6BArPQ;EAsPR,eAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;AC5BJ;AD8BI;EAbF;IAcI,aAAA;IACA,YAAA;EC3BJ;AACF;AD6BI;EAlBF;IAmBI,cAAA;EC1BJ;AACF;AD4BI;EACE,qBAAA;EACA,mBA3QI;EA4QJ,yBAAA;AC1BN;AD6BI;EACE,qBAAA;EACA,sBAAA;EACA,gBApRK;ACyPX;AD8BI;EACE;IACE,mBAvRE;IAwRF,yBAAA;EC5BN;ED+BI;IACE,mBA5RE;EC+PR;AACF;;ADkCA;EACE,kBAAA;AC/BF;ADiCE;EACE,mBAAA;AC/BJ;ADkCE;EACE,mBAAA;AChCJ;ADmCE;EACE,cAAA;ACjCJ;ADmCE;EAEE,qBAAA;EACA,mBAAA;EACA,YAAA;AClCJ;ADoCI;EANF;IAOI,WAAA;ECjCJ;AACF;ADmCI;EACE,YAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;ACjCN;ADmCM;EACE,cAAA;EACA,eAAA;EACA,UAAA;ACjCR;ADmCQ;EACE,cAAA;EACA,eAAA;ACjCV;ADyCE;EAEE,aAAA;ACxCJ;AD0CI;EAJF;IAKI,aAAA;ECvCJ;AACF;;AD2CA;EACE,gBAAA;EACA,cAAA;ACxCF;AD0CE;EAJF;IAKI,cAAA;ECvCF;AACF;ADyCE;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;ACvCJ;;AD4CA;EACE,qBAAA;EACA,6BAAA;EACA,gCAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;ACzCF;AD2CE;EARF;IASI,6BAAA;IACA,WAAA;ECxCF;AACF;AD0CE;EACE,gBAAA;ACxCJ;AD2CE;EACE,cAAA;EACA,kBAAA;ACzCJ;AD4CE;EACE,sBAAA;EACA,WAAA;EACA,cAAA;AC1CJ;AD6CE;EAEE,aAAA;EACA,yBAAA;AC5CJ;AD8CI;EALF;IAMI,yBAAA;EC3CJ;AACF;AD8CE;EACE;IACE,aAAA;IACA,yBAAA;EC5CJ;AACF;AD6CM;EAJF;IAKI,yBAAA;EC1CN;AACF;;ADgDA;EACE,sBAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,8BApaU;EAqaV,2BAAA;EACA,mBAAA;EACA,WAAA;AC7CF;AD+CE;EAdF;IAeI,gBAAA;IACA,kBAAA;EC5CF;AACF;;AD+CA;EACE,8BAlboB;EAmbpB,WAtbS;EAubT,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AC5CF;AD8CE;EAVF;IAWI,gBAAA;IACA,iBAAA;EC3CF;AACF;;AAvZA;EACE,kBAAA;EACE,uBAAA;AA0ZJ;;AAtZA;EACE,0BAAA;AAyZF;;AAvZA;EACE,wBAAA;AA0ZF;;AAxZA;EACG,wBAAA;AA2ZH;;AAzZA;EACE,kBAAA;AA4ZF;;AA1ZA;EAKI,kBAAA;EACA,iBAAA;EAEA,WAAA;AAwZJ;;AA9YA;EACE,4BAAA;AAiZF;;AA/YA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;AAkZF;;AAhZA;EACG,8BAAA;EACA,eAAA;AAmZH;;AAjZA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AAoZF;;AAjZA;EACE,4BAAA;AAoZF;;AAlZA;EACE,WAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AAqZF;;AAnZA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AAsZF;AArZE;EANF;IAOE,sBAAA;EAwZA;AACF;;AArZA;EACE;IACE,iBAAA;EAwZF;AACF;AAtZA;EACE;IACF,aAAA;EAwZE;AACF;AAtZA;EACI,cAAA;EACA,eAAA;EAEA,qBAAA;EACA,cAAA;AAuZJ;;AArZA;EACG,gBAAA;AAwZH;;AArZA;EACE,iBAAA;AAwZF;;AAtZA;EACE,mBAAA;EACA,gBAAA;AAyZF;;AApZA;EAEE,eAAA;EACA,aAAA;EACA,QAAA;EACA,8BAAA;AAsZF;;AApZA;EACE,aAAA;AAuZF;;AArZA;EACE,kBAAA;EACA,QAAA;AAwZF;;AArZA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AAwZJ;;AArZC;EACC,yBAAA;EACA,2BAAA;AAwZF;;AAtZC;EACK,yBAAA;AAyZN;;AAvZC;EACG,aAAA;EACA,mBAAA;EACA,8BAAA;AA0ZJ;;AAxZA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;AA2ZA;AAzZC;EACG,YAAA;EACA,qBAAA;AA2ZJ;;AAvZA;EAEE,gCAAA;EACA,cAAA;AAyZF;;AAtZA;EACE,yBAAA;AAyZF;;AAvZA;EACE,gCAAA;EACA,cAAA;AA0ZF;;AAxZA;EACE,YAAA;EACA,+BAAA;AA2ZF;;AAxZA;EACE,uEAAA;EACA,0BAAA;EACA,kCAAA;EACA,2BAAA;AA2ZF;AA1ZE;EACE,cAAA;EACA,mBAAA;AA4ZJ;AA1ZE;EACE,aAAA;AA4ZJ;;AAzZA;EACE,aAAA;AA4ZF;;AAxZA;EACE;IACE,iBAAA;EA2ZF;EAzZA;IAEE,YAAA;IACA,iBAAA;EA0ZF;EAxZA;IACE,YAAA;EA0ZF;AACF;AAxZA;EACE;IAEE,WAAA;IACA,YAAA;EAyZF;EAvZA;IACE,YAAA;EAyZF;AACF;AAvZA;EACE;IACE,iBAAA;IACA,eAAA;IACA,OAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;EAyZF;AACF;AA/YA;EACE,kBAAA;AAiZF;;AA9YA;EACE,6BAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;AAiZF;AAhZA;EALA;IAMA,mBAAA;EAmZE;AACF;;AAjZA;EACE,uBAAA;AAoZF;;AA5YA;EAEI,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA8YJ;;AA5YA;EACI,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA+YJ;;AA3YA;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;AA8YF;;AA5YA;EACE,iBAAA;AA+YF;;AA7YA;EACE,uBAAA;AAgZF;;AA7YA;EAGI,eAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AA8YJ;;AA3YE;EAEE,eAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AA6YJ;;AA7XA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EAEA,WAAA;EACA,8CAAA;AA+XJ;;AA5XE;EACE,cAAA;AA+XJ;;AA5XE;EACE,qBAAA;EACA,cAAA;AA+XJ;;AA7XE;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;AAgYJ;;AA7XE;;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,8CAAA;AAgYJ;;AA7XE;EACE,YAAA;EACA,QAAA;EACA,MAAA;AAgYJ;;AA7XE;EACE,WAAA;AAgYJ;;AA7XE;EACE,OAAA;AAgYJ;;AA3XE;EAGE,QAAA;EACA,WAAA;AA4XJ;;AA1XA;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AA6XJ;;AAxXA;EACI,wBAAA;AA2XJ;;AAzXA;EACI,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,oCAAA;EACA,sBAAA;AA4XJ;;AA1XA;EACI,oCAAA;AA6XJ;;AAxXA;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;AA2XJ;;AAzXA;EACE,cAAA;AA4XF;;AA1XA;EACE;IACE,4BAAA;IACA,6BAAA;EA6XF;AACF;AA1XA;EACE;IACE,aAAA;IACA,mBAAA;EA4XF;AACF;AA1XA;EACI,UAAA;EACA,mBAAA;EACA,WAAA;AA4XJ;;AAzXA;EACE,mBAAA;AA4XF;;AA1XA;EACE,gBAAA;AA6XF;;AAvXA;EACI,aAAA;AA0XJ;;AAxXA;EACI,cAAA;EACA,eAAA;AA2XJ;;AAxXE;EACE,yBAAA;EACA,eAAA;AA2XJ;AAzXA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AA2XF;;AAxXC;EACG,cAAA;EACA,eAAA;EACA,iBAAA;AA2XJ;;AAzXC;EAEG,eAAA;EACA,cAAA;EACA,iBAAA;AA2XJ;;AAxXC;EACI,cAAA;EAEA,iBAAA;EAEA,eAAA;AAyXL;;AAvXC;EACC,0BAAA;AA0XF;;AAxXC;EACI,cAAA;EACA,eAAA;AA2XL;;AAzXC;EACO,cAAA;EACA,eAAA;EACA,iBAAA;AA4XR;;AA1XC;EACI,cAAA;EACA,eAAA;AA6XL;;AA3XC;EACE,cAAA;EACC,eAAA;EACA,mBAAA;AA8XJ;;AA5XC;EACG,cAAA;EACA,eAAA;EACA,oBAAA;AA+XJ;;AA7XE;EACI,cAAA;EACA,eAAA;AAgYN;;AA7XE;EACE,iBAAA;AAgYJ;;AA9XE;EACE,cAAA;EACA,eAAA;AAiYJ;;AA/XE;EACE,cAAA;EACA,eAAA;AAkYJ;;AA/XC;EACC,cAAA;EAEA,iBAAA;EACA,eAAA;AAiYF;;AA/XA;EACE,cAAA;EACA,eAAA;AAkYF;;AA/XA;EACE,cAAA;EACA,eAAA;AAkYF;;AAhYA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAmYF;;AAjYA;EACE,cAAA;EACA,eAAA;AAoYF;;AAlYA;EACE,cAAA;EACA,eAAA;AAqYF;;AAnYA;EACE,cAAA;EACA,eAAA;AAsYF;;AApYA;EACE,cAAA;EACA,eAAA;AAuYF;;AArYA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAwYF;;AAtYA;EACE,cAAA;EACA,eAAA;AAyYF;;AAtYA;EACE,cAAA;EACA,eAAA;AAyYF;;AAvYA;EACE,eAAA;EACA,cAAA;AA0YF;;AAxYA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AA2YF;;AAxYC;EACG,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,8CAAA;AA2YJ;;AAxYE;EACE,cAAA;EACA,YAAA;AA2YJ;;AAxYE;EACE,qBAAA;EACA,cAAA;AA2YJ;;AAzYE;EACE,mBAAA;EACA,qBAAA;EAEA,YAAA;EAEA,mBAAA;AA0YJ;;AAvYE;;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,8CAAA;AA0YJ;;AAvYE;EACE,YAAA;EACA,QAAA;EACA,MAAA;AA0YJ;;AAvYE;EACE,WAAA;AA0YJ;;AAvYE;EACE,OAAA;AA0YJ;;AAvYE;EAEI,+BAAA;AAyYN;;AAvYE;EACE,kBAAA;AA0YJ;;AAxYE;EACE;IAEI,kBAAA;EA0YN;AACF;AApYE;EAEE,aAAA;EAGA,YAAA;EACA,YAAA;EACA,6CAAA;EACA,qBAAA;AAmYJ;;AAjYE;EACE,yBAAA;EACA,kBAAA;AAoYJ;;AAlYE;EACE;IACE,YAAA;EAqYJ;AACF;AAnYE;EACE;IACE,kBAAA;EAqYJ;AACF;AAlYE;EAEE,aAAA;EAGA,YAAA;EACA,YAAA;EACA,6CAAA;EACA,qBAAA;AAiYJ;;AA/XE;EACE,UAAA;EACA,iBAAA;AAkYJ;;AAhYE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AAmYJ;;AAjYE;EACE,yBAAA;AAoYJ;;AAlYA;EACE,iBAAA;AAqYF;;AAlYE;EADF;IAEE,uBAAA;EAsYA;AACF;;AAnYE;EADF;IAEI,uBAAA;EAuYF;AACF;;AArYA;EAIE,aAAA;EACA,iBAAA;EACE,mBAAA;AAqYJ;AApYE;EAPF;IAQK,aAAA;EAuYH;AACF;;AApYA;EACE;IACE,WAAA;IACA,YAAA;EAuYF;AACF;AArYA;EACE;IAEE,sBAAA;EAsYF;EApYA;IACE,gBAAA;EAsYF;AACF;AAnYE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAqYJ;;AA7XA;EACI,wBAAA;AAgYJ;;AA9XA;EACE,kBAAA;AAiYF;;AA/XA;EACE,2BAAA;AAkYF;;AA9XA;EACE,yBAAA;AAiYF;;AA/XA;EACE,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,QAAA;EACA,wBAAA;EACA,SAAA;EACA,WAAA;EACA;kBAAA;EAEA,cAAA;EACA,eAAA;EACA,UAAA;AAkYF;AAjYE;EAdF;IAeI,6BAAA;EAoYF;AACF;;AAlYA;EACE,UAAA;EACA,gBAAA;AAqYF;;AAnYA;EACE,mBAAA;AAsYF;;AApYA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAuYF;;AArYA;EACE;IACE,2BAAA;EAwYF;EAtYA;IACE,QAAA;EAwYF;AACF;AAtYA;EAEI;IACI,6BAAA;IACA,sBAAA;IACA,aAAA;IACA,MAAA;EAuYN;EApYE;IACI,UAAA;IACA,kBAAA;EAsYN;EApYE;IAEI,YAAA;IACA,uBAAA;IACA,aAAA;IACA,wBAAA;IACA,mBAAA;IACA,6BAAA;EAqYN;EAlYE;IACI,wBAAA;EAoYN;EAlYE;IACE,8BAAA;EAoYJ;EAlYE;IACE,aAAA;EAoYJ;EAlYE;IACE,eAAA;EAoYJ;EAlYE;IACE,eAAA;EAoYJ;EAlYE;IACE,eAAA;EAoYJ;EAlYE;IACE,eAAA;EAoYJ;EAlYE;IACE,eAAA;EAoYJ;EAlYE;IACE,2BAAA;IACA,SAAA;EAoYJ;AACF;AAlYA;EACE;IAEE,mBAAA;IACA,iBAAA;EAmYF;EAjYF;IACE,cAAA;IACA,aAAA;EAmYA;EAjYF;IACE,aAAA;IACA,uBAAA;EAmYA;EAhYF;IAIE,kBAAA;EA+XA;EAlYA;IACE,cAAA;EAoYF;EAhYF;IAEE,yBAAA;EAiYA;EA/XF;IACE,2BAAA;EAiYA;AACF;AA/XA;EACE;IAEE,mBAAA;IACA,iBAAA;EAgYF;EA7XF;IACE,yBAAA;IACA,2BAAA;EA+XA;EA7XF;IACE,eAAA;IACA,cAAA;EA+XA;EA7XF;IACE,eAAA;EA+XA;EA7XF;IACE,eAAA;EA+XA;EA7XF;IACE,eAAA;EA+XA;EA7XF;IAEE,YAAA;IACA,YAAA;IACA,eAAA;EA8XA;EA1XF;IACE,QAAA;IACA,WAAA;EA4XA;EA1XF;IACE,aAAA;EA4XA;EA1XF;IACE,wBAAA;EA4XA;AACF;AA1XA;EACE;IACE,cAAA;IACA,aAAA;EA4XF;EA1XF;IACE,uBAAA;IACA,wBAAA;EA4XA;EA1XF;IACE,iBAAA;IACA,kBAAA;EA4XA;AACF;AArXA;EACE,YAAA;EACA,aAAA;AAuXF;;AApXA;EACE,+BAAA;AAuXF;AAtXE;EAFF;IAGI,6BAAA;EAyXF;AACF;;AAvXA;EACE,gCAAA;AA0XF;;AAxXA;EACE,6BAAA;AA2XF;;AAvXA;EACE,gCAAA;AA0XF;;AAxXA;EAEC,YAAA;EACC,uEAAA;EACA,0BAAA;EACA,kCAAA;EACA,2BAAA;AA0XF;;AAtXA;EAEE,8BAAA;AAwXF;;AApXA;EACE;IACE,gCAAA;IACA,kBAAA;EAuXF;EArXA;IACE,gCAAA;IACA,+BAAA;EAuXF;EArXA;IACE,gCAAA;IACA,kBAAA;EAuXF;EArXA;IACE,gCAAA;IACA,+BAAA;EAuXF;EArXA;IACE,gCAAA;EAuXF;AACF;AArXA;EACE;IACE,gCAAA;IACA,kBAAA;EAuXF;EArXA;IACE,gCAAA;IACA,kBAAA;EAuXF;EArXA;IACE,gCAAA;IACA,kBAAA;EAuXF;EArXA;IACE,gCAAA;IACA,kBAAA;EAuXF;EArXA;IACE,gCAAA;IACA,kBAAA;EAuXF;EArXA;IACE,gCAAA;EAuXF;EArXA;IACE,aAAA;IACA,uBAAA;EAuXF;AACF;AAhXA;EACE,kBAAA;AAkXF;;AAhXA;EACE,YAAA;EACA,mBAAA;AAmXF;;AAlXA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;AAqXF;AApXE;EANF;IAOI,UAAA;IACA,WAAA;EAuXF;AACF;;AArXA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AAwXF;AAvXE;EANF;IAOI,UAAA;IACA,WAAA;EA0XF;AACF;;AAxXA;EACE,kBAAA;AA2XF;;AAzXC;EACC,WAAA;EACE,YAAA;EACF,gBAAA;EACA,cAAA;AA4XF;AA3XE;EALD;IAMG,sBAAA;IACA,YAAA;EA8XF;AACF;;AA5XA;EACE,kBAAA;AA+XF;;AA7XA;EACE,kBAAA;EACA,mDAAA;EACA,4BAAA;AAgYF;;AApXA;EACE,gBAAA;EACD,eAAA;AAuXD;;AArXA;EACE,wBAAA;EACA,yBAAA;AAwXF;;AAtXA;EACE,yBAAA;EACA,oBAAA;AAyXF;;AAvXA;EACE,iBAAA;AA0XF;;AAxXA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AA2XF;;AAzXA;EACE,kBAAA;AA4XF;;AA1XA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;AA6XF;;AA3XA;EACM,cAAA;EACA,kBAAA;EACA,YAAA;AA8XN;;AA3XA;EACE,yBAAA;EACA,gBAAA;AA8XF;;AA5XA;EACC,yBAAA;EACA,cAAA;AA+XD;;AA7XA;EAGA,cAAA;AA8XA;;AA5XA;EACE,aAAA;EAGE,YAAA;EACA,YAAA;EACA,6CAAA;EACA,qBAAA;EACA,kBAAA;AA6XJ;;AA3XA;EACE;IAGE,cAAA;IACA,eAAA;EA4XF;EA1XE;IACE,iBAAA;EA4XJ;EA1XE;IACE,gBAAA;EA4XJ;AACF;AA1XA;EACE;IACE,qBAAA;EA4XF;AACF;AAxXA;EACE,yBAAA;AA0XF;;AAxXA;EACE,iBAAA;EACA,oBAAA;AA2XF;;AAzXA;EACE,YAAA;EACA,YAAA;AA4XF;;AAjXA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;AAoXF;AAnXE;EACE,qBAAA;EACA,cAAA;AAqXJ;;AAlXA;EACE,iBAAA;AAqXF;;AAlXA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAqXF;;AAlXA;EAEE,gBAAA;AAoXF;AAnXE;EACE,qBAAA;EACA,cAAA;AAqXJ;;AAlXA;EACE,cAAA;EACA,gBAAA;AAqXF;;AAnXA;EACE,cAAA;EACA,gBAAA;AAsXF;;AApXA;EACE,6BAAA;EACA,kBAAA;AAuXF;;AApXA;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;AAsXF;;AA9WA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EAGA,mBAAA;EACA,eAAA;AA+WF;AA9WE;EACE,qBAAA;EACA,cAAA;AAgXJ;;AA7WA;EACE,cAAA;EAGA,iBAAA;EACA,UAAA;EACA,eAAA;AA8WF;;AA5WA;EACE,YAAA;EACA,YAAA;AA+WF;;AA1WA;EAEE,cAAA;EAGA,eAAA;EAEA,UAAA;EACA,yBAAA;AAyWF;;AAtWA;EACE;IACE,cAAA;EAyWF;EAxWE;IACE,sBAAA;IACA,kBAAA;IACA,sBAAA;EA0WJ;EAvWA;IACE,sCAAA;IACA,sBAAA;EAyWF;AACF;AAvWA;EACE;IACE,iBAAA;EAyWF;EAvWA;IACE,iBAAA;EAyWF;AACF;AAvWA;EACE,kBAAA;AAyWF;;AAtWA;EAIC,WAAA;AAsWD;;AApWA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AAuWF;;AApWA;EACE;IACE,YAAA;EAuWF;AACF;AArWA;EACE;IACE,aAAA;EAuWF;AACF;AApWA;EACE;IACE,iBAAA;EAsWF;AACF;AApWA;EACE;IACE,iBAAA;EAsWF;AACF;AApWA;EACE,kBAAA;AAsWF;;AAnWA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;AAsWF;;AAnWA;EACE,gBAAA;AAsWF;;AApWA;EACE,gBAAA;EACA,+BAAA;EACA,kBAAA;AAuWF;AAtWE;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AAwWJ;AArWE;EACE,cAAA;AAuWJ;;AApWA;EACE,kBAAA;AAuWF;;AArWA;EACE;IACE,kBAAA;EAwWF;AACF;AAtWA;EACE;IACE,+BAAA;EAwWF;EAtWA;IACE,kBAAA;EAwWF;EAtWA;IACE,kBAAA;EAwWF;AACF;AAtWA;EACE,gBAAA;AAwWF;AAvWE;EAFF;IAGI,gBAAA;EA0WF;AACF;;AAxWA;EAGE,WAAA;AAyWF;;AAtWA;EACE;IACE,aAAA;IACA,mBAAA;EAyWF;AACF;AArWA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAuWF;;AArWA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAwWF;AAvWE;EANF;IAOI,kBAAA;EA0WF;AACF;AAzWE;EATF;IAUI,eAAA;EA4WF;AACF;;AAvWA;EACE,mBAAA;EACA,gBAAA;AA0WF;;AAxWA;EACE,gBAAA;EACA,WAAA;AA2WF;;AAjWA;EAQE,kBAAA;AA6VF;;AA3VA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;AA8VF;;AA3VA;EACE,iBAAA;AA8VF;;AA1VA;EACE,mBAAA;AA6VF;;AA3VA;EACE,gCAAA;EACA,+BAAA;EACA,aAAA;AA8VF;;AA5VA;EACE,kBAAA;AA+VF;;AA5VA;EACE,mBAAA;AA+VF;AA9VE;EAFF;IAGE,mBAAA;EAiWA;AACF;AAhWE;EALF;IAMI,gCAAA;EAmWF;AACF;;AAjWA;EACE,mBAAA;AAoWF;;AAlWA;EACE,gCAAA;EACA,aAAA;AAqWF;;AAnWA;EACE,aAAA;EACA,+BAAA;AAsWF;;AApWA;EACE,aAAA;AAuWF;;AArWA;EACE,kBAAA;EACA,qBAAA;AAwWF;AAvWE;EAHF;IAII,iBAAA;IACA,oBAAA;EA0WF;AACF;AAzWE;EAPF;IAQI,mBAAA;IACA,oBAAA;EA4WF;AACF;;AAzWA;EACA,WAAA;EACA,YAAA;AA4WA;;AA1WA;EACE,iBAAA;AA6WF;;AA3WA;EACE;IACE,gCAAA;IACA,kBAAA;EA8WF;EA5WE;IACE,gCAAA;IACA,6BAAA;EA8WJ;AACF;AA5WA;EACE,gBAAA;AA8WF;;AA3WA;EACE,WAAA;AA8WF;;AA5WA;EACE;IACE,aAAA;IACA,mBAAA;EA+WF;AACF;AA7WA;EACE,oBAAA;EACA,iBAAA;EACA,gBAAA;AA+WF;;AA7WA;EACE;IACE,mBAAA;EAgXF;AACF;AA5WA;EAEE,gBAAA;AA6WF;AA5WE;EAHF;IAII,gBAAA;EA+WF;AACF;;AA7WA;EAGE,gBAAA;AA8WF;AA7WE;EAJF;IAKQ,iBAAA;EAgXN;AACF;AA/WE;EAPF;IAQI,gBAAA;EAkXF;AACF;AAjXE;EAVF;IAWI,gBAAA;EAoXF;AACF;;AAlXA;EACA;IACA,aAAA;IACA,mBAAA;EAqXE;AACF;AAnXA;EACA,WAAA;EACA,kBAAA;AAqXA;;AAnXA;EACE,gBAAA;AAsXF;AApXE;EAHF;IAII,gBAAA;EAuXF;AACF;;AArXA;EAEG,iBAAA;EACD,gBAAA;AAuXF;;AApXA;EACA,kBAAA;AAuXA;;AArXA;EACE,WAAA;AAwXF;;AAtXA;EACE;IACE,aAAA;IACA,mBAAA;EAyXF;EAvXA;IACE,gBAAA;EAyXF;AACF;AAtXA;EACE,gBAAA;AAwXF;;AAtXA;EACE,gBAAA;AAyXF;;AAvXA;EACE,WAAA;EACA,aAAA;AA0XF;;AAxXA;EACE,mBAAA;AA2XF;;AAzXA;EACE;IACE,aAAA;EA4XF;AACF;AA1XA;EACE,aAAA;AA4XF;;AA1XA;EACE;IACE,gBAAA;EA6XF;AACF;AA3XA;EACE;IACE,iBAAA;EA6XF;AACF;AAzXA;EACE,kBAAA;EACA,2CAAA;AA2XF;;AAxXA;EACE,mDAAA;EACA,sBAAA;EACA,4BAAA;AA2XF;;AAzXA;EACE,iBAAA;EACA,iBAAA;AA4XF;;AA1XA;EACE,mBAAA;EACD,mBAAA;EACA,oBAAA;AA6XD;;AA1XA;EACE,gCAAA;AA6XF;;AA3XA;EACE,+BAAA;AA8XF;AA7XE;EAFF;IAGI,6BAAA;EAgYF;AACF;;AA9XA;EACE,6BAAA;AAiYF;;AA/XA;EACE,8BAAA;AAkYF;AAjYE;EAFF;IAGI,2CAAA;EAoYF;AACF;;AAlYA;EACE,8BAAA;AAqYF;AApYE;EAFF;IAGI,2CAAA;EAuYF;AACF;;AArYA;EACE,8BAAA;AAwYF;AAvYE;EAFF;IAGI,2CAAA;EA0YF;AACF;;AAxYA;EACE,8BAAA;AA2YF;;AAtYA;EAEE,gCAAA;EACA,mBAAA;EACA,oBAAA;AAwYF;;AAtYA;EACE,WAAA;EACA,mBAAA;AAyYF;;AArYA;EACE,kBAAA;AAwYF;;AAtYA;EACE,mBAAA;AAyYF;;AAvYA;EACE;IACE,gBAAA;EA0YF;EAxYA;IACE,kBAAA;EA0YF;AACF;AAxYA;EACE;IACE,kBAAA;IACA,gCAAA;EA0YF;EAxYA;IACE,mBAAA;EA0YF;EAxYA;IACE,yBAAA;IACA,mBAAA;EA0YF;EAxYA;IAEE,gBAAA;EAyYF;AACF;AAtYA;EACE,kBAAA;AAwYF;;AAtYA;EACE,aAAA;EAEF,gBAAA;EACC,WAAA;AAwYD;;AAtYA;EACE,kBAAA;EACA,aAAA;EAGA,kBAAA;AAuYF;;AArYA;EAEE,aAAA;EACA,cAAA;EACA,eAAA;AAuYF;;AAnYA;EAEE,aAAA;EACA,cAAA;EAEA,gBAAA;EACA,eAAA;AAoYF;;AAjYA;EACE,YAAA;AAoYF;;AAlYA;EACE;IACE,aAAA;IACA,cAAA;IACA,gBAAA;IACA,eAAA;IACA,8BAAA;EAqYF;AACF;AAlYA;EAEE,mBAAA;EACA,kBAAA;EACA,mBAAA;AAmYF;;AAjYA;EACA,gBAAA;AAoYA;;AAhYA;EACE,WAAA;EACA,YAAA;AAmYF;;AAjYA;EACE;IACE,mBAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;EAoYF;EAlYF;IACE,4BAAA;EAoYA;AACF;AAjYA;EACE,gBAAA;AAmYF;;AAjYA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAoYF;;AAlYA;EACA,kBAAA;AAqYA;;AAnYA;EACE,gBAAA;AAsYF;;AApYA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;AAuYF;;AArYA;EACE,6BAAA;AAwYF;;AAtYA;EACE;IACE,4BAAA;IACA,gBAAA;EAyYF;AACF;AAvYC;EACE,aAAA;AAyYH;;AAvYA;EACE,gBAAA;AA0YF;;AAxYA;EACE,WAAA;AA2YF;;AAxYA;EACE,6BAAA;AA2YF;;AAzYA;EACE,WAAA;EACA,mBAAA;AA4YF;;AAzYA;EACE,gBAAA;EACA,mBAAA;AA4YF;;AA1YA;EACE,kBAAA;AA6YF;;AA3YA;EACE;IACE,4BAAA;EA8YF;EA3YF;IACE,iBAAA;EA6YA;AACF;AA1YA;EACE,kBAAA;EACA,iBAAA;AA4YF;;AA1YA;EACE,mBAAA;AA6YF;;AA1YA;EACE,kBAAA;EAEA,gBAAA;EAEA,mBAAA;AA2YF;AA1YE;EANF;IAOI,mBAAA;EA6YF;AACF;AA5YE;EATF;IAUI,mBAAA;EA+YF;AACF;;AA5YA;EACE,WAAA;EACA,YAAA;AA+YF;;AA7YA;EACE;IACE,kBAAA;IACA,gBAAA;IACA,mBAAA;EAgZF;AACF;AA5YA;EACE,gBAAA;EACA,oBAAA;AA8YF;;AA5YA;EAGE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AA6YF;AA5YE;EAPF;IAQI,sBAAA;EA+YF;AACF;;AA7YA;EACE,gCAAA;EACA,+BAAA;AAgZF;;AA7YA;EACE,6BAAA;AAgZF;;AA7YA;EACO,yBAAA;AAgZP;;AA9YA;EACE,yBAAA;AAiZF;;AA/YA;EACE,gCAAA;AAkZF;;AAhZA;EAEI,yBAAA;EAEA,uEAAA;EACA,0BAAA;EACA,kCAAA;EACA,2BAAA;AAiZJ;;AA/YA;EACE,8BAAA;EACF,aAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AAkZA;;AAhZA;EAEE,yBAAA;EAEA,uEAAA;EACA,0BAAA;EACA,kCAAA;EACA,2BAAA;AAiZF;;AA/YA;EACE,yBAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;AAkZF;AAjZE;EALF;IAMI,sBAAA;EAoZF;AACF;AAnZE;EARF;IASI,2BAAA;EAsZF;AACF;;AApZA;EACE,mBAAA;AAuZF;;AArZA;EACE,cAAA;AAwZF;;AAtZA;EACE,uDAAA;EACA,iBAAA;EACA,kBAAA;AAyZF;;AAvZA;EACE,iBAAA;EACA,iBAAA;EACA,uDAAA;AA0ZF;AAzZE;EACE,qBAAA;EACA,cAAA;AA2ZJ;;AAxZA;EACE,cAAA;EACA,gBAAA;AA2ZF;;AAzZA;EACE,mBAAA;AA4ZF;;AA1ZA;EACE,gBAAA;EACA,mBAAA;AA6ZF;;AAzZA;EACE,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,iBAAA;AA4ZF;AA3ZE;EALF;IAMI,sBAAA;EA8ZF;AACF;AA7ZE;EARF;IASI,2BAAA;EAgaF;AACF;;AA7ZA;EACE,uDAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;AAgaF;;AA9ZA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AAiaF;;AA9ZA;EAGE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uDAAA;AA+ZF;;AA7ZA;EACE,8BAAA;AAgaF;;AA9ZA;EACE,iBAAA;EACA,mBAAA;AAiaF;;AA/ZA;EAEE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AAiaF;;AA9ZA;EACE,eAAA;EACA,gBAAA;AAiaF;;AA9ZA;EACE,UAAA;AAiaF;;AA/ZA;EACE,2BAAA;AAkaF;;AA/ZA;EACE;IACE,cAAA;EAkaF;EAhaA;IACE,WAAA;EAkaF;EAhaA;IACE,UAAA;EAkaF;AACF;AA/ZA;EACE;IACE,kBAAA;IACA,kBAAA;EAiaF;EA/ZF;IACE,kBAAA;EAiaA;EA9ZF;IAEE,gBAAA;EA+ZA;EA7ZF;IACE,gBAAA;EA+ZA;EA7ZF;IACE,WAAA;EA+ZA;EA7ZF;IACE,kBAAA;IACA,gBAAA;IACA,mBAAA;EA+ZA;AACF;AA5ZA;EACE,iBAAA;EACF,8BAAA;EACA,gIAAA;AA8ZA;;AA3ZA;EACE,gBAAA;AA8ZF;;AA5ZA;EACA,gBAAA;AA+ZA;;AA7ZA;EACE,iBAAA;EAEA,oBAAA;AA+ZF;;AA7ZA;EAGE,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACC,YAAA;EAED,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AA6ZF;;AAzZA;EAGE,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EAEA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;AAyZF;;AApZA;EACE,UAAA;EACA,aAAA;AAuZF;;AArZA;EACE,YAAA;EACA,YAAA;AAwZF;;AAtZA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;AAyZA;;AAvZA;EACE;IACE,cAAA;EA0ZF;EAxZA;IACE,gBAAA;EA0ZF;EAxZE;IACE,WAAA;EA0ZJ;EAvZE;IACE,WAAA;IACA,SAAA;EAyZJ;EAvZE;IACE,gBAAA;IACA,iBAAA;IACA,kBAAA;EAyZJ;AACF;AAvZA;EACE,gBAAA;EACA,mBAAA;AAyZF;;AAtZA;EACE,yBAAA;EACA,mBAAA;AAyZF;;AAvZA;EACE,uDAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;AA0ZF;;AAxZA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AA2ZF;;AAxZA;EAGE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uDAAA;AAyZF;;AAvZA;EACE,8BAAA;AA0ZF;;AAxZA;EACE,mBAAA;AA2ZF;;AAxZA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AA2ZF;;AAzZA;EACE,eAAA;AA4ZF;;AA1ZA;EACE,8BAAA;AA6ZF;;AA1ZA;EACE,WAAA;EACA,sBAAA;AA6ZF;;AA3ZA;EACE,0BAAA;AA8ZF;;AA5ZA;EACE,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;AA+ZF;;AA5ZA;EACE,oCAAA;EACA,gBAAA;AA+ZF;;AA7ZA;EACE,oCAAA;EACA,gBAAA;AAgaF;;AA7ZA;EACE,oCAAA;AAgaF;;AA7ZA;EACE,kBAAA;AAgaF;;AA7ZA;EACE,oCAAA;AAgaF;;AA7ZA;EACE,oCAAA;AAgaF;;AA5ZA;EACE;IACA,kBAAA;EA+ZA;EA7ZF;IAEE,kBAAA;EA8ZA;EA5ZF;IACE,iBAAA;EA8ZA;AACF;AA5ZA;EACE;IACE,WAAA;EA8ZF;EA5ZA;IACE,WAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EA8ZF;EA5ZA;IACE,iBAAA;EA8ZF;EA5ZF;IAEE,4BAAA;EA6ZA;EA3ZF;IAEE,4BAAA;EA4ZA;AACF;AAzZA;EACA;IACE,gBAAA;EA2ZA;EAxZF;IACE,mBAAA;EA0ZA;EAxZF;IACE,gBAAA;EA0ZA;AACF;AAxZA;EACE,gBAAA;EACA,mBAAA;AA0ZF;;AAxZA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AA2ZA;;AAzZA;EACE,eAAA;EACA,cAAA;AA4ZF;;AAzZA;EACE,gBAAA;EACA,mBAAA;AA4ZF;;AA1ZA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AA6ZA;;AA3ZA;EACE,eAAA;EACA,cAAA;AA8ZF;;AA5ZA;EACE,eAAA;EACA,iBAAA;AA+ZF;;AA7ZA;EACE,gBAAA;AAgaF;;AA9ZA;EACE,gBAAA;EACA,mBAAA;AAiaF;AAhaE;EACE,eAAA;AAkaJ;;AA7ZA;EACE,gBAAA;AAgaF;;AA9ZA;EACE,gBAAA;AAiaF;;AA/ZA;EACE,WAAA;AAkaF;;AAhaA;EACE,mBAAA;EACA,kBAAA;AAmaF;;AAjaA;EACE,iBAAA;EACA,gBAAA;AAoaF;;AAlaA;EACC,oBAAA;AAqaD;;AAnaA;EACE,mBAAA;AAsaF;;AApaA;EACE,gBAAA;AAuaF;;AAraA;EACE,aAAA;AAwaF;;AAtaA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAyaF;;AApaA;EACE,mBAAA;EACA,mBAAA;AAuaF;;AAjaA;EACE,kBAAA;AAoaF;;AAlaA;EACE,uDAAA;EACA,iBAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;AAqaF;;AAnaA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;AAsaF;;AAnaA;EAGE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uDAAA;AAoaF;;AAlaA;EACE,8BAAA;AAqaF;;AAnaA;EACA,gBAAA;AAsaA;;AAnaA;EACC,8BAAA;EACA,wBAAA;AAsaD;;AAjaA;EACE,mBAAA;EACA,kBAAA;AAoaF;;AAjaA;EACE,eAAA;AAoaF;;AAlaA;EACE,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;AAqaF;;AAnaA;EACE,yBAAA;EACA,qBAAA;AAsaF;;AAnaA;EACE,qBAAA;EACA,uBAAA;EACA,6BAAA;AAsaF;;AApaA;EACE,qBAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;AAuaF;;AAlaA;EACE,WAAA;EACA,yBAAA;AAqaF;;AAnaA;EACE,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,uBAAA;EACA,0BAAA;AAsaF;;AApaA;EACE,uDAAA;AAuaF;;AAraA;EACE,aAAA;AAwaF;;AAtaA;EACE,aAAA;AAyaF;;AAvaA;EACE,wBAAA;AA0aF;;AAxaA;EACE,0BAAA;EACA,6BAAA;AA2aF;;AAraA;EACE,iBAAA;EACA,iBAAA;EACA,oBAAA;AAwaF;;AAtaA;EACE,kBAAA;AAyaF;;AAvaA;EACE,kBAAA;EACA,mBAAA;AA0aF;;AAxaA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EAEA,kBAAA;AA0aF;;AAxaA;EACE,aAAA;EACA,WAAA;AA2aF;AA1aE;EAHF;IAII,aAAA;EA6aF;AACF;;AA1aA;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA6aF;;AA1aE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;AA6aJ;AA3aE;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AA6aJ;AA3aE;EACE,qBAAA;EACA,yBAAA;EACA,eAAA;AA6aJ;AA3aE;EACE,8BAAA;EACA,8BAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACF,YAAA;AA6aF;;AA1aA;EACE,gBAAA;AA6aF;;AA3aA;EACE,mBAAA;EAGA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,kBAAA;AA2aF;AA1aE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACF,YAAA;AA4aF;;AAzaA;EACE;IACE,iBAAA;IACA,gBAAA;EA4aF;EA1aF;IACE,eAAA;EA4aA;EA1aF;IACE,cAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;EA4aA;EA1aF;IACE,eAAA;EA4aA;EA1aF;IACE,uDAAA;IACA,iBAAA;IACA,2BAAA;IACA,kBAAA;IACA,kBAAA;IACA,eAAA;EA4aA;AACF;AA1aA;EACE;IACE,cAAA;IACA,eAAA;IACA,uBAAA;IACA,kBAAA;EA4aF;EA1aF;IACI,iBAAA;EA4aF;EA1aF;IACE,mBAAA;IACA,mBAAA;IACA,gBAAA;EA4aA;AACF;AA1aA;EACE;IACE,iBAAA;IACA,gBAAA;IACA,gCAAA;EA4aF;EA1aF;IACE,6BAAA;IACA,gBAAA;EA4aA;EAtaF;IACE,gBAAA;IACA,aAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EAwaA;EAraA;IAEE,iBAAA;EAsaF;EApaA;IACE,mBAAA;IACA,kBAAA;IACA,aAAA;IACA,iBAAA;EAsaF;EAnaA;IACE,8BAAA;IACA,8BAAA;IACA,yBAAA;IACA,YAAA;IACA,WAAA;IACF,YAAA;EAqaA;EAlaF;IACE,mBAAA;IAGA,kBAAA;IACA,mBAAA;IACA,iBAAA;IACA,mBAAA;IACA,mBAAA;IAEA,kBAAA;EAiaA;EAhaA;IACE,mBAAA;IACA,mBAAA;IACA,YAAA;IACA,WAAA;IACF,YAAA;EAkaA;AACF;AA5ZA;EACE,gBAAA;AA8ZF;;AA5ZA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA+ZF;;AA7ZA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AAgaF;;AA9ZA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;AAiaF;;AA/ZA;EACE,kBAAA;EACA,mBAAA;AAkaF;;AAhaA;EACE,yBAAA;EACA,mBAAA;AAmaF;;AA/ZA;EACE,YAAA;EACA,mBAAA;AAkaF;AAjaE;EACE,gBAAA;AAmaJ;;AA7ZA;EACE,iBAAA;EACA,eAAA;AAgaF;;AA9ZA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EAEA,gBAAA;EACF,mBAAA;AAgaA;;AA9ZA;EACE,cAAA;EACA,eAAA;EAEA,mBAAA;AAgaF;;AA5ZA;EACE,mBAAA;EACA,mBAAA;EACA,mBAAA;AA+ZF;;AA7ZA;EACE,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;AAgaF;;AAnZE;EACE,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;AAsZJ;AApZE;EACE,cAAA;EACA,eAAA;AAsZJ;AApZE;EACE,gBAAA;AAsZJ;AApZE;EACE,YAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AAsZJ;AApZE;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;AAsZJ;AAnZE;EACE,cAAA;EACA,eAAA;AAqZJ;;AA7YA;EACE,YAAA;AAgZF;;AAzYA;EACE,6BAAA;AA4YF;AAnYA;EACE,YAAA;EACA,YAAA;EACA,aAAA;AAqYF;;AAnYA;EACE;IACE,kBAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;EAsYF;EApYA;IACE,aAAA;EAsYF;EApYA;IAEE,qBAAA;EAqYF;AACF;AAlYA;EACE;IAEE,qBAAA;EAmYF;AACF;AAhYA;EACE,cAAA;EACA,eAAA;AAkYF;;AAhYA;EACE,eAAA;AAmYF;;AAhYA;EACE,kBAAA;AAmYF;;AAjYA;EACE;IACE,yBAAA;EAoYF;AACF;AAlYA;EACE;IACE,kBAAA;IACA,mBAAA;EAoYF;AACF;AAlYA;EACE;IACE,aAAA;IACA,eAAA;IACA,sBAAA;IACA,mBAAA;EAoYF;EAlYA;IACE,eAAA;IACA,gBAAA;IACA,YAAA;EAoYF;EAlYA;IACE,eAAA;IACA,gBAAA;IACA,YAAA;EAoYF;AACF;AAjYA;EACE;IACE,eAAA;IACA,mBAAA;EAmYF;AACF;AAjYA;EACA;IACE,eAAA;IACA,gBAAA;EAmYA;EAhYF;IACE,eAAA;IACA,gBAAA;EAkYA;AACF;AA5XA;EACE,sBAAA;EACA,kBAAA;AA8XF;;AA5XA;EACE,kBAAA;AA+XF;;AA7XA;EACE,WAAA;AAgYF;;AA9XA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AAiYF;;AA9XE;EAEE,eAAA;EACA,YAAA;EAEA,kBAAA;AA+XJ;;AA3XA;EACE,gBAAA;AA8XF;;AA5XA;EACE,gBAAA;AA+XF;AA9XE;EAFF;IAGI,gBAAA;EAiYF;AACF;;AA9XA;EACC,aAAA;AAiYD;;AA/XA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAkYF;AAjYE;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAmYJ;AAjYE;EAZF;IAaI,kBAAA;IACA,8BAAA;EAoYF;AACF;;AAlYA;EACE,oBAAA;AAqYF;AApYE;EAFF;IAGI,mBAAA;EAuYF;AACF;;AArYA;EACE;IACE,eAAA;EAwYF;AACF;AAhYA;EACE,gBAAA;EACA,mBAAA;AAkYF;;AAhYA;EACE,mBAAA;EACA,gCAAA;AAmYF;;AAjYA;EACE,mBAAA;EACA,gCAAA;AAoYF;;AAjYA;EACE,iBAAA;EACA,gBAAA;AAoYF;;AAlYA;EACE,eAAA;EACA,+BAAA;EACA,iBAAA;EACA,cAAA;AAqYF;;AAnYA;EACE,eAAA;EACA,cAAA;AAsYF;;AAnYA;EACE,gBAAA;EACA,iBAAA;AAsYF;;AApYA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAuYF;;AArYA;EACE,aAAA;AAwYF;;AAtYA;EACE,yBAAA;AAyYF;;AAvYA;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AA0YF;;AAxYA;EACE,eAAA;EACA,cAAA;AA2YF;;AAzYA;EACE,eAAA;EACA,cAAA;AA4YF;;AA1YA;EACE,kBAAA;AA6YF;;AA1YA;EACE,gBAAA;EACA,iBAAA;AA6YF;;AA3YA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AA8YF;;AA5YA;EACE,kBAAA;AA+YF;AA9YE;EACE,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAgZJ;AA9YE;EACE,cAAA;EACA,eAAA;AAgZJ;AA9YE;EACE,gBAAA;AAgZJ;AA9YE;EACE,gBAAA;AAgZJ;;AA7YA;EACE,YAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAgZF;;AA9YA;EACE,oBAAA;AAiZF;;AA/YA;EACE;IACE,mBAAA;IACA,mBAAA;EAkZF;EAhZA;IACE,mBAAA;IACA,mBAAA;IACA,gBAAA;EAkZF;AACF;AA/YA;EACE;IACE,YAAA;EAiZF;EA/YA;IACE,eAAA;EAiZF;EA/YA;IACE,iBAAA;EAiZF;EA/YA;IACE,iBAAA;EAiZF;EA/YA;IACE,kBAAA;IACA,iBAAA;EAiZF;EA/YA;IACE,yBAAA;EAiZF;AACF;AA/YA;EACE,iBAAA;AAiZF;;AA/YA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAkZF;AAhZE;EACE,gBAAA;AAkZJ;AAhZE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAkZJ;AAhZE;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAkZJ;AAhZE;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAkZJ;AAhZE;EACE,YAAA;EACA,wBAAA;AAkZJ;;AA9YA;EACE,yBAAA;AAiZF;;AA/YA;EACE,YAAA;AAkZF;;AAhZA;EACE,aAAA;AAmZF;;AAjZA;EACE;IACE,aAAA;EAoZF;EAlZA;IACE,cAAA;EAoZF;AACF;AAlZA;EACE;IACE,iBAAA;IAEA,kBAAA;EAmZF;AACF;AA5YA;EACE,iBAAA;EACA,mBAAA;AA8YF;;AA5YA;EACE,iBAAA;EACA,kBAAA;AA+YF;;AA5YA;EACE,YAAA;AA+YF;;AA7YA;EACE,aAAA;AAgZF;;AA9YA;EACE,gBAAA;AAiZF;AAhZE;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAkZJ;AAhZE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAkZJ;AA/YE;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAiZJ;AA/YE;EACE,aAAA;EACA,YAAA;AAiZJ;;AA7YA;EACE,gBAAA;AAgZF;;AA9YA;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;AAiZF;;AA/YA;EACE,iBAAA;AAkZF;;AAhZA;EACE;IACE,iBAAA;IACA,kBAAA;EAmZF;AACF;AAjZA;EACE;IACE,YAAA;EAmZF;EAjZF;IACE,YAAA;EAmZA;EAjZF;IACE,iBAAA;EAmZA;EAjZF;IAEE,aAAA;EAkZA;EAhZF;IACE,gBAAA;EAkZA;AACF;AA/YA;EACE;IACE,kBAAA;IAIA,aAAA;EA8YF;EA5YF;IACE,cAAA;EA8YA;AACF;AA5YA;EACE;IACE,yBAAA;EA8YF;EA5YA;IACE,kBAAA;EA8YF;EA5YA;IACE,kBAAA;IACA,cAAA;IACA,gBAAA;EA8YF;AACF;AA1YA;EACE,gBAAA;AA4YF;;AA1YA;EACE,qBAAA;AA6YF;;AA3YA;EACE,qBAAA;AA8YF;;AArYE;EAEE,mBAAA;AAuYJ;;AArYE;EACE,gBAAA;AAwYJ;;AArYE;EACE,6BAAA;AAwYJ;;AAtYE;EAEE,kBAAA;AAwYJ;;AArYE;EACE,YAAA;AAwYJ;;AAtYE;EACE,WAAA;EACA,mBAAA;AAyYJ;;AAvYE;EACE;IAEE,kBAAA;EAyYJ;AACF;AAvYE;EACE;IACE,eAAA;IACA,kBAAA;EAyYJ;EAtYE;IACE,eAAA;IACA,mBAAA;EAwYJ;EAtYE;IACE,gCAAA;EAwYJ;AACF;AAlYE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oCAAA;EACA,WAAA;EACA,8CAAA;AAoYJ;;AAjYE;EACE,cAAA;EACA,uBAAA;AAoYJ;;AAjYE;EAEE,qBAAA;EACA,cAAA;AAmYJ;;AA/XE;EACE,mBAAA;EACA,gCAAA;EAEA,uBAAA;EAEA,mBAAA;AAgYJ;;AA7XE;;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,8CAAA;AAgYJ;;AA7XE;EACE,YAAA;EACA,QAAA;EACA,MAAA;AAgYJ;;AA7XE;EACE,WAAA;AAgYJ;;AA7XE;EACE,OAAA;AAgYJ;;AA3XE;EACE,uBAAA;AA8XJ;;AAxXA,gCAAA;AACA;EACE,WAAA;AA2XF;;AAzXA;EAEI;;IAEE,WAAA;EA2XJ;EAxXA;IACE,aAAA;IACA,mBAAA;EA0XF;AACF;AA1XI;EAHF;IAII,kBAAA;IACA,aAAA;IACA,yBAAA;EA6XJ;AACF;AAzXA;EACE;IACE,iBAAA;EA2XF;EAzXA;IACE,wDAAA;EA2XF;EAzXA;IACE,cAAA;IACA,iBAAA;IACA,oBAAA;IACA,wDAAA;IACA,uDAAA;EA2XF;EAzXA;IACE,iBAAA;EA2XF;EAzXA;IACE,WAAA;IACA,aAAA;EA2XF;AACF;AAzXA;EACE;IACE,wBAAA;EA2XF;EAzXA;IACE,4BAAA;IACA,6BAAA;EA2XF;EAzXA;IACE,gBAAA;EA2XF;EAzXA;IACE,eAAA;EA2XF;EAzXA;IACE,YAAA;IACA,iBAAA;EA2XF;EA1XE;IACE,eAAA;EA4XJ;EAzXA;IACE,kBAAA;IACA,eAAA;EA2XF;EA1XE;IACE,WAAA;EA4XJ;EAzXA;IACE,uBAAA;IACA,eAAA;EA2XF;EAzXA;IACE,4BAAA;EA2XF;EAzXA;IACE,iCAAA;IACA,gCAAA;IACA,2CAAA;EA2XF;AACF;AA3XI;EAJF;IAKI,UAAA;IACF,iBAAA;IACA,kBAAA;IACA,mBAAA;IACA,iBAAA;EA8XF;AACF;AA3aA;EA+CE;IACE,iBAAA;IACA,eAAA;EA+XF;EA7XA;IACE,WAAA;IACA,QAAA;EA+XF;EA7XA;IACE,oBAAA;IACA,iBAAA;IACA,WAAA;EA+XF;EA9XE;IACE,4BAAA;EAgYJ;EA7XA;IACE,gBAAA;EA+XF;EA7XA;IACE,6BAAA;IACA,iBAAA;EA+XF;EA7XA;IACE,8BAAA;IACA,6BAAA;EA+XF;EA7XA;IACE,6BAAA;EA+XF;EA7XA;IACE,2BAAA;IACA,+BAAA;EA+XF;EA9XE;IACE,2BAAA;EAgYJ;EA7XA;IACE,UAAA;IACA,WAAA;EA+XF;EA7XA;IACE,cAAA;EA+XF;EA7XA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EA+XF;EA7XA;IACE,wBAAA;EA+XF;EA7XA;IACE,eAAA;IACA,mBAAA;EA+XF;EA7XA;IACE,kBAAA;IACA,eAAA;EA+XF;EA7XA;IACE,iBAAA;EA+XF;EA7XA;IACE,YAAA;IACA,gBAAA;IACA,sBAAA;EA+XF;EA7XA;IACE,4BAAA;IACA,+BAAA;EA+XF;EA9XE;IACE,cAAA;IACA,0BAAA;EAgYJ;EA7XA;IACE,iBAAA;EA+XF;EA7XA;IACE,gBAAA;EA+XF;EA9XE;IACE,uDAAA;IACA,6BAAA;IACA,iBAAA;EAgYJ;EA9XE;IACE,2BAAA;EAgYJ;EA9XE;IACE,2BAAA;EAgYJ;EA9XE;IACE,2BAAA;EAgYJ;EA9XE;IACE,0BAAA;EAgYJ;EA9XE;IACE,wDAAA;IACA,uDAAA;EAgYJ;EA9XE;IACE,4BAAA;IACA,eAAA;EAgYJ;EA5XA;IACE,eAAA;EA8XF;EA7XE;IACE,4BAAA;EA+XJ;EA7XE;IACE,2BAAA;EA+XJ;EA7XE;IACE,wBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;EA+XJ;EA5XA;IACE,2BAAA;EA8XF;EA7XE;IACE,iBAAA;EA+XJ;EA7XE;IACE,uBAAA;EA+XJ;EA7XE;IACE,eAAA;IACA,mBAAA;EA+XJ;EA7XE;IACE,eAAA;IACA,2BAAA;EA+XJ;EA7XE;IACE,6BAAA;EA+XJ;EA7XE;IACE,eAAA;IACA,eAAA;EA+XJ;EA5XA;IACE,iBAAA;IACA,oBAAA;EA8XF;EA7XE;IACE,0BAAA;IACA,gBAAA;IACA,mBAAA;EA+XJ;EA9XI;IACE,mBAAA;EAgYN;EA7XE;IACE,gBAAA;EA+XJ;EA3XE;IACE,gBAAA;EA6XJ;EA1XA;IACE,aAAA;EA4XF;EA3XE;IACE,eAAA;IACA,iBAAA;EA6XJ;EA1XA;IACE,aAAA;EA4XF;EA1XA;IACE,6CAAA;IACA,4CAAA;EA4XF;EA3XE;IACE,gBAAA;EA6XJ;EA5XI;IACE,gBAAA;EA8XN;EA1XA;IACE,gBAAA;EA4XF;EA3XE;IACE,wDAAA;IACA,uDAAA;EA6XJ;EA1XA;IACE,6BAAA;IACA,iBAAA;IACA,eAAA;IACA,mBAAA;IACA,YAAA;EA4XF;EA1XA;IACE,iBAAA;IACA,gBAAA;EA4XF;EA1XA;IACE,gBAAA;EA4XF;EA1XA;IACE,8BAAA;IACA,8BAAA;IACA,6CAAA;IACA,4CAAA;EA4XF;EA1XA;IACE,wDAAA;IACA,uDAAA;EA4XF;EA1XA;IACE,UAAA;IACA,UAAA;IACA,kBAAA;IACA,gBAAA;EA4XF;EA1XA;IACE,iBAAA;IACA,oBAAA;EA4XF;EA1XA;IACE,kBAAA;IACA,iBAAA;IACA,eAAA;EA4XF;EA1XA;IACE,6CAAA;IACA,4CAAA;IACA,gBAAA;IACA,6BAAA;EA4XF;EA1XA;IACE,gBAAA;EA4XF;EA1XA;IACE,6CAAA;IACA,4CAAA;EA4XF;EA3XE;IACE,gBAAA;EA6XJ;EA5XI;IACE,eAAA;EA8XN;EA1XA;IACE,gBAAA;EA4XF;EA3XE;IACE,eAAA;IACA,kBAAA;EA6XJ;EA3XE;IACE,WAAA;IACA,YAAA;EA6XJ;EA3XE;IACE,aAAA;EA6XJ;EA1XA;IACE,oBAAA;EA4XF;EA3XE;IACE,eAAA;EA6XJ;EA3XE;IACE,mBAAA;EA6XJ;EA5XI;IACE,uBAAA;EA8XN;EA3XE;IACE,qBAAA;IACA,SAAA;EA6XJ;EA3XE;IACE,2CAAA;EA6XJ;EA1XA;IACE,aAAA;IACA,aAAA;EA4XF;EA1XA;IACE,UAAA;EA4XF;EA3XE;IACE,eAAA;IACA,iBAAA;EA6XJ;EA3XE;IACE,eAAA;EA6XJ;EA1XA;IACE,cAAA;EA4XF;EA1XA;IACE,gBAAA;IACA,kBAAA;EA4XF;EA1XA;IACE,6BAAA;IACA,iBAAA;EA4XF;EA1XA;IACE,eAAA;EA4XF;EA3XE;IACE,6BAAA;IACA,iBAAA;EA6XJ;EA3XE;IACE,UAAA;EA6XJ;EA1XA;IACE,gBAAA;EA4XF;EA3XE;IACE,6BAAA;IACA,iBAAA;EA6XJ;EA1XA;IACE,gBAAA;IACA,mBAAA;EA4XF;EA3XE;IACE,gBAAA;EA6XJ;EA3XE;IACE,6BAAA;IACA,iBAAA;EA6XJ;EA1XA;IACE,gBAAA;IACA,mBAAA;EA4XF;EA1XA;IACE,gBAAA;IACA,mBAAA;EA4XF;EA1XA;IACE,gBAAA;IACA,gBAAA;EA4XF;EA1XA;IACE,6BAAA;IACA,iBAAA;IACA,eAAA;IACA,mBAAA;EA4XF;EA1XA;IACE,eAAA;IACA,cAAA;EA4XF;EA1XA;IACE,gBAAA;EA4XF;EA1XA;IACE,gBAAA;EA4XF;EA3XE;IACE,YAAA;IACA,eAAA;EA6XJ;EA3XE;IACE,YAAA;IACA,YAAA;EA6XJ;EA1XA;IACE,gBAAA;IACA,gBAAA;EA4XF;EAzXE;IACE,eAAA;EA2XJ;EAzXE;IACE,eAAA;IACA,iBAAA;EA2XJ;EAzXE;IACE,eAAA;EA2XJ;EAxXA;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EA0XF;EAxXA;IACE,gBAAA;EA0XF;EAxXA;IACE,gBAAA;IACA,gBAAA;IACA,+BAAA;EA0XF;EAzXE;IACE,kBAAA;EA2XJ;EAxXA;IACE,mBAAA;EA0XF;EAzXE;IACE,iBAAA;EA2XJ;EAxXA;IACE,gBAAA;EA0XF;EAzXE;IACE,YAAA;EA2XJ;EAzXE;IACE,gBAAA;EA2XJ;EAxXA;IACE,gBAAA;IACA,gBAAA;IACA,oBAAA;EA0XF;EAzXE;IACE,iBAAA;EA2XJ;EAxXA;IACE,WAAA;IACA,uBAAA;EA0XF;AACF;AAxXA;EACE;IACE,sBAAA;EA0XF;EAxXA;IACE,aAAA;IACA,iBAAA;EA0XF;EAxXA;IACE,gBAAA;EA0XF;EAxXA;IACE,gBAAA;IACA,0BAAA;IACA,kBAAA;IACA,iBAAA;IACA,6BAAA;IACA,iBAAA;IACA,eAAA;IACA,mBAAA;EA0XF;EAxXA;IACE,iBAAA;EA0XF;EAzXE;IACE,iBAAA;EA2XJ;AACF;AAxXA;EACE;IACE,UAAA;IACA,UAAA;EA0XF;EAxXA;IACE,wBAAA;IACA,sBAAA;EA0XF;EAxXA;IACE,mBAAA;EA0XF;EAxXA;IACE,UAAA;EA0XF;EAxXA;IACE,WAAA;IACA,YAAA;EA0XF;EAxXA;IACE,eAAA;EA0XF;EAzXE;IACE,eAAA;EA2XJ;EAxXA;IACE,eAAA;EA0XF;EAxXA;IACE,WAAA;IACA,aAAA;IACA,mBAAA;EA0XF;AACF;AAxXA;EACE;IACE,iBAAA;EA0XF;EAxXA;IACE,sBAAA;IACA,wBAAA;EA0XF;EAxXA;IACE,cAAA;EA0XF;EAxXA;IACE,UAAA;EA0XF;EAxXA;IACE,WAAA;IACA,YAAA;EA0XF;EAxXA;IACE,+BAAA;EA0XF;EAxXA;IACE,UAAA;EA0XF;EAxXA;IACE,8BAAA;EA0XF;AACF;AAxXA;EACE;IACE,UAAA;EA0XF;EAxXA;IACE,UAAA;EA0XF;EAxXA;IACE,UAAA;EA0XF;AACF;AAxXA;EACI,yBAAA;EACA,eAAA;AA0XJ;;AAxXA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;AA2XF;;AAzXA;EACE,cAAA;AA4XF;;AA1XA;EACA,cAAA;EACA,gBAAA;AA6XA;;AA3XA;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;AA8XF;;AA5XE;EACI,mBAAA;AA+XN;;AA7XA;EACM,kBAAA;AAgYN;;AA9XA;EACC,kBAAA;AAiYD;;AA/XA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAkYF;;AA/XA;EACE,eAAA;EACA,kBAAA;AAkYF;;AAhYA;EACE,cAAA;AAmYF;;AAjYA;EACA,WAAA;AAoYA;;AAlYE;EACI,mBAAA;EACA,gBAAA;EACA,mBAAA;AAqYN;;AAnYM,cAAA;AACA;EACI,uBAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;AAsYV;;AApYM;EAA6B,SAAA;AAwYnC;;AAvYM;EAA4B,UAAA;AA2YlC;;AAzYM;EACI,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,2CAAA;AA4YV;;AA1YM;EACE,mBAAA;EACA,2BAAA;AA6YR;;AA1YM,yCAAA;AACA;EACI,0DAAA;AA6YV;;AA1YU,MAAA;AACA;;;EAGI,uBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AA6Yd;;AA3YU;EACI,WAAA;AA8Yd;;AA5YU;;EAEI,YAAA;AA+Yd;;AA5YA,0CAAA;AACA;EAAY,aAAA;AAgZZ;;AA/YE;;;;EAIE,aAAA;AAkZJ;;AAhZE;EACE,mBAAA;EACA,2BAAA;AAmZJ;;AAjZE;EACE,0BAAA;EACD,sBAAA;EACA,oBAAA;EACA,uBAAA;EACA,kCAAA;AAoZH;;AAlZA;EACE,6BAAA;EACA,sBAAA;EACA,2BAAA;AAqZF","sourcesContent":["$ig-small-screen: 768px !default;\n$ig-xsmall-screen: 480px !default;\n$ig-white: #fff !default;\n$ig-black: #000 !default;\n$ig-blue: #337ab7 !default;\n$ig-background-black: rgba(0, 0, 0, .4) !default;\n$ig-transparent: rgba(0, 0, 0, 0) !default;\n$ig-shadow: 0 2px 2px lighten($ig-black, 10%);\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$vendor}#{$name}: #{$value};\n  }\n}\n\n// SVG ICON STYLES\n.image-gallery-icon {\n  color: $ig-white;\n  transition: all .3s ease-out;\n  appearance: none;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: none;\n  position: absolute;\n  z-index: 4;\n  filter: drop-shadow($ig-shadow);\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: $ig-blue;\n      .image-gallery-svg {\n        transform: scale(1.1);\n      }\n    }\n  }\n\n  &:focus {\n    // a11y support\n    outline: 2px solid $ig-blue;\n  }\n}\n\n.image-gallery-using-mouse {\n  .image-gallery-icon {\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n.image-gallery-fullscreen-button,\n.image-gallery-play-button {\n  bottom: 0;\n  padding: 20px;\n\n  .image-gallery-svg {\n    height: 28px;\n    width: 28px;\n  }\n\n  @media (max-width: $ig-small-screen) {\n    padding: 15px;\n\n    .image-gallery-svg {\n      height: 24px;\n      width: 24px;\n    }\n  }\n\n  @media (max-width: $ig-xsmall-screen) {\n    padding: 10px;\n\n    .image-gallery-svg {\n      height: 16px;\n      width: 16px;\n    }\n  }\n}\n\n.image-gallery-fullscreen-button {\n  right: 0;\n}\n\n.image-gallery-play-button {\n  left: 0;\n}\n\n.image-gallery-left-nav,\n.image-gallery-right-nav {\n  padding: 50px 10px;\n  top: 50%;\n  transform: translateY(-50%);\n\n  .image-gallery-svg {\n    height: 120px;\n    width: 60px;\n  }\n\n  @media (max-width: $ig-small-screen) {\n    .image-gallery-svg {\n      height: 72px;\n      width: 36px;\n    }\n  }\n\n  @media (max-width: $ig-xsmall-screen) {\n    .image-gallery-svg {\n      height: 48px;\n      width: 24px;\n    }\n  }\n\n  &[disabled] {\n    cursor: disabled;\n    opacity: .6;\n    pointer-events: none;\n  }\n}\n\n.image-gallery-left-nav {\n  left: 0;\n}\n\n.image-gallery-right-nav {\n  right: 0;\n}\n// End of Icon styles\n\n.image-gallery {\n  @include vendor-prefix('user-select', none);\n  -webkit-tap-highlight-color: $ig-transparent;\n  position: relative;\n\n  &.fullscreen-modal {\n    background: $ig-black;\n    bottom: 0;\n    height: 100%;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    width: 100%;\n    z-index: 5;\n\n    .image-gallery-content {\n      top: 50%;\n      transform: translateY(-50%);\n    }\n  }\n}\n\n.image-gallery-content {\n  position: relative;\n  line-height: 0;\n  top: 0;\n\n  &.fullscreen {\n    background: $ig-black;\n  }\n\n  .image-gallery-slide .image-gallery-image {\n    max-height: calc(100vh - 80px); // 80 px for the thumbnail space\n  }\n\n  &.image-gallery-thumbnails-left,\n  &.image-gallery-thumbnails-right {\n    .image-gallery-slide .image-gallery-image {\n      max-height: 100vh;\n    }\n  }\n}\n\n.image-gallery-slide-wrapper {\n  position: relative;\n\n  &.image-gallery-thumbnails-left,\n  &.image-gallery-thumbnails-right {\n    display: inline-block;\n    width: calc(100% - 110px); // 100px + 10px for margin\n\n    @media (max-width: $ig-small-screen) {\n      width: calc(100% - 87px); // 81px + 6px for margin\n    }\n  }\n  &.image-gallery-rtl {\n    direction: rtl;\n  }\n}\n\n.image-gallery-slides {\n  line-height: 0;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.image-gallery-slide {\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n\n  &.image-gallery-center {\n    position: relative;\n  }\n\n  .image-gallery-image {\n    width: 100%;\n    object-fit: contain;\n  }\n\n  .image-gallery-description {\n    background: $ig-background-black;\n    bottom: 70px;\n    color: $ig-white;\n    left: 0;\n    line-height: 1;\n    padding: 10px 20px;\n    position: absolute;\n    white-space: normal;\n\n    @media (max-width: $ig-small-screen) {\n      bottom: 45px;\n      font-size: .8em;\n      padding: 8px 15px;\n    }\n\n  }\n}\n\n.image-gallery-bullets {\n  bottom: 20px;\n  left: 0;\n  margin: 0 auto;\n  position: absolute;\n  right: 0;\n  width: 80%;\n  z-index: 4;\n\n  .image-gallery-bullets-container {\n    margin: 0;\n    padding: 0;\n    text-align: center;\n  }\n\n  .image-gallery-bullet {\n    appearance: none;\n    background-color: transparent;\n    border: 1px solid $ig-white;\n    border-radius: 50%;\n    box-shadow: $ig-shadow;\n    cursor: pointer;\n    display: inline-block;\n    margin: 0 5px;\n    outline: none;\n    padding: 5px;\n    transition: all .2s ease-out;\n\n    @media (max-width: $ig-small-screen) {\n      margin: 0 3px;\n      padding: 3px;\n    }\n\n    @media (max-width: $ig-xsmall-screen) {\n      padding: 2.7px;\n    }\n\n    &:focus {\n      transform: scale(1.2);\n      background: $ig-blue;\n      border: 1px solid $ig-blue;\n    }\n\n    &.active {\n      transform: scale(1.2);\n      border: 1px solid $ig-white;\n      background: $ig-white;\n    }\n\n    @media (hover: hover) and (pointer: fine) {\n      &:hover {\n        background: $ig-blue;\n        border: 1px solid $ig-blue;\n      }\n\n      &.active:hover {\n        background: $ig-blue;\n      }\n    }\n  }\n}\n\n.image-gallery-thumbnails-wrapper {\n  position: relative;\n\n  &.thumbnails-swipe-horizontal {\n    touch-action: pan-y;\n  }\n\n  &.thumbnails-swipe-vertical {\n    touch-action: pan-x;\n  }\n\n  &.thumbnails-wrapper-rtl {\n    direction: rtl;\n  }\n  &.image-gallery-thumbnails-left,\n  &.image-gallery-thumbnails-right {\n    display: inline-block;\n    vertical-align: top;\n    width: 100px;\n\n    @media (max-width: $ig-small-screen) {\n      width: 81px; // 75px + 6px for border\n    }\n\n    .image-gallery-thumbnails {\n      height: 100%;\n      width: 100%;\n      left: 0;\n      padding: 0;\n      position: absolute;\n      top: 0;\n\n      .image-gallery-thumbnail {\n        display: block;\n        margin-right: 0;\n        padding: 0;\n\n        + .image-gallery-thumbnail {\n          margin-left: 0;\n          margin-top: 2px;\n        }\n\n      }\n\n    }\n  }\n\n  &.image-gallery-thumbnails-left,\n  &.image-gallery-thumbnails-right {\n    margin: 0 5px;\n\n    @media (max-width: $ig-small-screen) {\n      margin: 0 3px;\n    }\n  }\n}\n\n.image-gallery-thumbnails {\n  overflow: hidden;\n  padding: 5px 0;\n\n  @media (max-width: $ig-small-screen) {\n    padding: 3px 0;\n  }\n\n  .image-gallery-thumbnails-container {\n    cursor: pointer;\n    text-align: center;\n    white-space: nowrap;\n  }\n\n}\n\n.image-gallery-thumbnail {\n  display: inline-block;\n  border: 4px solid transparent;\n  transition: border .3s ease-out;\n  width: 100px;\n  background: transparent;\n  padding: 0;\n\n  @media (max-width: $ig-small-screen) {\n    border: 3px solid transparent;\n    width: 81px;\n  }\n\n  + .image-gallery-thumbnail {\n    margin-left: 2px;\n  }\n\n  .image-gallery-thumbnail-inner {\n    display: block;\n    position: relative;\n  }\n\n  .image-gallery-thumbnail-image {\n    vertical-align: middle;\n    width: 100%;\n    line-height: 0;\n  }\n\n  &.active,\n  &:focus {\n    outline: none;\n    border: 4px solid $ig-blue;\n\n    @media (max-width: $ig-small-screen) {\n      border: 3px solid $ig-blue;\n    }\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      outline: none;\n      border: 4px solid $ig-blue;\n\n      @media (max-width: $ig-small-screen) {\n        border: 3px solid $ig-blue;\n      }\n    }\n  }\n\n}\n\n.image-gallery-thumbnail-label {\n  box-sizing: border-box;\n  color: white;\n  font-size: 1em;\n  left: 0;\n  line-height: 1em;\n  padding: 5%;\n  position: absolute;\n  top: 50%;\n  text-shadow: $ig-shadow;\n  transform: translateY(-50%);\n  white-space: normal;\n  width: 100%;\n\n  @media(max-width: $ig-small-screen) {\n    font-size: .8em;\n    line-height: .8em;\n  }\n}\n\n.image-gallery-index {\n  background: $ig-background-black;\n  color: $ig-white;\n  line-height: 1;\n  padding: 10px 20px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 4;\n\n  @media(max-width: $ig-small-screen) {\n    font-size: .8em;\n    padding: 5px 10px;\n  }\n}","@import \"~react-image-gallery/styles/scss/image-gallery.scss\";\r\nhtml{\r\n  overflow-x: hidden;\r\n    scroll-behavior: smooth;\r\n\r\n  \r\n}\r\n.__react_modal_image__medium_img {\r\n  max-height: 70%!important;\r\n}\r\n.attributed-text-segment-list__container{\r\n  display: none!important;\r\n}\r\n#webpack-dev-server-client-overlay{\r\n   display:none!important;\r\n}\r\nbody{\r\n  overflow-x: hidden;\r\n}\r\n.header{\r\n  // position: fixed;\r\n  // height: 100px;\r\n\r\n    // position: fixed;\r\n    position: relative;\r\n    z-index: 35555555;\r\n    // overflow:visible;\r\n    width: 100%;\r\n\r\n}\r\n// .sss{\r\n//   position: relative!important;\r\n// }\r\n.Header-logo{\r\n  // margin-left: 80px!important;\r\n  // margin-left: 10%!important;\r\n}\r\n.header-container{\r\n  padding-left: 0px!important;\r\n}\r\n.whatsapp{\r\n  position: fixed;\r\n  right: 25px;\r\n  bottom: 14%;\r\n  z-index: 10000000;\r\n}\r\n.arr:hover{\r\n   background: #ff5c00!important;\r\n   cursor: pointer;\r\n}\r\n.__react_modal_image__medium_img{\r\n  width: auto!important;\r\n  height: auto!important;\r\n  border-radius: 20px;\r\n  border: 3px solid white;\r\n  // pointer-events: none;\r\n}\r\n.__react_modal_image__modal_container {\r\n  z-index: 99999000!important;\r\n}\r\n.h-ban .slick-next{\r\n  height: 80%;\r\n  z-index: 111111;\r\n  width: 50%;\r\n  opacity: -1;\r\n  display: block!important;\r\n}\r\n.h-ban .slick-prev{\r\n  height: 40%;\r\n  z-index: 11;\r\n  width: 50%;\r\n  opacity: -1;\r\n  display: block!important;\r\n  @media(max-width:767px){\r\n  height:30%!important;\r\n}\r\n}\r\n\r\n@media(max-width:576px){\r\n  .Header-logo{\r\n    margin-left: 25px;\r\n  }\r\n}\r\n@media(max-width:517px){\r\n  .head-viewallpro-dom{\r\ndisplay: none;\r\n  }\r\n}\r\n.nav-link li a{\r\n    color: #333333;\r\n    font-size: 14px;\r\n    \r\n    text-decoration: none;\r\n    padding: 0.5em;\r\n}\r\n.nav-link li{\r\n   list-style: none;\r\n   \r\n}\r\n.nav-item{\r\n  padding: 0px 12px;\r\n}\r\n.menu1 {\r\n  padding-right: 10px;\r\n  margin-top: -2px;\r\n}\r\n// .nav-item{\r\n//   padding-right: 25px;\r\n// }\r\n.navbar {\r\n  // position: unset;\r\n  position: fixed;\r\n  height: 100px;\r\n  right: 0;\r\n  background: rgb(255, 255, 255);\r\n}\r\n.navbar-nav{\r\n  height: 100px;\r\n}\r\n.naa{\r\n  position: absolute;\r\n  right: 0;\r\n}\r\n\r\n.nav-link{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin: 0;\r\n    font-size: 14px;\r\n    padding: 0;\r\n    \r\n }\r\n .active .nav-link{\r\n  color: #ff5c00!important;\r\n  font-weight: 500!important;\r\n }\r\n .nav-link:hover{\r\n      color: #ff5c00!important;\r\n }\r\n nav{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.nav-product{\r\nbackground: #002B85;\r\nbackground-position: 100% 100%;\r\nheight: 100px;\r\npadding: 39px;\r\n\r\n a{\r\n    color: white;\r\n    text-decoration: none;\r\n    \r\n    }\r\n}\r\n.nav-product-list{\r\n \r\n  text-decoration: none!important;\r\n  color: #FFFFFF;\r\n\r\n}\r\n.nav-product-list:hover{\r\n  color:#ff5c00 !important;\r\n}\r\n.clients-div{\r\n  border-bottom: 2px solid #002b85;\r\n  margin: 30px 0;\r\n}\r\n.clients-div-logo{\r\n  margin: 15px;\r\n  border-right: 2px solid #002b85;\r\n}\r\n\r\n.nav-product:hover{\r\n  background: linear-gradient(#00A1ED, #00A1ED 50%, #002B85 50%, #002B85);\r\n  background-size: 100% 200%;\r\n  /*trasition effect for background*/\r\n  transition: background 0.2s;\r\n  .menu2{\r\n    display: block;\r\n    padding-right: 13px;\r\n  }\r\n  .menu1{\r\n    display: none;\r\n  }\r\n}\r\n.menu2{\r\n  display: none;\r\n}\r\n\r\n\r\n@media(min-width: 768px) and (max-width: 1214px){\r\n  .nav-item{\r\n    padding: 0px 10px;\r\n  }\r\n  .navbar {\r\n    // position: unset;\r\n    height: auto;\r\n    min-height: 100px;\r\n  }\r\n  .navbar-nav{\r\n    height: auto;\r\n  }\r\n}\r\n@media(max-width:768px){\r\n  .navbar {\r\n    // position: unset;\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n  .navbar-nav{\r\n    height: auto;\r\n  }\r\n}\r\n@media(max-width:992px){\r\n  .naa{\r\n    background: white;\r\n    position: fixed;\r\n    left: 0;\r\n    top: 68px;\r\n    overflow: scroll;\r\n    height: 100vh;\r\n  }\r\n}\r\n// .homeBanner{\r\n//     width: 100%;\r\n//     position: absolute;\r\n// }\r\n// .homeBannerTXT{\r\n//     position: relative;\r\n    \r\n// }\r\n.homeBanner{\r\n  position: relative;\r\n  // opacity: 0.85;\r\n}\r\n.intro{\r\n  position: absolute!important;\r\n  top: 40%;\r\n  margin-left: 150px;\r\n  opacity: 0.7;\r\n@media(min-width:1500px){\r\ntop:45%!important;\r\n}\r\n}\r\n.homeBanner{\r\n  filter: brightness(0.7);\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n.banner-text1{\r\n\r\n    top: 80px;\r\n    left: 100px;\r\n    width: 132px;\r\n    height: 18px;\r\n    position: absolute;\r\n    color: #FFFFFF;\r\n    font-size: 14px;\r\n  }\r\n.num{\r\n    top: 80px;\r\n    left: 81px;\r\n    width: 20px;\r\n    height: 18px;\r\n    position: absolute;\r\n    color: #FF5C00;\r\n    font-size: 14px;\r\n\r\n  }\r\n\r\n.arbtn{\r\n  background: #002B85;\r\n  border: none;\r\n  margin-top: 30px;\r\n}\r\n.btns2{\r\n  margin-left: 10px;\r\n}\r\n.arbtn img{\r\n  height: 44px!important;\r\n}\r\n\r\n.banner-text2{\r\n    // font-family: Akzidenz-Grotesk Next;    \r\n    \r\n    font-size:32px;  \r\n    top: 130px;\r\n    left: 81px;\r\n    width: 409px;\r\n    height: 82px;\r\n    position: absolute;\r\n    color: #FFFFFF;\r\n  }\r\n\r\n  .banner-text3{\r\n    // font-family: Akzidenz-Grotesk Next;\r\n    font-size: 20px;\r\n    top: 250px;\r\n    left: 81px;\r\n    width: 408px;\r\n    height: 52px;\r\n    position: absolute;\r\n    color: #FFFFFF;\r\n  }\r\n\r\n//   button {\r\n//     position: absolute;\r\n//     top: 339px;\r\n//     left: 81px;\r\n//     width: 200px;\r\n//     height: 50px;\r\n//     color:white;\r\n//     background-color: #002B85;\r\n//     border-radius: 10px;\r\n//     border-color: initial;\r\n    \r\n// }\r\n \r\n.btn {\r\n    position: absolute;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 200px;\r\n    height: 50px;\r\n    color: white !important;;\r\n    background-color: #002B85;\r\n    border-radius: 10px;\r\n    border:none;\r\n    // border-color: initial;\r\n    z-index: 20;\r\n    transition: all 0.35s cubic-bezier(1, 0, 0, 1);\r\n  }\r\n  \r\n  .btn:hover {\r\n    color: #fcfcfc;\r\n  }\r\n  \r\n  .btn-color {\r\n    border-color: #002B85;\r\n    color: #002B85;\r\n  }\r\n  .btn-color::before, .btn-color::after {\r\n    border-radius: 10px;\r\n    border-color: #FF5C00;\r\n    background: #FF5C00;\r\n  }\r\n  \r\n  .btn::before,\r\n  .btn::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    z-index: -1;\r\n    transition: all 0.35s cubic-bezier(1, 0, 0, 1);\r\n  }\r\n  \r\n  .btn-l-r::after {\r\n    height: 100%;\r\n    width: 0;\r\n    top: 0;\r\n  }\r\n  \r\n  .btn-l-r:hover::after {\r\n    width: 100%;\r\n  }\r\n  \r\n  .btn-l-r::after {\r\n    left: 0;\r\n  }\r\n\r\n\r\n\r\n  .slick-dots {\r\n    // top: 100px;  // play with the number of pixels to position it as you want\r\n    // left: 100px; // play with the number of pixels to position it as you want\r\n    top: 50%;\r\n    right: -95%;\r\n  }\r\n.slick-dots li {\r\n    position: relative;\r\n    display: block !important;\r\n    width: 20px;\r\n    height: 20px;\r\n    margin: 0 5px;\r\n    padding: 0;\r\n    \r\n}\r\n\r\n\r\n.slick-dots li button::before{\r\n    display: none!important;\r\n}\r\n.slick-dots li button{\r\n    width: 2px!important;\r\n    height: 2px!important;\r\n    padding: 3px !important;\r\n    border-radius: 50%!important;\r\n    border: 1px solid #ffffff!important;\r\n    margin: 5px!important;\r\n}\r\n.slick-active button{\r\n    background-color: #ffffff!important;\r\n}\r\n// .slick-dots li button:active{\r\n//     background-color: #FF5C00!important;\r\n// }\r\n.about-us{\r\n    background: #EFF7FF;\r\n    padding-top: 80px;\r\n    margin-top: -5px;\r\n}\r\n.development-support{\r\n  margin: 50px 0;\r\n}\r\n@media(max-width:1200px){\r\n  .about-us-sub-con{\r\n    margin-left: 10px!important;\r\n    margin-right: 10px!important;\r\n  }\r\n \r\n}\r\n@media(max-width:998px){\r\n  .aboutimg-div{\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n}\r\n.aboutimg{\r\n    width: 95%;\r\n    border-radius: 20px;\r\n    height: 90%;\r\n    // height: 480px;\r\n}\r\n.development-support img{\r\n  border-radius: 20px;\r\n}\r\n.Ser_slid .__react_modal_image__modal_content img{\r\n  margin-left: -9%;\r\n}\r\n// .g-img{\r\n//   max-height: 250px!important;\r\n//   max-width: 100%!important;\r\n// }\r\n.banner-txt{\r\n    display: flex;\r\n}\r\n.banner-num{\r\n    color: #FF5C00;\r\n    font-size: 14px;\r\n}\r\n.intro{\r\n  .banner-num{\r\n    color: #ff5c00!important;\r\n    font-size: 14px;\r\n}\r\n.banner-title{\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  margin-left: 20px;\r\n}\r\n}\r\n .banner-title{\r\n    color: #333333;\r\n    font-size: 14px;\r\n    margin-left: 20px;\r\n }\r\n .txt1{\r\n    // font-family: Akzidenz-Grotesk Next;\r\n    font-size: 32px;\r\n    color: #FFFFFF;\r\n    font-weight: bold;\r\n    \r\n }\r\n .txt2{\r\n     color: #002B85;\r\n    //  font-family: Akzidenz-Grotesk Next;\r\n     font-weight: bold;\r\n     \r\n     font-size: 30px;\r\n }\r\n .our-products .txt2{\r\n  padding-left: 0!important;\r\n }\r\n .txt3{\r\n     color: #3B3B3B;\r\n     font-size: 18px;\r\n }\r\n .txt4{\r\n        color: #002B85;\r\n        font-size: 16px;\r\n        font-weight: bold;\r\n }\r\n .txt5{\r\n     color: #7C90A2;\r\n     font-size: 16px;\r\n }\r\n .txt6{\r\n   color: #0A0A0A;\r\n    font-size: 26px;\r\n    padding-left: 100px;\r\n }\r\n .txt7{\r\n    color: #FFFFFF;\r\n    font-size: 20px;\r\n    font-weight: lighter;\r\n }\r\n  .txt8{\r\n      color: #000000;\r\n      font-size: 18px;\r\n      \r\n  }\r\n  .our-products{\r\n    padding-top: 20px;\r\n  }\r\n  .txt9{\r\n    color: #FFFFFF;\r\n    font-size: 10px;\r\n  }\r\n  .txt10{\r\n    color: #FFFFFF;\r\n    font-size: 20px;\r\n    \r\n }\r\n .txt11{\r\n  color: #ffffff;\r\n  // font-family: Akzidenz-Grotesk Next;\r\n  font-weight: bold;\r\n  font-size: 30px;\r\n}\r\n.txt12{\r\n  color: #ffffff;\r\n  font-size: 18px;\r\n  \r\n}\r\n.txt13{\r\n  color: #ffffff;\r\n  font-size: 24px;\r\n}\r\n.txt14{\r\n  color:#0A0A0A;\r\n  font-size:24px;\r\n  font-weight:500;\r\n}\r\n.txt15{\r\n  color:#0A0A0A;\r\n  font: size 20px;\r\n}\r\n.txt16{\r\n  color: #0A0A0A;\r\n  font-size: 32px;\r\n}\r\n.txt17{\r\n  color: #FFFFFF;\r\n  font-size: 17px;\r\n}\r\n.txt18{\r\n  color: #002B85;\r\n  font-size: 18px;\r\n}\r\n.txt19{\r\n  font-size: 24px;\r\n  color: #002B85;\r\n  font-weight: bold;\r\n}\r\n.txt20{\r\n  color: #000000;\r\n  font-size: 12px;\r\n  \r\n}\r\n.txt21{\r\n  color: #3B3B3B;\r\n  font-size: 18px;\r\n}\r\n.txt22{\r\n  font-size: 14px;\r\n  color: #555555;\r\n}\r\n.txt23{\r\n  font-size: 24px;\r\n  color: #000000;\r\n  font-weight: bold;\r\n}\r\n\r\n .btn2 {\r\n    position: relative;\r\n    display: block;\r\n    width: 200px;\r\n    height: 50px;\r\n    color:white;\r\n    align-items: center;\r\n    background: transparent;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-decoration: none;\r\n    border: 2px solid #002B85; \r\n    z-index: 20;\r\n    transition: all 0.35s cubic-bezier(1, 0, 0, 1);\r\n  }\r\n  \r\n  .btn2:hover {\r\n    color: #fcfcfc;\r\n    border: none;\r\n  }\r\n  \r\n  .btn2-color {\r\n    border-color: #002B85;\r\n    color: #002B85;\r\n  }\r\n  .btn2-color::before, .btn2-color::after {\r\n    border-radius: 10px;\r\n    border-color: #FF5C00;\r\n\r\n    border: none;\r\n    \r\n    background: #FF5C00;\r\n  }\r\n  \r\n  .btn2::before,\r\n  .btn2::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    z-index: -1;\r\n    transition: all 0.35s cubic-bezier(1, 0, 0, 1);\r\n  }\r\n  \r\n  .btn2-l-r::after {\r\n    height: 100%;\r\n    width: 0;\r\n    top: 0;\r\n  }\r\n  \r\n  .btn2-l-r:hover::after {\r\n    width: 100%;\r\n  }\r\n  \r\n  .btn2-l-r::after {\r\n    left: 0;\r\n  }\r\n\r\n  .data1\r\n  {\r\n      border-right: 2px solid #002B85;\r\n  }\r\n  .data1:last-child{\r\n    border-right: none;\r\n  }\r\n  @media (max-width: 768px) {\r\n    .data1\r\n    {\r\n        border-right: none;\r\n    }\r\n  }\r\n\r\n\r\n\r\n\r\n  .banner-txt-Dev{\r\n    // text-align: center;\r\n    display:flex;\r\n    \r\n    // justify-content: space-around;\r\n    width: 310px;\r\n    height: 20px;\r\n    transform: rotate(-90deg) translate(-100%, 0);\r\n    transform-origin: 0 0;\r\n  }\r\n  .Our_Ser{\r\n    background-color: #EFF7FF;\r\n    overflow-x: hidden;\r\n  }\r\n  @media(max-width:992px){\r\n    .banner-txt-Dev {     \r\n      width: 230px;    \r\n  }\r\n  }\r\n  @media(max-width:568px){\r\n    .Our_Ser{\r\n      padding-left: 20px;\r\n    }\r\n  }\r\n \r\n  .banner-txt-Ser{\r\n    // text-align: center;\r\n    display:flex;\r\n        \r\n    // justify-content: space-around;\r\n    width: 207px;\r\n    height: 20px;\r\n    transform: rotate(-90deg) translate(-100%, 0);\r\n    transform-origin: 0 0;\r\n  }\r\n  .dev-img1{\r\n    width: 78%;\r\n    max-height: 370px;\r\n  }\r\n  .dev-img2{\r\n    width:100% ;   \r\n    height:286px;\r\n    object-fit:cover;\r\n  }\r\n  .homeBanner{\r\n    padding-top: 0!important;\r\n  }\r\n.Ser_slid{\r\n  margin-left: 50px;\r\n}\r\n.Ser_slid .slick-slide{\r\n  @media (min-width: 768px) and (max-width: 1200px) {\r\n  width: 250px!important;\r\n  }\r\n}\r\n.Ser_slid .slick-current{\r\n  @media (min-width: 768px) and (max-width: 1200px) {\r\n    width: 400px!important;\r\n    }\r\n}\r\n.Ser_slid img{\r\n  // width: 285px;\r\n  // height: 306px;\r\n  // width: auto;\r\n  height: 406px;\r\n  object-fit: cover;\r\n    border-radius: 20px;\r\n  @media(max-width:1000px){\r\n     height: 300px;\r\n  }\r\n\r\n}\r\n@media(max-width:768px){\r\n  .dev-img2{\r\n    width:100% ;   \r\n    height:auto;\r\n  }\r\n}\r\n@media(max-width:568px){\r\n  .slide-img{\r\n    // height: 150px!important;\r\n    width: 68px!important;\r\n  }\r\n  .Ser_slid {\r\n    margin-left: 0px;\r\n}\r\n}\r\n\r\n  .Ser_slid .slick-initialized .slick-slide {\r\n    display: block;\r\n    padding-right: 25px;\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n}\r\n// .slick-center {\r\n//   -webkit-transform: scale(1.25);\r\n//   -moz-transform: scale(1.25);\r\n//   transform: scale(1.25);\r\n// }\r\n\r\n.slick-arrow{\r\n    display: none!important;\r\n}\r\n.slick-slide img{\r\n  padding-top: 150px;\r\n}\r\n.slick-center img{\r\n  padding-top: 0px!important;\r\n}\r\n\r\n\r\n.show .pro{\r\n  display: block!important;\r\n}\r\n.pro{\r\n  background-color: #002B85;\r\n  position: absolute;\r\n  border-radius: 0px 0px 20px 20px;\r\n  margin-top: 29px;\r\n  right: 0;\r\n  display: none!important;\r\n  top: 71px;\r\n  width: 100%;\r\n  /* width: 873px;\r\n  height: 496px; */\r\n  color: #EFF7FF;\r\n  font-size: 14px;\r\n  z-index: 2;\r\n  @media (max-width: 480px) {\r\n    background-color: transparent;\r\n  }\r\n}\r\n.pro p{\r\n  padding: 0;\r\n  text-align: left;\r\n}\r\n.navbar-nav{\r\n  align-items: center;\r\n}\r\n.btn-products{\r\n  border: 1px solid #FFFFFF;\r\n  border-radius: 10px;\r\n  text-align: center;\r\n  align-items: center;\r\n  width: 184px;\r\n  height: 34px;\r\n  padding: 6px;\r\n}\r\n@media(max-width:1024px){\r\n  .banner-num{\r\n    margin-bottom: 0!important;\r\n  }\r\n  .intro{\r\n    top:26%;\r\n  }\r\n}\r\n@media (max-width: 992px)\r\n{\r\n    .pro{\r\n        position:relative !important;\r\n        width: 100% !important;\r\n        margin-top: 0;\r\n        top: 0;\r\n        \r\n    }\r\n    .pro p{\r\n        padding: 0;\r\n        text-align: center;\r\n    }\r\n    .btn-products{\r\n       \r\n        height: 34px;\r\n        width: 150px!important;\r\n        display: flex;\r\n        /* text-align: center; */\r\n        align-items: center;\r\n        justify-content: space-around;\r\n        \r\n    }\r\n    .nav-product{\r\n        border-radius: 10px 10px;\r\n    }\r\n    .navbar-nav{\r\n      align-items: normal!important;\r\n    }\r\n    .navbar-nav li{\r\n      padding: 10px;\r\n    }\r\n    .txt1{\r\n      font-size: 25px;\r\n    }\r\n    .txt7{\r\n      font-size: 18px;\r\n    }\r\n    .txt6{\r\n      font-size: 20px;\r\n    }\r\n    .txt2{\r\n      font-size: 20px;\r\n    }\r\n    .txt3{\r\n      font-size: 15px;\r\n    }\r\n    .btn{\r\n      margin-top: 10px !important;\r\n      left: 25%;\r\n    }\r\n}\r\n@media (max-width:768px){\r\n  .intro {\r\n    \r\n    top: 30%!important;\r\n    margin-left: 75px;\r\n}\r\n.Ser_slid .slick-initialized .slick-slide {\r\n  display: block;\r\n  padding: 19px;\r\n}\r\n.our-Ser-btn{\r\n  display: flex;\r\n  justify-content: center;\r\n  \r\n}\r\n.our-Ser-title{\r\n  .offset-3{\r\n    margin-left: 0;\r\n  }\r\n  text-align: center;\r\n}\r\n.txt1{\r\n \r\n  padding-top: 0!important;\r\n}\r\n.banner-num{\r\n  margin-bottom: 0!important;\r\n}\r\n}\r\n@media (max-width:668px){\r\n  .intro {\r\n    \r\n    top: 30%!important;\r\n    margin-left: 30px;\r\n    \r\n}\r\n.intro .txt1{\r\n  padding-top: 0!important;\r\n  margin-bottom: 0!important;\r\n}\r\n.txt1{\r\n  font-size: 15px;\r\n  padding-top: 0;\r\n}\r\n.banner-title{\r\n  font-size: 10px;\r\n}\r\n.banner-num{\r\n  font-size: 10px;\r\n}\r\n.txt7 {\r\n  font-size: 12px;\r\n}\r\n.btn {\r\n\r\n  width: 156px;\r\n  height: 35px;\r\n  font-size: 12px;\r\n}\r\n\r\n\r\n.slick-dots {\r\n  top: 30%;\r\n  right: -90%;\r\n}\r\n.homeBanner{\r\n  height: 250px;\r\n}\r\n.pro{\r\n  padding: 30px!important;\r\n}\r\n}\r\n@media(max-width:568px){\r\n  .Ser_slid .slick-initialized .slick-slide {\r\n    display: block;\r\n    padding: 12px;\r\n}\r\n.our-products img {\r\n  width: 250px!important;\r\n  height: 200px!important;\r\n}\r\n.our-products{\r\n  margin-left: 20px;\r\n  overflow-x: hidden;\r\n}\r\n}\r\n\r\n\r\n// .our-products .btn2{\r\n//   float: right;\r\n// }\r\n.our-products img{\r\n  width: 320px;\r\n  height: 280px;\r\n  \r\n}\r\n.our-pro .Our-pro-img{\r\n  border-right: #002B85 solid 2px;\r\n  @media (max-width: 768px){\r\n    border-right: none!important;\r\n  }\r\n}\r\n.Our-pro-img{\r\n  border-bottom: #002B85 solid 2px;\r\n}\r\n.our-pro:nth-child(3n) .Our-pro-img {\r\n  border-right: none!important;  \r\n}\r\n\r\n\r\n.our-pro-con{\r\n  border-bottom: #ffffff solid 2px;\r\n}\r\n.our-pro:hover .our-pro-con{\r\n  // background: #002B85;\r\n color: white;\r\n  background: linear-gradient(#002B85, #002B85 50%, #ffffff 50%, #ffffff);\r\n  background-size: 100% 200%;\r\n  /*trasition effect for background*/\r\n  transition: background 0.5s;\r\n  \r\n  // height: 58px;\r\n}\r\n.our-pro-con{\r\n \r\n  background-position: 100% 100%;\r\n\r\n \r\n}\r\n@media(max-width:991px){\r\n  .Our-pro-img-1{\r\n    border-bottom: #002B85 solid 2px;\r\n    border-right: none;\r\n  }\r\n  .Our-pro-img-2{\r\n    border-bottom: #002B85 solid 2px;\r\n    border-right: #002B85 solid 2px;\r\n  }\r\n  .Our-pro-img-3{\r\n    border-bottom: #002B85 solid 2px;\r\n    border-right: none;\r\n  }\r\n  .Our-pro-img-4{\r\n    border-bottom: #002B85 solid 2px;\r\n    border-right: #002B85 solid 2px;\r\n  }\r\n  .Our-pro-img-5{\r\n    border-bottom: #002B85 solid 2px;\r\n  }\r\n}\r\n@media(max-width:767px){\r\n  .Our-pro-img{\r\n    border-bottom: #002B85 solid 2px;\r\n    border-right:none;\r\n  }\r\n  .Our-pro-img-1{\r\n    border-bottom: #002B85 solid 2px;\r\n    border-right: none;\r\n  }\r\n  .Our-pro-img-2{\r\n    border-bottom: #002B85 solid 2px;\r\n    border-right: none;\r\n  }\r\n  .Our-pro-img-3{\r\n    border-bottom: #002B85 solid 2px;\r\n    border-right: none;\r\n  }\r\n  .Our-pro-img-4{\r\n    border-bottom: #002B85 solid 2px;\r\n    border-right: none;\r\n  }\r\n  .Our-pro-img-5{\r\n    border-bottom: #002B85 solid 2px;\r\n  }\r\n  .our-pro-btn {    \r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n}\r\n\r\n// .slick-initialized { \r\n//   overflow: hidden; \r\n  \r\n// }\r\n.Ser_slid .slick-list .slick-active:nth-child(2){\r\n  margin-top: -100px;\r\n}\r\nmark{\r\n  color: white;\r\n  background: #FF5C00;}\r\n.previous{\r\n  z-index: 999;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  bottom: 30%;\r\n  left: -50px;\r\n  @media(max-width: 420px){\r\n    left: -5px;\r\n    bottom: 50%;\r\n  }\r\n}\r\n.next{\r\n  z-index: 999;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  bottom: 30%;\r\n  right: 0;\r\n  @media(max-width: 420px){\r\n    right: 4px;\r\n    bottom: 50%;\r\n  }\r\n}\r\n.Ser_slid .slick-list{\r\n  margin-right: 30px;\r\n}\r\n .arrow svg {\r\n  width: 57px;\r\n    height: 56px;\r\n  font-weight: 600;\r\n  color: #ff5c00;\r\n  @media(max-width: 420px){\r\n    width: 23px!important;\r\n    height: 23px;\r\n  }\r\n }\r\n.ser-slide .slick-initialized{\r\n  padding-left: 40px;\r\n}\r\n.latest_news_area{\r\n  overflow-x: hidden;\r\n  background: url(\"../../public/asset/images/Mask\\ Group\\ 29.png\");\r\n  background-repeat: no-repeat;\r\n  // height: 980px;\r\n}\r\n// .latest_news_area::before {\r\n//   position: absolute;\r\n//   content: '';\r\n//   z-index: -1;\r\n//   width: 50%;\r\n//   height: 100%;\r\n//   background: url(\"../../public/asset/images/Mask\\ Group\\ 29.png\");\r\n//   background-size: cover;\r\n// }\r\n.latest_news{\r\n  margin-left: 30%;\r\n padding-top: 8%;\r\n}\r\n#direct-post-widget[data-iframeembed=true] #createPostButton {\r\n  display: none!important;\r\n  z-index: -1111!important;\r\n}\r\n.latest_feed{\r\n  margin-left: 0!important;\r\n  padding-bottom: 50px;\r\n}\r\n.latest_news .btn2{\r\n  margin-left: 15px;\r\n}\r\n.news-img{\r\n  width: 246px;\r\n  height: 248px;\r\n  position: relative;\r\n}\r\n.news-img img{\r\n  position: relative;\r\n}\r\n.news-date{\r\n  position: relative;\r\n  right: -119px;\r\n  top: 15px;\r\n}\r\n.news-title{   \r\n      bottom: -230px;     \r\n      position: absolute;     \r\n      width: 225px;     \r\n  \r\n}\r\n.contact-us-bg{\r\n  background-color: #002B85;\r\n  margin-left: 13%;\r\n}\r\n.contact-us-bg .btn2{\r\n border: #EFF7FF solid 2px;\r\n color: #FFFFFF;\r\n}\r\n.contact-us-bg img{\r\n//   max-width: 509px;\r\n//   max-height: 361px;\r\nmax-width: 95%;\r\n}\r\n.banner-txt-contact{\r\n  display:flex;\r\n        \r\n    // justify-content: space-around;\r\n    width: 300px;\r\n    height: 20px;\r\n    transform: rotate(-90deg) translate(-100%, 0);\r\n    transform-origin: 0 0;\r\n    margin-left: 100px;\r\n}\r\n@media(max-width:768px){\r\n  .contact-us-bg img{\r\n    //   max-width: 509px;\r\n    //   max-height: 361px;\r\n    max-width: 95%;\r\n    margin-top: 25%;\r\n    }\r\n    .banner-txt-contact{\r\n      margin-left: 80px;\r\n    }\r\n    .latest_news{\r\n      margin-left: 10%;\r\n    }\r\n}\r\n@media(max-width:568px){\r\n  .news-img{\r\n    padding: 0!important;\r\n  }\r\n}\r\n\r\n\r\n.footer-top{\r\n  background-color: #ECECEC;\r\n}\r\n.footer-top .container{\r\n  padding-top: 55px;\r\n  padding-bottom: 50px;\r\n}\r\n.logo{\r\n  width: 237px;\r\n  height: 93px;\r\n}\r\n// .foot-logo a {\r\n//   margin-left: 25px;\r\n// }\r\n// .foot-logo  p {\r\n//   margin-left: 25px;\r\n// }\r\n// .tail-row ul{\r\n//   margin-left: 18px;\r\n// }\r\n.footer-title{\r\n  color: #002B85;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  /* text-align: center; */\r\n  a{\r\n    text-decoration: none;\r\n    color: #002B85;\r\n  }\r\n}\r\n.footer-Qlink{\r\n  margin-left: 10px;\r\n}\r\n\r\n.list{\r\n  list-style:none;\r\n  padding-left: 0%;\r\n  color: #3B3B3B;\r\n  font-size: 14px;\r\n  padding-top: 25px;\r\n  \r\n}\r\n.list li{\r\n  \r\n  padding-top: 5px;\r\n  a{\r\n    text-decoration: none;\r\n    color: #3B3B3B;\r\n  }\r\n}\r\n.list li a:hover{\r\n  color: #FF5C00;\r\n  font-weight: 600;\r\n}\r\n.tail ul li a:hover{\r\n  color: #FF5C00;\r\n  font-weight: 600;\r\n}\r\n.Novacancy .btn{\r\n  padding-top: 0.8em !important;\r\n  margin-left: 145px;\r\n}\r\n\r\n.footer-bottom{\r\n    \r\n  width: 100%;\r\n  padding: 20px 0;\r\n  background-color: #002B85;\r\n}\r\n.tail{\r\n  \r\n  // width: 100%;\r\n  // min-height: 100px;\r\n  // background-color: #002B85;\r\n}\r\n.tail ul li{\r\n  list-style:none;\r\n  display:inline-block;\r\n  color: #FFFFFF;\r\n  // padding-top: 40px;\r\n  // padding-bottom: 40px;\r\n  padding-right: 20px;\r\n  font-size: 14px;\r\n  a{\r\n    text-decoration: none;\r\n    color: #FFFFFF;\r\n  }\r\n}\r\n.footer-text2{\r\n  color: #FFFFFF;\r\n  // padding-top: 40px;\r\n  // padding-bottom: 40px;\r\n  padding-left: 3px;\r\n  margin: 0%;\r\n  font-size: 14px;\r\n}\r\n.footer-img{\r\n  width: 140px;\r\n  height: 33px;\r\n  // margin-left: -25px;\r\n  // margin-top: 40px;\r\n  // margin-bottom: 40px;\r\n}\r\n.footer-text{\r\n  \r\n  color: #fc0000;\r\n  // padding-top: 40px;\r\n  // padding-bottom: 40px;\r\n  font-size: 14px;\r\n  // width: 240px;\r\n  margin: 0%;\r\n  /* padding-right: 25px; */\r\n  \r\n}\r\n@media(min-width:767px) and (max-width:830px){\r\n  .tail-row {\r\n    display: block;\r\n    ul{\r\n      margin: 0px!important;\r\n      text-align: center;\r\n      width: 100%!important;\r\n    }\r\n  }\r\n  .tail-row-logo{\r\n    justify-content: flex-start!important;\r\n    width: 100%!important;\r\n  }\r\n}\r\n@media(max-width:576px){\r\n  .foot-logo{\r\n    margin-left: 15px;\r\n  }\r\n  .tail{\r\n    padding: 0px 10px;\r\n  }\r\n}\r\n.Def-banner{\r\n  position: relative;\r\n  // margin-top: 100px\r\n}\r\n.Def-banner-image{\r\n//  height: 503px;\r\n// background:cover;\r\n\r\n width: 100%;\r\n}\r\n.Def-banner-text{\r\n  position: absolute;\r\n  bottom: 100px;\r\n  color: #FFFFFF;\r\n  font-size: 50px;\r\n  // left: 80px;\r\n}\r\n@media(max-width:768px){\r\n  .Def-banner-text{\r\n    bottom: 30px;\r\n  }\r\n}\r\n@media(max-width:574px){\r\n  .Def-banner-image{\r\n    height: 315px;\r\n  \r\n   }\r\n}\r\n@media (min-width:1500px) {\r\n  .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {\r\n    max-width: 1450px;\r\n}\r\n}\r\n@media (min-width:1620px) {\r\n  .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {\r\n    max-width: 1450px;\r\n}\r\n}\r\n.since{\r\n  overflow-x: hidden;\r\n}\r\n\r\n.since-top-link{\r\n  border: 1px solid #002B85;\r\n  border-radius: 20px;\r\n  margin-top: 30px;\r\n  \r\n}\r\n.since-top-link-text{\r\n  margin: 20px 0px;\r\n}\r\n.since-top-links{\r\n  margin: 20px 0px;\r\n  border-right: 1px solid #002B85;\r\n  text-align: center;\r\n  a{\r\n    color: #002B85;\r\n    font-size: 18px;\r\n    text-decoration: none;\r\n    \r\n  }\r\n  a:hover{\r\n    color: #FF5C00;\r\n  }\r\n}\r\n.since-top-links:last-child{\r\n  border-right: none;\r\n}\r\n@media(max-width:767px){\r\n  .since-top-links:nth-child(3){\r\n    border-right: none;\r\n  }\r\n}\r\n@media(max-width:576px){\r\n  .since-top-links:nth-child(3){\r\n    border-right: 1px solid #002B85;\r\n  }\r\n  .since-top-links:nth-child(2){\r\n    border-right: none;\r\n  }\r\n  .since-top-links:nth-child(4){\r\n    border-right: none;\r\n  }\r\n}\r\n.since-con{\r\n  margin-top: 80px;\r\n  @media(max-width:991px){\r\n    margin-top: 20px;\r\n  }\r\n}\r\n.since-con img{\r\n  // max-width: 505px;\r\n  // max-height: 476px;\r\n  width: 100%;\r\n \r\n}\r\n@media(max-width:1200px){\r\n  .since-img{\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n \r\n}\r\n\r\n.since-title{\r\n  font-size: 30px;\r\n  font-weight: bold;\r\n  color: #002B85;\r\n  margin-top: 45px;\r\n  padding-left: 20px;\r\n}\r\n.since-desc{\r\n  font-size: 17px;\r\n  color: #3B3B3B;\r\n  margin-top: 27px;\r\n  margin-bottom: 0px;\r\n  padding-left: 20px;\r\n  @media(max-width:1300px){\r\n    margin-bottom: 0px;\r\n  }\r\n  @media(max-width:1200px){\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n\r\n\r\n.profile-container{\r\n  background:#EFF7FF;\r\n  margin-top: 26px;\r\n}\r\n.CompanyProfile-img{\r\n  margin-top: 80px;\r\n  width: 100%;\r\n  // background: url(\"../../public/asset/images/Rectangle.png\");\r\n  // background-size: contain;\r\n  // background-repeat: no-repeat;\r\n  // height: 508px;\r\n  // width: 100%;\r\n  \r\n  \r\n\r\n}\r\n.CompanyProfile-img-overly{\r\n  // height: 508px;\r\n  // width: 100%;\r\n  // background-color:#3466c2;\r\n  // opacity: 0.5;\r\n  // background-size: cover;\r\n  // z-index: 4;\r\n  // margin-top: 80px;\r\n  position: relative;\r\n}\r\n.CompanyProfile-img-overly:before {\r\n  content: \"\";\r\n  display: block;\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  background: rgba(22, 44, 201, 0.26);\r\n  border-radius: 20px;\r\n  margin-top: 80px;\r\n}\r\n\r\n.CompanyProfile-con{\r\n  padding: 30px 0px;\r\n  // font-family: Akzidenz-Grotesk Next;\r\n  \r\n}\r\n.Com-Profile{\r\n  background:#002B85;\r\n}\r\n.company-profile{\r\n  border-bottom: 1px solid #FFFFFF;\r\n  border-right: 1px solid #FFFFFF;\r\n  display: flex;\r\n}\r\n.company-profile:nth-child(2n){\r\n  border-right: none;\r\n \r\n}\r\n.company-profile:nth-child(3){\r\n  border-bottom: none;\r\n  @media(max-width: 992px){\r\n  border-bottom:none;\r\n  }\r\n  @media(max-width: 768px){\r\n    border-bottom: 1px solid #FFFFFF;\r\n  }\r\n}\r\n.company-profile:nth-child(4){\r\n  border-bottom: none;\r\n}\r\n.company-profile1{\r\n  border-bottom: 1px solid #FFFFFF;\r\n  display: flex;\r\n}\r\n.company-profile2{\r\n  display: flex;\r\n  border-right: 1px solid #FFFFFF;\r\n}\r\n.company-profile3{\r\n  display: flex;\r\n}\r\n.Com-Profile-con{\r\n  padding-top:100px;\r\n  padding-bottom:100px;\r\n  @media(max-width:991px){\r\n    padding-top: 50px;   \r\n    padding-bottom: 50px;\r\n  }\r\n  @media(min-width:1200px) and (max-width:1300px){\r\n    padding-left: 100px;   \r\n    padding-right: 100px;\r\n  \r\n  }\r\n}\r\n.profile-icon{\r\nwidth: 85px;\r\nheight: 85px;\r\n}\r\n.profile-txt{\r\n  margin-left: 40px;\r\n}\r\n@media(max-width:767px){\r\n  .company-profile{\r\n    border-bottom: 1px solid #FFFFFF;\r\n    border-right: none;\r\n  }\r\n    .company-profile2 {\r\n      border-bottom: 1px solid #FFFFFF;\r\n      border-right: none!important;\r\n  }\r\n  }\r\n.QualityAssurance{\r\n  margin-top: 80px;\r\n} \r\n\r\n.QualityAssurance-img{\r\n  width: 100%;\r\n}\r\n@media(max-width:868px){\r\n  .QualityAssurance-img-con{\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n}\r\n.QualityAssurance-con{\r\n  padding-right: 120px;\r\n  margin-left: 30px;\r\n  margin-top: 50px;\r\n}\r\n@media(max-width:1250px){\r\n  .QualityAssurance-con{\r\n    padding-right: 30px;\r\n    \r\n  }\r\n}\r\n\r\n.TrinityHoldingsSubsidiaries{\r\n  // margin-right: 80px;\r\n  margin-top: 80px;\r\n  @media(max-width:1300px){\r\n    margin-top: 10px;\r\n}\r\n}\r\n.TrinityHoldingsSubsidiaries-con{\r\n  \r\n  // margin-left: 130px;\r\n  margin-top: 50px;\r\n  @media(max-width:1300px){\r\n        margin-left: 50px;\r\n  }\r\n  @media(max-width: 768px){\r\n    margin-left: 0px;\r\n  }\r\n  @media(max-width:991px){\r\n    margin-left: 0px;\r\n  }\r\n}\r\n@media(max-width:992px){\r\n.TrinityHoldingsSubsidiaries-img-con{\r\ndisplay: flex;\r\nalign-items: center;\r\n}\r\n}\r\n.TrinityHoldingsSubsidiaries-img{\r\nwidth: 100%;\r\npadding-left: 20px;\r\n}\r\n.WordsfromtheCEO{\r\n  margin-top: 80px;\r\n  // margin-left:75px;\r\n  @media(max-width:1300px){\r\n    margin-top: 10px;\r\n}\r\n}\r\n.WordsfromtheCEO-con{\r\n  // margin-right: 100px;\r\n   margin-left: 25px;\r\n  margin-top: 50px;\r\n\r\n}\r\n.WordsfromtheCEO-con-det{\r\npadding-left: 30px;\r\n}\r\n.WordsfromtheCEO-img{\r\n  width: 100%;\r\n}\r\n@media(max-width:992px){\r\n  .WordsfromtheCEO-img-con{\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  .WordsfromtheCEO-con {\r\n    margin-top: 15px;\r\n}\r\n}\r\n\r\n.OurTeam-about{\r\n  margin: 75px 0px;\r\n}\r\n.OurTeam-about-img{\r\n  margin-top: 10px;\r\n}\r\n.OurTeam-about-img img{\r\n  width: 100%;\r\n  height: 268px;\r\n}\r\n.OurTeam-about-con{\r\n  background: #002B85;\r\n}\r\n@media(min-width:768px) and (max-width:992px){\r\n  .OurTeam-about-con{\r\n    height: 150px;\r\n  }\r\n}\r\n.OurTeam-about-con-det{\r\n  padding:21px;\r\n}\r\n@media(max-width:768px){\r\n  .OurTeam-about-img{\r\n    margin-top: 20px;\r\n  }\r\n}\r\n@media(max-width:575px){\r\n  .OurTeam-about{\r\n    margin:30px 50px;\r\n  }\r\n}\r\n\r\n\r\n.OurClients-bg{\r\n  position: relative; \r\n  background: #162cc985; \r\n \r\n}\r\n.OurClients{\r\n  background: url(\"../../public/asset/images/exclusive-tailor-our-clients-header.png\") ;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n}\r\n.OurClients-con{\r\n  padding-top: 80px;\r\n  margin-left: 60px;\r\n}\r\n.OurClients-div{\r\n  background: #FFFFFF;\r\n border-radius: 20px;\r\n margin-bottom: 150px;\r\n}\r\n\r\n.OurClients-logo-first-row{\r\n  border-bottom: #002B85 solid 1px;\r\n}\r\n.Clientslogo{\r\n  border-right: #002B85 solid 1px;\r\n  @media (max-width: 768px){\r\n    border-right: none!important;\r\n  }\r\n}\r\n.OurClients-logo:nth-child(4) .Clientslogo{\r\n  border-right: none!important;\r\n}\r\n.OurClients-logo:nth-child(5){\r\n  border-bottom: none!important;\r\n  @media (max-width: 768px){\r\n    border-bottom: #002B85 solid 1px!important;\r\n  }\r\n}\r\n.OurClients-logo:nth-child(6){\r\n  border-bottom: none!important;\r\n  @media (max-width: 768px){\r\n    border-bottom: #002B85 solid 1px!important;\r\n  }\r\n}\r\n.OurClients-logo:nth-child(7){\r\n  border-bottom: none!important;\r\n  @media (max-width: 768px){\r\n    border-bottom: #002B85 solid 1px!important;\r\n  }\r\n}\r\n.OurClients-logo:nth-child(8){\r\n  border-bottom: none!important;\r\n}\r\n// .OurClients-logo .btn2{\r\n//   margin-top: -100px;\r\n// }\r\n.OurClients-logo{\r\n \r\n  border-bottom: 1px solid #002b85;\r\n  margin-bottom: 10px;\r\n  padding-bottom: 20px;\r\n}\r\n.Clientslogo{\r\n  width: 100%;\r\n  padding-right: 20px;\r\n \r\n}\r\n\r\n.OurClients-logo:last-child{\r\n  border-right: none;\r\n}\r\n.OurClients-logo-first-row:last-child{\r\n  border-bottom: none;\r\n}\r\n@media(max-width:992px){\r\n  .OurClients-logo{\r\n    margin-top: 20px;\r\n  }\r\n  .OurClients-logo:nth-child(2){\r\n    border-right: none;\r\n  }\r\n}\r\n@media(max-width:767px){\r\n  .OurClients-logo{\r\n    border-right: none;\r\n    border-bottom: #002B85 solid 1px;\r\n  }\r\n  .OurClients-logo:last-child{\r\n    border-bottom: none;\r\n  }\r\n  .OurClients-logo-first-row {\r\n    display: block!important;\r\n    align-items: center;\r\n  }\r\n  .OurClients-con {\r\n    \r\n    margin-left: 0px;\r\n}\r\n}\r\n\r\n.Solutions-banner{\r\n  position: relative;\r\n}\r\n.Solutions-banner-image{\r\n  height: 657px;\r\n// background:cover;\r\nmargin-top: 50px;\r\n width: 100%;\r\n}\r\n.Solutions-banner-text{\r\n  position: absolute;\r\n  bottom: 160px;\r\n  \r\n  // left: 80px;\r\n  padding-left: 10px;\r\n}\r\n.Solutions-banner-text-title{\r\n \r\n  bottom: 100px;\r\n  color: #FFFFFF;\r\n  font-size: 50px;\r\n  // font-family: Akzidenz-Grotesk Next, sans-serif;\r\n  // left: 80px;\r\n}\r\n.Solutions-banner-text-sub{\r\n  \r\n  bottom: 100px;\r\n  color: #FFFFFF;\r\n  // font-family: Akzidenz-Grotesk Next , sans-serif;\r\n  font-weight: 300;\r\n  font-size: 30px;\r\n  \r\n}\r\n.Solutions-content{\r\n  margin: 20px;\r\n}\r\n@media(max-width:768px){\r\n  .Solutions-banner-text-sub {\r\n    bottom: 100px;\r\n    color: #FFFFFF;\r\n    font-weight: 300;\r\n    font-size: 20px;\r\n    padding-right: 50px!important;\r\n}\r\n}\r\n\r\n.CustomManufacturing-txt{\r\n  // display: flex;\r\n  align-items: center;\r\n  padding-left: 70px;\r\n  padding-right: 10px;\r\n}\r\n.CustomManufacturing{\r\nmargin-top: 80px;\r\n}\r\n\r\n\r\n.CustomManufacturing-image{\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n@media(max-width:767px){\r\n  .CustomManufacturing-txt {\r\n    align-items: center;\r\n    padding-left: 0px;\r\n    margin-top: 20px;\r\n    padding-right: 10px;\r\n}\r\n.Hire-image-con {\r\n  padding-left: 0px!important;\r\n}\r\n\r\n}\r\n.Hire{\r\n  margin-top: 80px;\r\n}\r\n.Hire-image{\r\n  width: 100%;\r\n  height: auto;\r\n  border-radius: 20px;\r\n}\r\n.Hire-image-con{\r\npadding-left: 50px;\r\n}\r\n.TurnkeyProjects{\r\n  margin-top: 80px;\r\n}\r\n.TurnkeyProjects-image{\r\n  border-radius: 20px;\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n.TurnkeyProjects-con{\r\n  padding-left: 50px!important;\r\n}\r\n@media(max-width:767px){\r\n  .TurnkeyProjects-con{\r\n    padding-left: 0px!important;\r\n    margin-top: 20px;\r\n  }\r\n}\r\n .ProductSliderContent-row .childslider .slick-active.slick-cloned{\r\n   display: none;\r\n}\r\n.ConsultingDesign{\r\n  margin-top: 80px;\r\n}\r\n.ConsultingDesign-image{\r\n  width: 100%;\r\n  // height: 440px;\r\n}\r\n.ConsultingDesign-image-con{\r\n  padding-left: 32px!important;\r\n}\r\n.DewateringTechniques-image{\r\n  width: 100%;\r\n  border-radius: 20px;\r\n\r\n}\r\n.DewateringTechniques{\r\n  margin-top: 80px;\r\n  margin-bottom: 80px;\r\n}\r\n.DewateringTechniques-txt{\r\n  padding-left: 80px;\r\n}\r\n@media(max-width:767px){\r\n  .ConsultingDesign-image-con {\r\n    padding-left: 0px !important;\r\n\r\n}\r\n.DewateringTechniques-txt {\r\n  padding-left: 0px;\r\n}\r\n}\r\n\r\n.ProductsBanner{\r\n  overflow-x: hidden;\r\n  margin-top: 100px;\r\n}\r\n.ProductsBanner-text{\r\n  background: #EFF7FF;\r\n  // width: 100%;\r\n}\r\n.ProductsBanner-txt{\r\n  padding-left: 80px;\r\n  // margin-bottom: 100px;\r\n  margin-top: 80px;\r\n  // padding-right: 50px;\r\n  padding-right: 20px;\r\n  @media (min-width: 1300px) and (max-width: 1599px){\r\n    padding-left: 100px;\r\n  }\r\n  @media (min-width: 1600px) and (max-width: 1920px){\r\n    padding-left: 200px;\r\n  }\r\n  \r\n}\r\n.ProductsBanner-image{\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n@media(max-width:894px){\r\n  .ProductsBanner-txt{\r\n    padding-left: 45px;\r\n    margin-top: 10px;\r\n    padding-right: 20px;\r\n    \r\n  }\r\n}\r\n\r\n.ProductsList{\r\n  margin-top: 80px;\r\n  margin-bottom: 130px;\r\n}\r\n.ProductsList-image{\r\n  // width: 100%;\r\n \r\n  width: 320px;\r\n  height: 274px;\r\n  padding: 20px 0px;\r\n  margin: 0px 40px;\r\n  @media (min-width: 1000px) and (max-width: 1200px){\r\n    margin: 0px!important;\r\n  }\r\n}\r\n.ProductsList-image-div{\r\n  border-bottom: #002B85 solid 1px;\r\n  border-right: #002B85 solid 1px;\r\n\r\n}\r\n.ProductsList-image-col:nth-child(2n) .ProductsList-image-div{\r\n  border-right: none!important;\r\n\r\n}\r\n.productslide-img-scroll{\r\n       padding-top: 0!important;\r\n}\r\n.productslide-img{\r\n  padding-top: 0!important;\r\n}\r\n.ProductsList-image-div1{\r\n  border-bottom: #002B85 solid 1px;\r\n}\r\n.ProductsList-image-col:hover .ProductsList-image-desc{\r\n    // background: #002B85!important;\r\n    color: #FFFFFF!important;\r\n\r\n    background: linear-gradient(#002B85, #002B85 50%, #ffffff 50%, #ffffff);\r\n    background-size: 100% 200%;\r\n    /*trasition effect for background*/\r\n    transition: background 0.5s;\r\n}\r\n.ProductsList-image-desc{\r\n  background-position: 100% 100%;\r\nfont-size: 18;\r\ncolor: #000000;\r\ntext-align: center;\r\npadding: 20px;\r\nwidth: 100%;\r\n}\r\n.ProductsList-image-desc:hover{\r\n  // background: #002B85!important;\r\n  color: #FFFFFF!important;\r\n\r\n  background: linear-gradient(#002B85, #002B85 50%, #ffffff 50%, #ffffff);\r\n  background-size: 100% 200%;\r\n  /*trasition effect for background*/\r\n  transition: background 0.5s;\r\n}\r\n.RelatedProducts-div{\r\n  border: #002B85 solid 1px;\r\n  border-radius: 20px;\r\n  margin-top: 80px!important;\r\n  margin-left: 50px;\r\n  @media (min-width: 1000px) and (max-width: 1200px){\r\n    margin: 0px!important;\r\n  }\r\n  @media (min-width: 1400px){\r\n    margin-left: 0px!important;\r\n  }\r\n}\r\n.ProductsList-col1  {\r\n  padding-right: 30px;\r\n}\r\n.pro-item img{\r\n  padding: 0 3px;\r\n}\r\n.RelatedProducts-title{\r\n  border-bottom: #002a8587 solid 2px;\r\n  margin: 20px 20px;\r\n  padding: 10px 20px;\r\n}\r\n.RelatedProducts-sub{\r\n  margin: 10px 40px;\r\n  padding: 10px 0px;\r\n  border-bottom: #002a8587 solid 1px;\r\n  a{\r\n    text-decoration: none;\r\n    color: #000000;\r\n  }\r\n}\r\n.RelatedProducts-sub a:hover{\r\n  color: #002B85;\r\n  font-weight: 500;\r\n}\r\n.RelatedProducts-sub:last-child{\r\n  border-bottom: none;\r\n}\r\n.RelatedProducts-sub-div{\r\n  margin-top: 20px;\r\n  margin-bottom: 50px;\r\n}\r\n\r\n\r\n.LatestNews-div{\r\n  background: #EFF7FF;\r\n  border-radius: 20px;\r\n  margin-top: 100px!important;\r\n  margin-left: 50px;\r\n  @media (min-width: 1000px) and (max-width: 1200px){\r\n    margin: 0px!important;\r\n  }\r\n  @media (min-width: 1400px){\r\n    margin-left: 0px!important;\r\n  }\r\n  \r\n}\r\n.LatestNews-title{\r\n  border-bottom: #002a8587 solid 2px;\r\n  margin: 20px 20px;\r\n  margin-top: 60px!important;\r\n  padding: 10px 20px;\r\n  margin-right: 40px;\r\n}\r\n.LatestNews-sub-div{\r\n  margin-top: 20px;\r\n  margin-bottom: 40px;\r\n  margin-right: 40px;\r\n}\r\n\r\n.LatestNews-sub{\r\n  // margin: 20px 40px;\r\n  // padding: 10px 0px;\r\n  margin-left: 40px;\r\n  line-height: 35px;\r\n  margin-top: 15px;\r\n  padding-bottom: 15px;\r\n  border-bottom: #002a8587 solid 1px;\r\n}\r\n.LatestNews-sub:last-child{\r\n  border-bottom: none!important;\r\n}\r\n.ReadALLNews{\r\n  margin-left: 40px;\r\n  margin-bottom: 60px;\r\n}\r\n.btn3 {\r\n  \r\n  display: flex;\r\n  text-decoration: none;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 200px;\r\n  height: 50px;\r\n  color: #EFF7FF !important;;\r\n  background-color: #002B85;\r\n  border-radius: 10px;\r\n  border:none;\r\n \r\n}\r\n.Button3{\r\n  cursor: pointer;\r\n  margin-top: 40px;\r\n\r\n}\r\n.form-group .errors{\r\n  color: red;\r\n}\r\n.ProductsList-image-col{\r\n  margin-top: 50px!important;\r\n}\r\n\r\n@media(max-width:992px){\r\n  .ProductsList-row{\r\n    display: block;\r\n  } \r\n  .ProductsList-col1 {\r\n    width: 100%;\r\n  }\r\n  .ProductsList-col2 {\r\n    width: 90%;\r\n  }\r\n\r\n  }\r\n@media(max-width:767px){\r\n  .ProductsList-image-div {\r\n    text-align: center;\r\n    border-right: none;\r\n}\r\n.ProductsList-image-div1 {\r\n  text-align: center;\r\n  \r\n}\r\n.RelatedProducts-div {\r\n  \r\n  margin-left: 0px;\r\n}\r\n.LatestNews-div {\r\n  margin-left: 0px;\r\n}\r\n.ProductsList-col2 {\r\n  width: 100%;\r\n}\r\n.ProductsBanner-txt {\r\n  padding-left: 80px;\r\n  margin-top: 80px;\r\n  padding-right: 20px;\r\n}\r\n}\r\n\r\n.ProductSliderContent{\r\n  margin-top: 100px;\r\nbackground: rgb(255,255,255);\r\nbackground: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 0%, rgba(254,253,253,1) 50%, rgba(239,247,255,1) 50%);\r\n}\r\n\r\n.Productpath{\r\n  margin-top: 60px;\r\n}\r\n.ProductSliderContent-title{\r\nmargin-top: 73px;\r\n}\r\n.ProductSliderContent-det{\r\n  margin-left: 60px;\r\n  // margin-right: 80px;\r\n  margin-bottom: 110px;\r\n}\r\n.btn4 {\r\n  \r\n  // display: flex;\r\n  text-decoration: none;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n   width: 220px;\r\n  // height: 50px;\r\n  color: #EFF7FF !important;;\r\n  background-color: #002B85;\r\n  border-radius: 10px;\r\n  border:none;\r\n  cursor: pointer;\r\n  \r\n \r\n}\r\n.btn5 {\r\n  \r\n  // display: flex;\r\n  text-decoration: none;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n \r\n  color: #002B85 !important;;\r\n  background:transparent;\r\n  border-radius: 10px;\r\n  border: #002B85 solid 1px!important;\r\n  border:none;\r\n  \r\n \r\n}\r\n\r\n.productslide-img{\r\n  width: 98%;\r\n  height: 400px;\r\n}\r\n.productslide-img-scroll{\r\n  width: 128px;\r\n  height: 98px;\r\n}\r\n.childslider .slick-track {\r\nheight: auto!important;\r\ndisplay: flex;\r\nz-index: 99999;\r\n}\r\n@media(max-width:992px){\r\n  .ProductSliderContent-row{\r\n    display: block;\r\n  }\r\n  .ProductSliderContent{\r\n    background: none;\r\n    }\r\n    .ProductSliderContent-col1{\r\n      width: 100%;\r\n      // margin: 30px;\r\n    }\r\n    .ProductSliderContent-col2{\r\n      width: 100%;\r\n      margin: 0;\r\n    }\r\n    .ProductSliderContent-det{\r\n      margin-left: 0px;\r\n      margin-right: 0px;\r\n      margin-bottom: 0px;\r\n    }\r\n}\r\n.MaterialsandApplications{\r\n  margin-top:30px;\r\n  margin-bottom: 80px;\r\n}\r\n\r\n.MaterialsandApplications-div{\r\n  border: #002B85 solid 1px;\r\n  border-radius: 20px;\r\n}\r\n.MaterialsandApplications-title{\r\n  border-bottom: #002a8587 solid 2px;\r\n  margin: 20px 20px;\r\n  margin-top: 20px!important;\r\n  padding: 10px 10px;\r\n  margin-right: 40px;\r\n}\r\n.MaterialsandApplications-sub-div{\r\n  margin-top: 20px;\r\n  margin-bottom: 40px;\r\n  margin-right: 40px;\r\n}\r\n\r\n.MaterialsandApplications-sub{\r\n  // margin: 20px 40px;\r\n  // padding: 10px 0px;\r\n  margin-left: 40px;\r\n  line-height: 35px;\r\n  margin-top: 10px;\r\n  padding-bottom: 10px;\r\n  border-bottom: #002a8587 solid 1px;\r\n}\r\n.MaterialsandApplications-sub:last-child{\r\n  border-bottom: none!important;\r\n}\r\n.MaterialsandApplications-col{\r\n  margin-right: 130px ;\r\n  // margin-top:30px;\r\n}\r\n.pcnt{\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  margin-bottom: 1px!important;\r\n}\r\n.pcnt2{\r\n  font-size: 14px;\r\n}\r\n.feature{\r\n  border-bottom: 1px solid black\r\n}\r\n\r\n.feature img{\r\n  width: 100%;\r\n  height: 60%!important;\r\n}\r\n.feature-cnt{\r\n  margin-right: 0!important;\r\n}\r\n.Materials table {\r\n  border-collapse: collapse;\r\n  border: 2px solid rgb(200,200,200);\r\n  letter-spacing: 1px;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.Materials table th {\r\n  border: 1px solid rgb(190,190,190);\r\n  padding: 2px 4px;\r\n}\r\n.Materials table td {\r\n  border: 1px solid rgb(190,190,190);\r\n  padding: 2px 4px;\r\n}\r\n\r\n.Materials table th {\r\n  background-color: rgb(235,235,235);\r\n}\r\n\r\n.materials td {\r\n  text-align: center;\r\n}\r\n\r\n.Materials tr:nth-child(even) td {\r\n  background-color: rgb(250,250,250);\r\n}\r\n\r\n.materials tr:nth-child(odd) td {\r\n  background-color: rgb(245,245,245);\r\n}\r\n\r\n\r\n@media(max-width:1200px){\r\n  .MaterialsandApplications-title {   \r\n  margin-right: 20px;\r\n}\r\n.MaterialsandApplications-sub-div {\r\n \r\n  margin-right: 20px;\r\n}\r\n.MaterialsandApplications-sub {\r\n  margin-left: 20px;\r\n}\r\n}\r\n@media(max-width:992px){\r\n  .MaterialsandApplications-first-col{\r\n    width: 100%;\r\n  }\r\n  .MaterialsandApplications-col2{\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .MaterialsandApplications-col {\r\n    margin-right: 0px;\r\n}\r\n.Materials {\r\n  \r\n  margin-right: 0px !important;\r\n}\r\n.Applications {\r\n  \r\n  margin-right: 0px !important;\r\n}\r\n}\r\n\r\n@media(max-width:576px){\r\n.MaterialsandApplications{\r\n  margin:0px 30px;\r\n  \r\n}\r\n.MaterialsandApplications{\r\n  margin-bottom: 50px;\r\n}\r\n.ProductSliderContent{\r\n  margin:0px 30px;\r\n}\r\n}\r\n.Materials{\r\n  margin-top: 90px;\r\n  margin-right: 130px ;\r\n}\r\n.Materials-title{\r\nfont-size: 22px;\r\ncolor: #000000;\r\nfont-weight: bold;\r\n}\r\n.Materials-sub{\r\n  font-size: 17px;\r\n  color: #000000;\r\n}\r\n\r\n.Applications{\r\n  margin-top: 90px;\r\n  margin-right: 130px ;\r\n}\r\n.Applications-title{\r\nfont-size: 22px;\r\ncolor: #000000;\r\nfont-weight: bold;\r\n}\r\n.Applications-sub{\r\n  font-size: 17px;\r\n  color: #000000;\r\n}\r\n.MaterialsandApplications-btn{\r\n  cursor: pointer;\r\n  padding: 20px 0px;\r\n}\r\n.GalleryImages{\r\n  margin-top: 80px;\r\n}\r\n.GalleryBtn{\r\n  margin-top: 35px;\r\n  margin-bottom: 75px;\r\n  a{\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n\r\n.MainNews{\r\n  margin-top: 55px;\r\n}\r\n.MainNews-news{\r\n  margin-top: 35px;\r\n}\r\n.MainNews-news-img{\r\n  width: 100%;\r\n}\r\n.MainNews-news-con{\r\n  background: #F1F1F1;\r\n  position: relative;\r\n}\r\n.MainNews-news-con-news{\r\n  margin-left: 38px;\r\n  margin-top: 58px;\r\n}\r\n.MainNews-news-con-news-title{\r\n padding-right: 100px;\r\n}\r\n.MainNews-news-con-news-det{\r\n  padding-right: 69px;\r\n}\r\n.News2{\r\n  margin-top: 35px;\r\n}\r\n.News2:first-child{\r\n  margin-top: 0;\r\n}\r\n.NewsDate{\r\n  color:#14446F;\r\n  font-size: 14px;\r\n  bottom: 45px;\r\n  position: absolute;\r\n}\r\n\r\n\r\n\r\n.MainNews-div{\r\n  background: #EFF7FF;\r\n  border-radius: 20px;\r\n  // margin-top: 100px!important;\r\n  // margin-left: 86px;\r\n  // padding-right: 80px;\r\n  \r\n}\r\n.MainNews-Related{\r\n  padding-left: 72px;\r\n}\r\n.MainNews-title{\r\n  border-bottom: #002a8587 solid 2px;\r\n  margin: 20px 20px;\r\n  margin-top: 48px!important;\r\n  padding: 10px 20px;\r\n  margin-right: 40px;\r\n}\r\n.MainNews-sub-div{\r\n  margin-top: 20px;\r\n  margin-bottom: 40px;\r\n  margin-right: 40px;\r\n}\r\n\r\n.MainNews-sub{\r\n  // margin: 20px 40px;\r\n  // padding: 10px 0px;\r\n  margin-left: 40px;\r\n  line-height: 35px;\r\n  margin-top: 15px;\r\n  padding-bottom: 15px;\r\n  border-bottom: #002a8587 solid 1px;\r\n}\r\n.MainNews-sub:last-child{\r\n  border-bottom: none!important;\r\n}\r\n.SubNews{\r\nmargin-top: 35px;\r\n}\r\n\r\n.SubNews-col{\r\n padding-right: 25px!important;\r\n display: grid !important;\r\n}\r\n// .SubNews-col:last-child{\r\n//   padding-right:0!important;\r\n//  }\r\n.SubNews-con{\r\n  background: #F1F1F1;\r\n  position: relative;\r\n\r\n}\r\n.productslide-img{\r\n  cursor: pointer;\r\n}\r\n.open-modal{\r\n  padding: 1px 6px;\r\n  background-color:#002B85;\r\n  color: white;\r\n  border-color: #002B85;\r\n  right:10px;\r\n  position: absolute;\r\n}\r\n.open-modal:hover{\r\n  background-color:#FF5C00;\r\n  border-color: #FF5C00;\r\n\r\n}\r\n.ril__navButtons {\r\n  width: 8px!important;\r\n  height: 18px!important;\r\n  padding: 25px 15px!important;\r\n}\r\n.pslide{\r\n  width: 40%!important;\r\n  margin-top: 10%!important;\r\n  margin-right: auto!important;\r\n  margin-left: 30%!important;\r\n}\r\n// .pslide img{\r\n//   margin-top: 30%!important;\r\n// }\r\n.ReactModal__Content--after-open{\r\n  width: 100%;\r\n  display: block!important;\r\n}\r\n.ReactModal__Content--after-open img{\r\n  width: 600px!important;\r\n  height: 400px!important;\r\n  display: block!important;\r\n  margin: auto!important;\r\n  transform:none!important;\r\n}\r\n.ril__outer {\r\n  background-color: #00000091!important;\r\n}\r\n.ril-zoom-in{\r\n  display:none;\r\n}\r\n.ril-zoom-out{\r\n  display:none;\r\n}\r\n.ril-errored{\r\n  display: none!important;\r\n}\r\n.ReactModalPortal{\r\n  position: fixed!important;\r\n  z-index: 111111111!important;\r\n}\r\n// .ReactModal__Overlay--after-open{\r\n//   margin-top: 70px!important;\r\n\r\n// }\r\n.SubNews-con-det{\r\n  margin-left: 40px;\r\n  padding-top: 35px;\r\n  padding-bottom: 40px;\r\n}\r\n.SubNews-con-title{\r\n  margin-right: 80px;\r\n}\r\n.SubNews-con-desc{\r\n  margin-right: 58px;\r\n  margin-bottom: 37px;\r\n}\r\n.SubNewsDate{\r\n  color:#14446F;\r\n  font-size: 14px;\r\n  bottom: 5px;\r\n  \r\n  position: absolute;\r\n}\r\n.SubNews-img{\r\n  height: 236px;\r\n  width: 100%;\r\n  @media (min-width:1400px) and (max-width: 1920px){\r\n    height: 330px;\r\n  }\r\n}\r\n\r\n.pagination {\r\n  margin-top: 35px;\r\n  display: flex;\r\n  padding-left: 0;\r\n  list-style: none;\r\n  justify-content: center;\r\n  margin-bottom: 70px;\r\n}\r\n.pagination {\r\n  .disable{\r\n    background: #F1F1F1;\r\n    border-radius: 25px;\r\n    padding: 13px;\r\n    margin-right: 10px;\r\n    pointer-events: none;\r\n  }\r\n  .blocks{\r\n    background: #F1F1F1;\r\n    border-radius: 50%;\r\n    padding: 13px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n  }\r\n  a{\r\n    text-decoration: none;\r\n    color: #002B85!important;\r\n    cursor: pointer;\r\n  }\r\n  .active{\r\n    background: #002B85!important;\r\n    border-radius: 10px!important;\r\n    color: #FFFFFF!important;\r\n    padding: 15px;\r\n    width: 51px;\r\n  height: 50px;\r\n  }\r\n}\r\n.GetinTouch-icons-con li {\r\n  list-style: none;\r\n}\r\n.pagenumber{\r\n  background: #F1F1F1;\r\n  // width: 534px;\r\n  // height: 50px;\r\n  padding-left: 60px;\r\n  padding-right: 60px;\r\n  padding-top: 13px;\r\n  padding-bottom: 0px;\r\n  border-radius: 25px;\r\n  \r\n  text-align: center;\r\n  .blocks{\r\n    background: #F1F1F1;\r\n    border-radius: 25px;\r\n    padding: 15px;\r\n    width: 51px;\r\n  height: 50px;\r\n  }\r\n}\r\n@media(min-width:992px) and (max-width:1200px){\r\n  .MainNews-news-con-news {\r\n    margin-left: 38px;\r\n    margin-top: 20px;\r\n}\r\n.MainNews-news-con-news-title{\r\n  font-size: 20px;\r\n}\r\n.NewsDate {\r\n  color: #14446F;\r\n  font-size: 14px;\r\n  bottom: 10px;\r\n  position: absolute;\r\n}\r\n.MainNews-sub{\r\n  font-size: 14px;\r\n}\r\n.MainNews-title {\r\n  border-bottom: rgba(0, 42, 133, 0.5294117647) solid 2px;\r\n  margin: 20px 20px;\r\n  margin-top: 22px !important;\r\n  padding: 10px 20px;\r\n  margin-right: 40px;\r\n  font-size: 19px;\r\n}\r\n}\r\n@media(max-width:992px){\r\n  .NewsDate {\r\n    color: #14446F;\r\n    font-size: 14px;\r\n    bottom: 10px !important;\r\n    position: absolute;\r\n}\r\n.MainNews-Related {\r\n    padding-left: 0px;\r\n}\r\n.MainNews-div {\r\n  background: #EFF7FF;\r\n  border-radius: 20px;\r\n  margin-top: 50px;\r\n}\r\n}\r\n@media(max-width:767px){\r\n  .MainNews-news-con-news {\r\n    margin-left: 38px;\r\n    margin-top: 56px;\r\n    padding-bottom: 101px!important;\r\n  }\r\n.SubNews-col {\r\n  padding-right: 0px !important;\r\n  margin-top: 30px;\r\n}\r\n\r\n\r\n\r\n\r\n.pagination {\r\n  margin-top: 35px;\r\n  display: flex;\r\n  padding-left: 0;\r\n  list-style: none;\r\n  justify-content: center;\r\n  margin-bottom: 70px;\r\n}\r\n.pagination {\r\n  .disable{\r\n    \r\n    margin-right: 5px;\r\n  }\r\n  .blocks{\r\n    background: #F1F1F1;\r\n    border-radius: 50%;\r\n    padding: 10px;\r\n    margin-left: 10px;\r\n  }\r\n  \r\n  .active{\r\n    background: #002B85!important;\r\n    border-radius: 10px!important;\r\n    color: #FFFFFF!important; \r\n    padding: 5px;\r\n    width: auto;\r\n  height: auto;\r\n  }\r\n}\r\n.pagenumber{\r\n  background: #F1F1F1;\r\n  // width: 534px;\r\n  // height: 50px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  padding-top: 10px;\r\n  padding-bottom: 0px;\r\n  border-radius: 25px;\r\n  \r\n  text-align: center;\r\n  .blocks{\r\n    background: #F1F1F1;\r\n    border-radius: 25px;\r\n    padding: 2px;\r\n    width: auto;\r\n  height: auto;\r\n  }\r\n}\r\n}\r\n\r\n\r\n\r\n.CurrentOpportunities-main-title{\r\n  margin-top: 50px;\r\n}\r\n.CurrentOpportunities-sub-title{\r\n  color: #404040;\r\n  font-size: 24px;\r\n  margin-top: 40px;\r\n}\r\n.CurrentOpportunities-list{\r\n  margin-top: 50px;\r\n  margin-left: 25px;\r\n  margin-right: 20px;\r\n}\r\n.CurrentOpportunities-div1{\r\n  padding-right: 25px;\r\n  margin-bottom: 50px;\r\n  display: flex;\r\n}\r\n.CurrentOpportunities-div2{\r\n  padding-left: 25px;\r\n  margin-bottom: 50px;\r\n}\r\n.CurrentOpportunities-list-div{\r\n  border: 1px solid #002B85;\r\n  border-radius: 20px;\r\n  \r\n  \r\n}\r\n.CurrentOpportunities-list-div-con{\r\n  margin: 30px;\r\n  margin-bottom: 20px;\r\n  .txt20{\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n\r\n\r\n.CurrentOpportunities-exp{\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n}\r\n.CurrentOpportunities-cont{\r\n  color: #002B85;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n\r\n  margin-top: 10px;\r\nmargin-bottom: 30px;\r\n}\r\n.CurrentOpportunities-det{\r\n  color: #555555;\r\n  font-size: 14px;\r\n\r\n  margin-bottom: 24px;\r\n}\r\n\r\n\r\n.Applyform-bg{\r\n  background: #EFF7FF;\r\n  border-radius: 20px;\r\n  margin-bottom: 80px;\r\n}\r\n.Applyform-cont{\r\n  padding-left: 110px;\r\n  padding-right: 110px;\r\n  padding-top: 85px;\r\n  padding-bottom: 90px;\r\n}\r\n// .Applyform{\r\n//   display: none;\r\n// }\r\n// .apply-show{\r\n//   display: block!important;\r\n// }\r\n// .row-hide{\r\n//   display: none!important;\r\n// }\r\n\r\n.Applyform-cont{\r\n  input{\r\n    border: none;\r\n    border-radius: 10px;\r\n    padding-top: 15px;\r\n    padding-bottom: 15px;\r\n    color: #959595;\r\n    font-size: 14px;\r\n  }\r\n  label{\r\n    color: #555555;\r\n    font-size: 16px;\r\n  }\r\n  .form-group{\r\n    margin-top: 25px;\r\n  }\r\n  .btn4{\r\n    width: 185px;\r\n    height: 52px;\r\n    padding: 0;\r\n    float: right;\r\n    margin-top: inherit;\r\n  }\r\n  .trashbin{\r\n    float: right;\r\n    margin-right: 20px;\r\n    margin-top: 30px;\r\n    \r\n  }\r\n  .delete{\r\n    color: #555555;\r\n    font-size: 16px;\r\n  }\r\n  // .button-apply{\r\n   \r\n    \r\n  // }\r\n\r\n}\r\n.file-upload{\r\n  border: none;\r\n//   .file-input{\r\n//     display: flex!important;\r\n//     justify-content: center!important;\r\n//     align-items: center!important;\r\n// }\r\n}\r\n.image-upload{\r\n  text-align: center!important;\r\n  img{\r\n\r\n  }\r\n}\r\n.image-upload>input {\r\n  // display: none;\r\n  \r\n}\r\n.upload-img{\r\n  opacity: .2;\r\n  width:122px; \r\n  height:100px;\r\n}\r\n@media(max-width:1200px){\r\n  .upload-img{\r\n    padding-left: 20px;\r\n    opacity: 0.2;\r\n    width: 96px;\r\n    height: 68px;\r\n  }\r\n  .file-drop-target{\r\n    display: flex;\r\n  }\r\n  .progress {\r\n    \r\n    width: 75%!important;\r\n    \r\n}\r\n}\r\n@media(max-width:992px){\r\n  .progress {\r\n    \r\n    width: 50%!important;\r\n    \r\n}\r\n}\r\n.brow{\r\n  color: #002B85;\r\n  font-size: 14px;\r\n}\r\n.DD{\r\n  font-size: 14px;\r\n  \r\n}\r\n.CurrentOpportunities{\r\n  overflow-x: hidden;\r\n}\r\n@media(max-width:458px){\r\n  .CurrentOpportunities-list-div-content {\r\n    display: block!important;\r\n  }\r\n}\r\n@media(max-width:575px){\r\n  .Applyform-cont {\r\n    padding-left: 51px;\r\n    padding-right: 49px;\r\n  }\r\n}\r\n@media(min-width:768px) and (max-width:992px){\r\n  .CurrentOpportunities-list-row{\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n  .CurrentOpportunities-div2{\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n    width: 500px;\r\n  }\r\n  .CurrentOpportunities-div1{\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n    width: 500px;\r\n  }\r\n  \r\n}\r\n@media(max-width:1200px){\r\n  .CurrentOpportunities-div2 {\r\n    padding-left: 0;\r\n    margin-bottom: 50px;\r\n}\r\n}\r\n@media(max-width:768px){\r\n.CurrentOpportunities-div2{\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n\r\n}\r\n.CurrentOpportunities-div1{\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n\r\n}\r\n}\r\n\r\n\r\n\r\n.popup-content{\r\n  width: 100%!important;\r\n  left: 0!important;\r\n} \r\n.Novacancy-div{\r\n  position: relative;\r\n}\r\n.Novacancy-img{\r\n  width: 100%;\r\n}\r\n.Novacancy-text{\r\n  position: absolute;\r\n  z-index: 222;\r\n  font-size: 24px;\r\n  color: #101010;\r\n  text-align: center ;\r\n  bottom: 0;\r\n}\r\n.Novacancy{\r\n  a{\r\n    // color: #EFF7FF!important;\r\n    font-size: 14px;\r\n    width: 200px;\r\n    // padding: 15px;\r\n    text-align: center;\r\n    \r\n  }\r\n}\r\n.ttlvac{\r\n  margin-top: 30px;\r\n}\r\n.Novacancy-cv{\r\n  margin-top: 26px;\r\n  @media(max-width:483px){\r\n    margin-top: 20px;\r\n   \r\n  }\r\n}\r\ninput::file-selector-button {\r\n display: none;\r\n}\r\n.Novacancy-cv-det{\r\n  margin-left: 25px;\r\n  font-size: 20px;\r\n  color: #4E4E4E;\r\n  font-weight: 500;\r\n  a{\r\n    margin-right: 25px;\r\n    text-decoration: none;\r\n    font-size: 20px;\r\n    color: #002b85;\r\n    font-weight: 500;\r\n  }\r\n  @media(max-width:483px){\r\n    margin-right: 11px;\r\n    margin-bottom: 10px!important;\r\n  }\r\n}\r\n.Novacancy{\r\n  margin-bottom: 100px;\r\n  @media(max-width:483px){\r\n    margin-bottom: 40px;\r\n  }\r\n}\r\n@media(max-width:483px){\r\n  .Novacancy-text {\r\n    font-size: 16px;\r\n  }\r\n  // .Novacancy-cv {\r\n  //   display: block!important;\r\n  // }\r\n}\r\n\r\n\r\n\r\n.contact{\r\n  margin-top: 60px;\r\n  margin-bottom: 60px;\r\n}\r\n.GetinTouch{\r\n  background: #002B85;\r\n  border-radius: 20px 0px 0px 20px;\r\n}\r\n.Connectwithus{\r\n  background: #EFF7FF;\r\n  border-radius: 0px 20px 20px 0px;\r\n\r\n}\r\n.GetinTouch-data{\r\n  margin-left: 64px;\r\n  margin-top: 68px;\r\n}\r\n.GetinTouch-data-Title{\r\n  font-size: 40px;\r\n  font-family:Centrale Sans Bold ;\r\n  font-weight: bold;\r\n  color: #FFFFFF;\r\n}\r\n.GetinTouch-data-txt{\r\n  font-size: 16px;\r\n  color: #FFFFFF;\r\n}\r\n\r\n.GetinTouch-data-info{\r\n  margin-top: 54px;\r\n  margin-left: 64px;\r\n}\r\n.GetinTouch-icons{\r\n  width: 54px;\r\n  height: 54px;\r\n  display: block;\r\n  cursor: pointer;\r\n}\r\n.GetinTouch-icons:hover{\r\n  display: none;\r\n}\r\n.GetinTouch-icons:hover + .GetinTouch-icons-new{\r\n  display: block!important;\r\n}\r\n.GetinTouch-icons-new{\r\n  cursor: pointer;\r\n  display: none;\r\n  width: 54px;\r\n  height: 54px;\r\n}\r\n.icon-type{\r\n  font-size: 16px;\r\n  color: #FFFFFF;\r\n}\r\n.icon-data{\r\n  font-size: 20px;\r\n  color: #FFFFFF;\r\n}\r\n.GetinTouch-icons-con{\r\n  padding-left: 10px;\r\n}\r\n\r\n.Connectwithus-data{\r\n  margin-top: 45px;\r\n  margin-left: 87px;\r\n}\r\n.Connectwithus-data-Title{\r\n  font-size: 30px;\r\n  color: #002B85;\r\n  font-weight: bold;\r\n}\r\n.Connectwithus-data{\r\n  margin-right: 90px;\r\n  input{\r\n    border: none;\r\n    border-radius: 10px;\r\n    height: 48px;\r\n    font-size: 14px;\r\n    color: #A2A9B0;\r\n    margin-top: 10px;\r\n  }\r\n  label{\r\n    color: #555555;\r\n    font-size: 16px;\r\n  }\r\n  .form-group{\r\n    margin-top: 15px;\r\n  }\r\n  form{\r\n    margin-top: 25px;\r\n  }\r\n}\r\n.contactsub{\r\n  width: 185px;\r\n  height: 52px;\r\n  padding: 0;\r\n  margin-top: 30px;\r\n}\r\n.contactsub-div{\r\n  margin-bottom: 120px;\r\n}\r\n@media(max-width:992px){\r\n  .GetinTouch{\r\n    background: #002B85;\r\n    border-radius: 20px;\r\n  }\r\n  .Connectwithus{\r\n    background: #EFF7FF;\r\n    border-radius: 20px;\r\n    margin-top:20px;\r\n  \r\n  }\r\n}\r\n@media(max-width:575px){\r\n  .contactus{\r\n    margin: 20px;\r\n  }\r\n  .icon-data{\r\n    font-size: 13px;\r\n  }\r\n  .GetinTouch-data-info{\r\n    margin-left: 20px;\r\n  }\r\n  .GetinTouch-data{\r\n    margin-left: 20px;\r\n  }\r\n  .Connectwithus-data{\r\n    margin-right: 20px;\r\n    margin-left: 10px;\r\n  }\r\n  .captcha{\r\n    display: block!important;\r\n  }\r\n}\r\n.Feedback{\r\n  margin-top: 100px;\r\n}\r\n.Feedback-form{\r\n  margin-left: 80px;\r\n  margin-top: 90px;\r\n  margin-right: 80px;\r\n  margin-bottom: 100px;\r\n\r\n  .form-group{\r\n    margin-top: 30px;\r\n  }\r\n  label{\r\n    margin-top: 10px;\r\n    color: #555555;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n  }\r\n  input{\r\n    background: #F1F1F1;\r\n    border: none;\r\n    border-radius: 10px;\r\n    height: 48px;\r\n  }\r\n  textarea{\r\n    background: #F1F1F1;\r\n    border: none;\r\n    border-radius: 10px;\r\n    height: 218px;\r\n  }\r\n  .btn4{\r\n    width: 200px;\r\n    padding: 14px!important;\r\n  }\r\n}\r\n\r\n.filled-icons{\r\n  color: #FF5C00!important;\r\n}\r\n.Feedback-img{\r\n  height: 100%;\r\n}\r\n.Feedback-img1{\r\n  display: none;\r\n}\r\n@media(max-width:767px){\r\n  .Feedback-img{\r\n    display: none;\r\n  }\r\n  .Feedback-img1{\r\n    display: block;\r\n  }\r\n}\r\n@media(max-width:992px){\r\n  .Feedback-form {\r\n    margin-left: 50px;\r\n\r\n    margin-right: 30px;\r\n   \r\n}\r\n}\r\n\r\n\r\n\r\n\r\n.Enquiry{\r\n  margin-top: 150px;\r\n  margin-bottom: 80px;\r\n}\r\n.Enquiry-form{\r\n  margin-left: 80px;\r\n  margin-right: 80px;\r\n\r\n}\r\n.Enquiry-img{\r\n  height: 100%;\r\n}\r\n.Enquiry-img1{\r\n  display: none;\r\n}\r\n.Enquiry-form-div{\r\n  margin-top: 25px;\r\n  input{\r\n    background: #F1F1F1;\r\n    border: none;\r\n    border-radius: 10px;\r\n    height: 48px;\r\n    margin-top: 10px;\r\n    font-size: 10px;\r\n  }\r\n  label{\r\n    color: #555555;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    margin-top: 30px;\r\n\r\n  }\r\n  textarea{\r\n    background: #F1F1F1;\r\n    border: none;\r\n    border-radius: 10px;\r\n    height: 215px;\r\n  }\r\n  .btn4{\r\n    padding: 14px;\r\n    width: 200px;\r\n  }\r\n \r\n}\r\n.Enq-Btns{\r\n  margin-top: 30px;\r\n}\r\n.btn6{\r\n  background-color: #FF5C00;\r\n  border: none;\r\n  border-radius: 10px;\r\n  color: #FFFFFF;\r\n  padding: 14px;\r\n  width: 228px;\r\n}\r\n.Dowbtn {\r\n  margin-left: 30px;\r\n}\r\n@media(max-width:1200px){\r\n  .Enquiry-form {\r\n    margin-left: 50px;\r\n    margin-right: 50px;\r\n}\r\n}\r\n@media(min-width:768px) and (max-width:992px){\r\n  .btn6 {  \r\n    width: 205px;\r\n}\r\n.Enquiry-form-div .btn4 {\r\n  width: 145px;\r\n}\r\n.Dowbtn {\r\n  margin-left: 15px;\r\n}\r\n.Enquiry-form-div textarea {\r\n\r\n  height: 158px;\r\n}\r\n.Enquiry-form-div label {  \r\n  margin-top: 15px;\r\n}\r\n}\r\n\r\n@media(max-width:767px){\r\n  .Enquiry-img {\r\n    /* height: 100%; */\r\n    // object-fit: cover;\r\n    // // height: 500px;\r\n    // width: 100%;\r\n    display: none;\r\n}\r\n.Enquiry-img1{\r\n  display: block;\r\n}\r\n}\r\n@media(max-width:580px){\r\n  .Enq-Btns{\r\n    display: block!important;\r\n  }\r\n  .sendbtn{\r\n    text-align: center;\r\n  }\r\n  .Dowbtn {\r\n    text-align: center;\r\n    margin-left: 0;\r\n    margin-top: 20px;\r\n  }\r\n  }\r\n\r\n\r\n.Clientele{\r\n  margin-top: 50px;\r\n}\r\n.ProductsList-image-col a{\r\n  text-decoration: none;\r\n}\r\n.our-pro a{\r\n  text-decoration: none;\r\n}\r\n  // .clients{\r\n  //   margin-top: 70px;\r\n  // }\r\n  // .clients-list{\r\n  //   margin: 30px 0px;\r\n  //   // border-bottom: #002B85 2px solid;\r\n  // }\r\n  .clients-list:last-child{\r\n    \r\n    border-bottom: none;\r\n  }\r\n  .clients-div{\r\n    margin: 30px 0px;\r\n    // border-right: #002B85 2px solid;\r\n  }\r\n  .clients-div:nth-child(4n) .clients-div-logo{\r\n    border-right: none!important;\r\n  }\r\n  .clients-div:last-child{\r\n  \r\n    border-right: none;\r\n  }\r\n\r\n  .clients-div-logo{\r\n    margin: 15px;\r\n  }\r\n  .clients-div-logo-img{\r\n    width: 100%;\r\n    padding-right: 40px;\r\n  }\r\n  @media(max-width:767px){\r\n    .clients-div:nth-child(2){\r\n      \r\n      border-right:none;\r\n    }\r\n  }\r\n  @media(max-width:576px){\r\n    .clients-div{\r\n      margin: 0px 0px;\r\n      border-right:none;\r\n      // border-bottom: #002B85 2px solid;\r\n    }\r\n    .clients-list{\r\n      margin: 0px 0px;\r\n      border-bottom: none;\r\n    }\r\n    .clients-div-logo{\r\n      border-bottom: #002B85 2px solid;\r\n    }\r\n  }\r\n\r\n\r\n\r\n\r\n  .btn7 {\r\n    position: relative;\r\n    display: block;\r\n    width: 200px;\r\n    height: 50px;\r\n    color:white!important;\r\n    background: transparent;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-decoration: none;\r\n    border: 2px solid #FFFFFF!important; \r\n    z-index: 20;\r\n    transition: all 0.35s cubic-bezier(1, 0, 0, 1);\r\n  }\r\n  \r\n  .btn7:hover {\r\n    color: #fcfcfc;\r\n    border: none!important;\r\n  }\r\n  \r\n  .btn7-color {\r\n    \r\n    border-color: #ffffff;\r\n    color: #FFFFFF;\r\n  }\r\n\r\n\r\n  .btn7-color::before, .btn7-color::after {\r\n    border-radius: 10px;\r\n    border-color: #00A1ED!important;\r\n\r\n    border: none!important;\r\n    \r\n    background: #00A1ED;\r\n  }\r\n  \r\n  .btn7::before,\r\n  .btn7::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    z-index: -1;\r\n    transition: all 0.35s cubic-bezier(1, 0, 0, 1);\r\n  }\r\n  \r\n  .btn7-l-r::after {\r\n    height: 100%;\r\n    width: 0;\r\n    top: 0;\r\n  }\r\n  \r\n  .btn7-l-r:hover::after {\r\n    width: 100%;\r\n  }\r\n  \r\n  .btn7-l-r::after {\r\n    left: 0;\r\n  }\r\n\r\n\r\n\r\n  #canv{\r\n    width: 140px!important;\r\n    \r\n    // font-family: 'Montserrat', sans-serif!important;\r\n  }\r\n\r\n\r\n/*** Modified On: 16/11/2022 ***/\r\n.footer-top .logo {\r\n  width: auto;\r\n}\r\n@media(max-width: 1199px) {\r\n  .tail-row {\r\n    .col-md-7,\r\n    .col-md-5 {\r\n      width: 100%;\r\n    }\r\n  }\r\n  .footer-text {\r\n    display: flex;\r\n    align-items: center;\r\n    @media(max-width:480px){\r\n      text-align: center;\r\n      display: grid;\r\n      float: inherit!important;\r\n    }\r\n  }\r\n \r\n}\r\n@media(max-width: 991px) {\r\n  .MainNews-news-con-news {\r\n    margin-left: 25px;\r\n  }\r\n  .MainNews-news-con-news-title, .MainNews-news-con-news-det {\r\n    padding-right: calc(var(--bs-gutter-x) * 0.5) ! important;\r\n  }\r\n  .SubNews-con-det {\r\n    margin-left: 0;\r\n    padding-top: 15px;\r\n    padding-bottom: 30px;\r\n    padding-right: calc(var(--bs-gutter-x) * 0.5) ! important;\r\n    padding-left: calc(var(--bs-gutter-x) * 0.5) ! important;\r\n  }\r\n  .SubNews-con-title, .SubNews-con-desc {\r\n    margin-right: 0px;\r\n  }\r\n  .productslide-img {\r\n    width: 100%;\r\n    height: 400px;\r\n  }\r\n}\r\n@media(max-width: 767px) {\r\n  .navbar {\r\n    padding: 10px ! important;\r\n  }\r\n  .header-container {\r\n    padding-left: 0px !important;\r\n    padding-right: 0px !important;\r\n  }\r\n  .Header-logo {\r\n    margin-left: 0px;\r\n  }\r\n  .intro .txt1 {\r\n    font-size: 17px;\r\n  }\r\n  .nav-product {\r\n    height: auto;\r\n    padding: 5px 10px;\r\n    a {\r\n      font-size: 14px;\r\n    }\r\n  }\r\n  .menu1 {\r\n    padding-right: 7px;\r\n    margin-top: 0px;\r\n    svg {\r\n      width: 18px;\r\n    }\r\n  }\r\n  .navbar-toggler {\r\n    padding: 0.15rem 0.5rem;\r\n    font-size: 1rem;\r\n  }\r\n  .navbar-nav .pro  {\r\n    padding: 10px 0px ! important;\r\n  }\r\n  .navbar-nav .pro p {\r\n    padding-bottom: 0.5rem !important;\r\n    margin-bottom: 0.5rem !important;\r\n    border-bottom: 0px solid #dee2e6 !important;\r\n    @media (max-width: 480px) {\r\n      width: 91%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    background: #002B85;\r\n    border-radius: 4%;\r\n    }\r\n  }\r\n  .about-us {\r\n    padding-top: 40px;\r\n    margin-top: 0px;\r\n  }\r\n  .slick-slider .slick-dots {\r\n    bottom: 0px;\r\n    top: 50%;\r\n  }\r\n  .intro {\r\n    top: auto !important;\r\n    margin-left: 30px;\r\n    bottom: 22%;\r\n    a {\r\n      padding-top: 0rem !important;\r\n    }\r\n  }\r\n  .about-us .banner-txt {\r\n    margin-top: 15px;\r\n  }\r\n  .txt2.mt-4 {\r\n    margin-top: 0.5rem !important;\r\n    line-height: 25px;\r\n  }\r\n  .px-5, .aboutimg-div {\r\n    padding-right: 15px !important;\r\n    padding-left: 15px !important;\r\n  }\r\n  .txt3.mt-4, .btn2-color {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n  .mob-mt-2 {\r\n    margin-top: 35px!important;\r\n    padding-bottom: 35px ! important;\r\n    .data1.mt-5 {\r\n      margin-top: 1rem !important;\r\n    }\r\n  }\r\n  .banner-txt-Dev {\r\n    width: 50%;\r\n    height: 0px;\r\n  }\r\n  .development-support {\r\n    margin: 30px 0;\r\n  }\r\n  .btn2.btn2-color {\r\n    width: 165px;\r\n    height: 40px;\r\n    font-size: 15px;\r\n  }\r\n  .development-support .p-5, .Our_Ser .p-5 {\r\n    padding: 1rem !important;\r\n  }\r\n  .txt2 {\r\n    font-size: 17px;\r\n    margin-bottom: 10px;\r\n  }\r\n  .txt6 {\r\n    padding-left: 50px;\r\n    font-size: 16px;\r\n  }\r\n  .Our_Ser {\r\n    padding-left: 0px;\r\n  }\r\n  .Ser_slid img {\r\n    height: auto;\r\n    padding-top: 0px;\r\n    width: auto ! important;\r\n  }\r\n  .py-5.our-Ser-title {\r\n    padding-top: 1rem !important;\r\n    padding-bottom: 2rem !important;\r\n    .offset-3 {\r\n      margin-left: 0;\r\n      padding: 0 15px ! important;\r\n    }\r\n  }\r\n  .banner-txt-Ser  {\r\n    padding-top: 10px;\r\n  }\r\n  .our-products {\r\n    margin-left: 0px;\r\n    .txt2 {\r\n      padding-left: calc(var(--bs-gutter-x) * 0.5) ! important;\r\n      margin-top: 0.5rem !important;\r\n      line-height: 25px;\r\n    }\r\n    .mt-5 {\r\n      margin-top: 1rem !important;\r\n    }\r\n    .mt-3 {\r\n      margin-top: 0rem !important;\r\n    }\r\n    .center.mt-5 {\r\n      margin-top: 0rem !important;\r\n    }\r\n    .txt3  {\r\n      padding: 0 15px ! important;\r\n    }\r\n    .our-pro {\r\n      padding-right: calc(var(--bs-gutter-x) * .5) ! important;\r\n      padding-left: calc(var(--bs-gutter-x) * .5) ! important;\r\n    }\r\n    .our-pro-con {\r\n      padding: 10px 5px ! important;\r\n      font-size: 15px;\r\n    }\r\n    \r\n  }\r\n  .latest_news {\r\n    margin-left: 0%;\r\n    .btn2-color.btn2-l-r {\r\n      margin-top: -20px ! important;\r\n    }\r\n    .mt-5 {\r\n      margin-top: 1rem !important;\r\n    }\r\n    .news-img {\r\n      padding: 10px !important;\r\n      margin: 0rem !important;\r\n      width: 100%;\r\n      height: auto;\r\n    }\r\n  }\r\n  .contact-us.mt-5 {\r\n    margin-top: 1rem !important;\r\n    .banner-txt-contact {\r\n      margin-left: 25px;\r\n    }\r\n    .m-5 {\r\n      margin: 1rem !important;\r\n    }\r\n    .txt11 {\r\n      font-size: 17px;\r\n      margin-bottom: 10px;\r\n    }\r\n    .txt12 {\r\n      font-size: 15px;\r\n      padding-top: 2px ! important;\r\n    }\r\n    .btn7 {\r\n      margin-top: 0.5rem !important;\r\n    } \r\n    .contact-us-bg img {\r\n      max-width: 100%;\r\n      margin-top: 10%;\r\n    }\r\n  }\r\n  .footer-top .container {\r\n    padding-top: 35px;\r\n    padding-bottom: 30px;\r\n    .foot-logo {\r\n      padding: 0 15px ! important;\r\n      margin-left: 0px;\r\n      margin-bottom: 10px;\r\n      p {\r\n        margin-bottom: 10px;\r\n      }\r\n    }\r\n    .list {\r\n      padding-top: 5px;\r\n    }\r\n  }\r\n  .footer-bottom {\r\n    .footer-img {\r\n      margin-left: 0px;\r\n    }\r\n  }\r\n  .Def-banner {\r\n    margin-top: 0;\r\n    .Def-banner-text {\r\n      font-size: 20px;\r\n      font-weight: bold;\r\n    }\r\n  }\r\n  .Def-banner-image {\r\n    height: 250px;\r\n  }\r\n  .since-row-p5 {\r\n    padding-right: calc(var(--bs-gutter-x) * .5);\r\n    padding-left: calc(var(--bs-gutter-x) * .5);\r\n    .since-top-link-text {\r\n      margin: 10px 0px;\r\n      .since-top-links {\r\n        margin: 10px 0px;\r\n      }\r\n    }\r\n  }\r\n  .since-con {\r\n    margin-top: 40px;\r\n    .since-img {\r\n      padding-right: calc(var(--bs-gutter-x) * .5) ! important;\r\n      padding-left: calc(var(--bs-gutter-x) * .5) ! important;\r\n    }\r\n  }\r\n  .since-title  {\r\n    margin-top: 1.5rem !important;\r\n    line-height: 25px;\r\n    font-size: 17px;\r\n    margin-bottom: 10px;\r\n    padding: 0px;\r\n  }\r\n  .since-desc {\r\n    padding-left: 0px;\r\n    margin-top: 10px;\r\n  }\r\n  .CompanyProfile-img, .QualityAssurance, .WordsfromtheCEO, .CustomManufacturing, .TurnkeyProjects, .GalleryImages, .MainNews, .ProductSliderContent-title, .Materials {\r\n    margin-top: 40px;\r\n  }\r\n  .CompanyProfile-con {\r\n    padding-top: 1.5rem !important;\r\n    padding-top: 1.5rem !important;\r\n    padding-right: calc(var(--bs-gutter-x) * .5);\r\n    padding-left: calc(var(--bs-gutter-x) * .5);\r\n  }\r\n  .CompanyProfile-img-overly, .MainNews .p-0, .SubNews-col, .ProductSliderContent-col1, .ProductSliderContent-col2 {\r\n    padding-right: calc(var(--bs-gutter-x) * .5) ! important;\r\n    padding-left: calc(var(--bs-gutter-x) * .5) ! important;\r\n  }\r\n  .CompanyProfile-img-overly:before {\r\n    left: 10px;\r\n    width: 96%;\r\n    border-radius: 5px;\r\n    margin-top: 40px;\r\n  }\r\n  .Com-Profile-con {\r\n    padding-top: 40px;\r\n    padding-bottom: 40px;\r\n  }\r\n  .profile-txt  {\r\n    margin-bottom: 0px;\r\n    margin-left: 30px;\r\n    font-size: 18px;\r\n  }\r\n  .QualityAssurance-con {\r\n    padding-right: calc(var(--bs-gutter-x) * .5);\r\n    padding-left: calc(var(--bs-gutter-x) * .5);\r\n    margin-left: 0px;\r\n    margin-top: 1.5rem !important;\r\n  }\r\n  .TrinityHoldingsSubsidiaries-con, .TrinityHoldingsSubsidiaries, .ConsultingDesign {\r\n    margin-top: 10px;\r\n  }\r\n  .WordsfromtheCEO-con-det {\r\n    padding-right: calc(var(--bs-gutter-x) * .5);\r\n    padding-left: calc(var(--bs-gutter-x) * .5);\r\n    .WordsfromtheCEO-con {\r\n      margin-left: 0px;\r\n      .txt14 {\r\n        font-size: 17px;\r\n      }\r\n    }\r\n  }\r\n  .OurTeam-about {\r\n    margin: 10px 0px;\r\n    .txt16 {\r\n      font-size: 24px;\r\n      margin-bottom: 0px;\r\n    }\r\n    .OurTeam-about-img img {\r\n      width: 100%;\r\n      height: auto;\r\n    }\r\n    .OurTeam-about-con-det {\r\n      padding: 15px;\r\n    }\r\n  }\r\n  .OurClients-con {\r\n    padding: 40px 15px 0;\r\n    .txt11 {\r\n      font-size: 24px;\r\n    }\r\n    .OurClients-div {\r\n      margin-bottom: 50px;\r\n      .m-5 {\r\n        margin: 0rem !important;\r\n      }\r\n    } \r\n    .OurClients-logo, .Clientslogo {\r\n      padding: 0 ! important;\r\n      margin: 0;\r\n    }\r\n    .OurClients-logo:nth-child(7) {\r\n      border-bottom: #002B85 solid 0px !important;\r\n    }\r\n  }\r\n  .Solutions-banner-image {\r\n    height: 300px;\r\n    margin-top: 0;\r\n  }\r\n  .Solutions-banner-text {\r\n    bottom: 5%;\r\n    .Solutions-banner-text-title {\r\n      font-size: 17px;\r\n      font-weight: bold;\r\n    }\r\n    .Solutions-banner-text-sub {\r\n      font-size: 18px;\r\n    }\r\n  }\r\n  .Solutions-content {\r\n    margin: 0 15px;\r\n  }\r\n  .CustomManufacturing-txt {\r\n    margin-top: 10px;\r\n    padding-right: 0px;\r\n  }\r\n  .CustomManufacturing-title {\r\n    margin-top: 0.5rem !important;\r\n    line-height: 25px;\r\n  }\r\n  .Hire {\r\n    margin-top: 0px;\r\n    .Hire-title {\r\n      margin-top: 0.5rem !important;\r\n      line-height: 25px;\r\n    }\r\n    .Hire-image-con {\r\n      padding: 0;\r\n    }\r\n  }\r\n  .TurnkeyProjects-con {\r\n    margin-top: 10px;\r\n    .TurnkeyProjects-title {\r\n      margin-top: 0.5rem !important;\r\n      line-height: 25px;\r\n    }\r\n  }\r\n  .DewateringTechniques {\r\n    margin-top: 40px;\r\n    margin-bottom: 40px;\r\n    .DewateringTechniques-txt {\r\n      margin-top: 10px;\r\n    }\r\n    .ConsultingDesign-title {\r\n      margin-top: 0.5rem !important;\r\n      line-height: 25px;\r\n    }\r\n  }\r\n  .GalleryBtn {\r\n    margin-top: 25px;\r\n    margin-bottom: 50px;\r\n  }\r\n  .contact {\r\n    margin-top: 40px;\r\n    margin-bottom: 40px;\r\n  }\r\n  .GetinTouch-data {\r\n    margin-left: 0px;\r\n    margin-top: 20px;\r\n  }\r\n  .GetinTouch-data-Title, .Connectwithus-data-Title, .MainNews-news-con-news-title, .SubNews-con-title  {\r\n    margin-top: 0.5rem !important;\r\n    line-height: 25px;\r\n    font-size: 17px;\r\n    margin-bottom: 10px;\r\n  }\r\n  .GetinTouch-data-txt {\r\n    font-size: 16px;\r\n    color: #FFFFFF;\r\n  }\r\n  .GetinTouch-data-info {\r\n    margin-top: 25px;\r\n  }\r\n  .Connectwithus-data {\r\n    margin-top: 30px;\r\n    input {\r\n      height: 35px;\r\n      margin-top: 5px;\r\n    }\r\n    .contactsub {\r\n      width: 160px;\r\n      height: 45px;\r\n    }\r\n  }\r\n  .News2, .MainNews-div {\r\n    margin-top: 20px;\r\n    padding-right: 0;\r\n  }\r\n  .MainNews {\r\n    .txt2 {\r\n      font-size: 19px;\r\n    }\r\n    .txt8 {\r\n      font-size: 15px;\r\n      line-height: 28px;\r\n    }\r\n    .txt22 {\r\n      font-size: 15px;\r\n    }\r\n  }\r\n  .MainNews-title {\r\n    margin: 20px 20px;\r\n    margin-top: 20px !important;\r\n    font-size: 19px;\r\n  }\r\n  .MainNews-news {\r\n    margin-top: 15px;\r\n  }\r\n  .MainNews-news-con-news {\r\n    margin-left: 0px;\r\n    margin-top: 10px;\r\n    padding-bottom: 50px !important;\r\n    .MainNews-news-con-news-title, .MainNews-news-con-news-det {\r\n      padding-right: 0px;\r\n    }\r\n  }\r\n  .MainNews-sub-div {\r\n    margin-bottom: 20px;\r\n    span.txt20 {\r\n      line-height: 50px;\r\n    }\r\n  }\r\n  .SubNews {\r\n    margin-top: 10px;\r\n    .SubNews-img {\r\n      height: auto;\r\n    }\r\n    .pagination {\r\n      padding-right: 0;\r\n    }\r\n  }\r\n  .SubNews-con-det {\r\n    margin-left: 0px;\r\n    padding-top: 0px;\r\n    padding-bottom: 30px;\r\n    .SubNews-con-title {\r\n      margin-right: 0px;\r\n    }\r\n  }\r\n  .feature img {\r\n    width: auto;\r\n    height: auto !important;\r\n  }\r\n}\r\n@media (max-width: 580px) {\r\n  .MaterialsandApplications-col {\r\n    flex-direction: column;\r\n  }\r\n  .ProductSliderContent {\r\n    margin: unset;\r\n    margin-top: 100px;\r\n  }\r\n  .MaterialsandApplications {\r\n    margin: 0px 15px;\r\n  }\r\n  .MaterialsandApplications-title {\r\n    margin: 20px 0px;\r\n    margin-top: 0px !important;\r\n    padding: 10px 10px;\r\n    margin-right: 0px;\r\n    margin-top: 0.5rem !important;\r\n    line-height: 25px;\r\n    font-size: 17px;\r\n    margin-bottom: 10px;\r\n  }\r\n  .MaterialsandApplications-sub-div {\r\n    margin-right: 0px;\r\n    RelatedProducts-sub {\r\n      margin: 10px 15px;\r\n    }\r\n  }\r\n}\r\n@media (max-width: 520px) {\r\n  .tail ul li {\r\n    padding: 0;\r\n    width: 25%;\r\n  }\r\n  .tail-row-logo {\r\n    display: flex !important;\r\n    flex-direction: column;\r\n  }\r\n  .footer-text {\r\n    margin-bottom: 1rem;\r\n  }\r\n  .CompanyProfile-img-overly:before {\r\n    width: 95%;\r\n  }\r\n  .profile-icon {\r\n    width: 65px;\r\n    height: 65px;\r\n  }\r\n  .since-row-p5 .since-top-link-text .since-top-links {\r\n    margin: 5px 0px;\r\n    a {\r\n      font-size: 14px;\r\n    }\r\n  }\r\n  .Solutions-banner-text .Solutions-banner-text-sub {\r\n    font-size: 14px;\r\n  }\r\n  .productslide-img {\r\n    width: 100%;\r\n    height: 250px;\r\n    object-fit: contain;\r\n  }\r\n}\r\n@media (max-width: 370px) {\r\n  .banner-title {\r\n    margin-left: 10px;\r\n  }\r\n  .our-products img {\r\n    width: 100% !important;\r\n    height: 130px ! important;\r\n  }\r\n  .tail ul li {\r\n    width: 33.333%;\r\n  }\r\n  .CompanyProfile-img-overly:before {\r\n    width: 94%;\r\n  }\r\n  .profile-icon {\r\n    width: auto;\r\n    height: auto;\r\n  }\r\n  .company-profile .p-4 {\r\n    padding: 1rem 0.5rem !important;\r\n  }\r\n  .banner-txt-Dev {\r\n    width: 58%;\r\n  }\r\n  .Solutions-banner-text .Solutions-banner-text-title {\r\n    margin-bottom: 10px !important;\r\n  }\r\n}\r\n@media (max-width: 300px) {\r\n  .tail ul li {\r\n    width: 50%;\r\n  }\r\n  .CompanyProfile-img-overly:before {\r\n    width: 92%;\r\n  }\r\n  .Solutions-banner-text {\r\n    bottom: 0%;\r\n  }\r\n}\r\n.design{\r\n    background-color: #d4d4d4;\r\n    padding: 12px 0;\r\n}\r\n.footer-text{\r\n  color: #002B85;\r\n  float: right;\r\n  margin-bottom: 0;\r\n}\r\n.footer-text2{\r\n  color: #002B85;\r\n}\r\n.des p{\r\ncolor: #002B85;\r\nmargin-bottom: 0;\r\n}\r\n.des p a{\r\n  font-weight: bold;\r\n  color: #002B85;\r\n  text-decoration: none;\r\n  }\r\n  .imgs{\r\n      border-radius: 20px;\r\n  }\r\n.footer-top .logo{\r\n      margin-left: -15px;\r\n}\r\n.tree{\r\n overflow-y:scroll;\r\n}\r\n.tree, .tree ul, .tree li {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  position: relative;\r\n}\r\n\r\n.tree {\r\n  margin: 0 0 1em;\r\n  text-align: center;\r\n}\r\n.tree, .tree ul {\r\n  display: table;\r\n}\r\n.tree ul {\r\nwidth: 100%;\r\n}\r\n  .tree li {\r\n      display: table-cell;\r\n      padding: .5em 0;\r\n      vertical-align: top;\r\n  }\r\n      /* _________ */\r\n      .tree li:before {\r\n          outline: solid 1px #666;\r\n          content: \"\";\r\n          left: 0;\r\n          position: absolute;\r\n          right: 0;\r\n          top: 0;\r\n      }\r\n      .tree li:first-child:before {left: 50%;}\r\n      .tree li:last-child:before {right: 50%;}\r\n\r\n      .tree code, .tree span {\r\n          border: solid .1em #002B85;\r\n          background: #002B85;\r\n          color: white;\r\n          width: 160px;\r\n          border-radius: 4px;\r\n          display: inline-block;\r\n          font-size: 14px;\r\n          margin: 0 .3em .9em;\r\n          padding: .4em .5em;\r\n          position: relative;\r\n          box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px;\r\n      }\r\n      .tree code, .tree span:hover{\r\n        background: #f28300;\r\n        border: solid .1em #f28300;\r\n\r\n      }\r\n      /* If the tree represents DOM structure */\r\n      .tree code {\r\n          font-family: monaco, Consolas, 'Lucida Console', monospace;\r\n      }\r\n\r\n          /* | */\r\n          .tree ul:before,\r\n          .tree code:before,\r\n          .tree span:before {\r\n              outline: solid 1px #666;\r\n              content: \"\";\r\n              height: .5em;\r\n              left: 50%;\r\n              position: absolute;\r\n          }\r\n          .tree ul:before {\r\n              top: -.5em;\r\n          }\r\n          .tree code:before,\r\n          .tree span:before {\r\n              top: -.55em;\r\n          }\r\n\r\n/* The root node doesn't connect upwards */\r\n.tree > li {margin-top: 0;}\r\n  .tree > li:before,\r\n  .tree > li:after,\r\n  .tree > li > code:before,\r\n  .tree > li > span:before {\r\n    outline: none;\r\n  }\r\n  .tree .head{\r\n    background: #f28300;\r\n    border: solid .1em #f28300;\r\n  }\r\n  .slick-current .productslide-img.pop{\r\n    position: fixed!important;\r\n   width: 100%!important;\r\n   margin: 0!important;\r\n   height: 100%!important;\r\n   z-index: 99999999999999!important;\r\n  }\r\n.attributed-text-segment-list__content{\r\n  line-height: 1.5em!important;\r\n  height: 3em!important;       \r\n  overflow: hidden!important; \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
